export default {
  // 快速模式 5 问交互卡片文案（Epixora 快速调研）
  materialAnswer: {
    badge: '材料回答',
    analyzedFiles: '已分析 {files}',
    noRelevantContent: '材料中未找到查询相关内容',
    partialCoverage: '基于材料可回答部分问题，但获取的数据有限',
    noneHint: '您的问题在所选材料中没有依据。可尝试：调整表述使其更贴近材料、补充更多相关文件，或使用下方「生成主题简报」「深度调研」检索外部文献。',
    partialHint: '以下回答仅基于已上传材料。如需更全面信息，可使用下方扩展入口。',
    fullHint: '以下回答基于已上传材料。如需扩展调研范围，可继续生成主题简报或深度调研。',
    disclaimer: '回答仅基于所选材料，未检索外部文献',
    saveToMap: '保存到知识地图',
    export: '导出',
    exportMarkdown: 'Markdown',
    exportWord: 'Word',
    exportPdf: 'PDF',
    exportHtml: 'HTML',
    noExportContent: '暂无可导出的内容',
    exportSuccess: '已导出{format}',
    exportFailed: '导出失败，请重试',
    startBrief: '生成主题简报',
    deepResearch: '深度调研',
    deepResearchConfirmTitle: '确认调研主题',
    deepResearchConfirmTip: '请确认并修改以下主题。确认后将进入专家模式并开始深度调研。',
    deepResearchOriginalQuestion: '您的问题：',
    deepResearchTopicLabel: '调研主题',
    deepResearchTopicPlaceholder: '请输入调研主题',
    deepResearchConfirmContinue: '确认并继续',
    deepResearchTopicRequired: '请先确认调研主题',
    preparingContent: '上传数据正在解析和准备中',
    preparingHint: '文件解析完成后，请重新提问；系统会基于文件内容回答您的问题。',
    filesParsing: '上传文件正在解析和准备中，请稍候…',
    filesParseTimeout: '文件仍在解析中，请稍后再提问。',
    parseFailedFiles: '以下文件解析失败：{files}，请重新上传后再提问',
    parseFailedStatus: '文件解析失败，请重新上传或使用 OCR 后的 PDF',
    parseReadyStatus: '文件解析完成，材料已准备好，可以重新提问',
    uploadedMaterialFallback: '上传材料',
    materialSnippetTitle: '上传材料检索片段 #{id}',
    snippetInlineTag: '检索片段{id}',
  },
  quickCard: {
    planCardTitle: '结构化调研问题（可编辑，至少保留 3 项）',
    questionPlanIntro: '围绕“{topic}”，我已准备以下几个方向来为您解答该问题。',
    planCardLocked: '已开始调研',
    title: '围绕「{topic}」准备的 {count} 个调研问题',
    defaultTopic: '该主题',
    summary: '当前 {count} 个问题（至少 {min} 个，最多 {max} 个）',
    addQuestion: '新增问题',
    changePerspective: '换个角度',
    startResearch: '开始调研',
    editTitle: '编辑',
    deleteTitle: '删除',
    questionPlaceholder: '请输入调研问题',
    emptyQuestion: '问题内容不能为空',
    tooLong: '单个问题不能超过 200 字',
    minQuestions: '简报至少需要 {min} 个问题',
    maxQuestions: '最多保留 {max} 个问题，可先删除不需要的问题',
    saveEditingFirst: '请先保存正在编辑的问题',
    saveDraftFailed: '大纲自动保存失败，请稍后重试',
    startBlockedByFailedFiles: '存在 {count} 个解析失败文件（{files}），请先重试解析或移除后再开始简报',
    startWithPendingFilesTitle: '文件仍在解析',
    startWithPendingFilesConfirm: '检测到 {count} 个文件仍在解析中，继续生成简报可能导致内容不完整。是否继续？',
    startWithPendingFilesContinue: '继续生成',
    startWithPendingFilesCancel: '等待解析完成',
    deleteConfirmTitle: '删除确认',
    deleteConfirmMessage: '确定删除这个调研问题吗？',
    deleteConfirmOk: '删除',
    defaultDimension: '自定义问题',
    intentConfirmHint: '您想针对「{topic}」快速生成一份简报吗？',
    intentYes: '是',
    intentNo: '否',
    entitySuggestTypo: '未在标准基因库中找到「{original}」。您是否指「{suggested}」{chinese}？',
    entitySuggestNotFound: '未在标准基因/靶点库中找到「{original}」，继续调研可能难以获得准确结果。',
    entityAccept: '使用建议',
    entityKeep: '仍用原文',
    protocolStartResearchWithTopic: '开始调研：{topic}',
    protocolRegenerateBriefWithTopic: '重新生成简报：{topic}',
  },
  expertCard: {
    boundaryTip: '您是想针对靶点{target}进行靶点调研，还是针对{focus}进行整体深度调研？',
    boundaryTarget: '靶点调研',
    boundaryOverall: '整体调研',
    moduleIntro: '请勾选需要纳入本次调研的模块（围绕「{topic}」）：',
    defaultTopic: '该主题',
    addRoot: '添加',
    addChild: '添加子项',
    customModule: '自定义模块',
    customContent: '自定义内容',
    confirmModules: '开始调研',
    deselectAll: '全不选',
    selectionCount: '已选 {checked} / {total} 项',
    changePerspective: '换个角度',
    changePerspectiveText: '换个角度',
    outlineUnchanged: '本轮大纲未检测到变化，请换种说法或直接在面板中编辑后重试。',
    revisionFailed: '大纲修订未能满足要求，请调整指令后重试。',
    minModules: '请至少勾选一个模块',
    outlineIntro: '请确认或编辑以下报告大纲：',
    startResearch: '开始调研',
    reportStartUnavailable: '无法发起报告生成，请刷新页面后重试',
    profileNotReady: '请先在对话中确认调研类型（靶点调研 / 整体调研），再开始生成报告',
  },
  common: {
    example: '示例',
    semicolon: '；',
    switchTenant: '切换租户',
    language: '语言',
    chinese: '简体中文',
    english: 'English',
    ok: '确定',
    cancel: '取消',
    save: '保存',
    done: '完成',
    back: '返回',
    refresh: '刷新',
    search: '搜索',
    clearFilters: '清空筛选',
    delete: '删除',
    loadMore: '加载更多',
    confirm: '确定',
    close: '关闭',
    profile: '个人信息',
    account: '账户信息',
    retry: '点击重试',
    please: '请',
    minuteShort: '分',
    secondShort: '秒',
    durationPrefix: '用时',
    loading: '加载中...',
    loadingUserData: '正在加载用户数据...',
    preparing: '正在准备，请稍候...',
    logout: '退出登录',
    confirmTitle: '提示',
    logoutConfirm: '确定要退出登录吗？',
    unknownError: '未知错误',
    mermaidRenderFailed: '图表渲染失败',
    operationFailed: '操作失败',
    operationConfirm: '操作确认',
    unknown: '未知',
    operation: '操作',
    edit: '编辑',
    confirmDelete: '确认删除',
    confirmExecute: '确认执行此操作?',
    featureInDevelopment: '功能开发中',
    contactSupport: "请联系客服：400-123-4567 或发送邮件至 enterprise{'@'}example.com",
    balanceCheckFailed: '余额检查失败，请稍后重试',
    feedback: '用户反馈',
    newChat: '新建会话',
    knowledgeBase: '知识库',
    manual: '使用手册',
    noPermission: '无权限访问',
    copyright: 'Copyright © 2025 XtalPi Inc. 粤ICP备17120953号-4',
    downloadStarted: '下载已开始',
    downloadFailed: '下载失败',
    browserNotSupportVideo: '您的浏览器不支持视频播放',
    browserNotSupportAudio: '您的浏览器不支持音频播放',
    downloadFile: '下载文件',
    directDownload: '直接下载',
    loadingPreview: '正在加载预览...',
    previewFailed: '预览失败',
    errorDetails: '错误详情',
    openInNewWindow: '新窗口打开',
    pages: '页',
    // 通用评分文本
    veryPoor: '很差',
    poor: '较差', 
    average: '一般',
    good: '较好',
    excellent: '很好',
    history: '历史记录',
    chooseFile: '选择文件',
    notificationCenter: '通知中心',
    warning: '警告',
    unnamedFile: '未命名文件',
    selectAll: '全选',
  },
  writeWizard: {
    outlineSelect: '大纲选择',
    outlineSource: {
      upload: '上传大纲',
      template: '选择模板',
      quick: '快速开始'
    },
    outlineUploadBtn: '选择大纲文件',
    outlineUploadHint: '支持 Word、TXT、Markdown、PDF',
    outlineTemplatePlaceholder: '选择模版',
    outlineError: '请选择或上传大纲',
    requirementsPlaceholder: '你可以描述关于：\n-文章篇幅（文章长短、字数、章节数量）\n-撰写风格（例如：严谨、活泼、学术等）\n-附件文件使用方式\n-需要避免的表述和内容\n-文档使用场景（例如：工作汇报、学术答辩等）\n等方面的任何指令！',
    requirementsError: '请填写撰写需求',
    userSummary: '撰写需求',
    outlineLabel: '大纲',
    outlineDraftLabel: '大纲内容',
    outlineDraftTitle: '大纲内容',
    outlineDraftTemplateHint: '已从模板带入，可继续编辑',
    outlineDraftUploadHint: 'TXT / Markdown 会自动读取，Word / PDF 可手动补充',
    outlineDraftQuickHint: '可选，留空时系统自动推荐结构',
    outlineDraftPlaceholder: '可在这里调整模板大纲，例如章节标题、层级、写作重点等',
    outlineDraftUploadPlaceholder: '如文件内容未自动读取，可在这里粘贴或补充大纲',
    outlineReviewTitle: '确认撰写大纲',
    outlineReviewDescription: '请最后确认章节结构和写作重点，确认后将按这份大纲生成文稿。',
    confirmOutlineAndGenerate: '确认大纲并生成',
    outlineFromUpload: '来自上传',
    outlineFromTemplate: '来自模版',
    outlineFromQuick: '快速开始（系统推荐结构）',
    modelPrefix: '模型：'
  },
  composer: {
    clearAttachments: '清空',
    selectModel: '选择模型',
    selectTemplate: '选择模版',
    clearTemplate: '清除模版',
    templateLoading: '模版加载中…',
    noTemplates: '暂无可用模版',
    templateDisabledWithFiles: '已选附件时不可使用模版',
    withFilesPlaceholder: '想从已选文件中了解什么？',
    quickTemplateReportPlaceholder: '输入主题，按照大纲模板生成研究报告',
    quickWithOutlinePlaceholder: '输入调研主题，将按所选模版生成问题框架',
    expertWithTemplatePlaceholder: '输入调研主题（已选模版：{name}）',
    expertReportGeneratingHint: '您的调研报告正在生成中，如需完成其他调研任务请开启新对话',
    expertReportReadyHint: '您的“{name}”报告已经生成。您可以针对报告进行：\n- 报告问答\n- 幻觉检测（在预览区域点击幻觉检测或在报告中选中您要检测的语句右键）\n- 内容重构（复制或语言描述您想要重新生成的内容的位置，并提供重构需求）\n- 编辑报告',
    expertReportReadyTitle: '您的“{name}”报告已经生成，右侧为报告预览区。您可以针对报告进行以下操作：',
    expertReportReadyActionQa: '报告问答',
    expertReportReadyActionHallucination: '幻觉检测',
    expertReportReadyActionHallucinationDesc: '（在预览区域点击幻觉检测或在报告中选中您要检测的语句右键）',
    expertReportReadyActionEdit: '编辑报告',
    expertReportAuditRejectedHint: '您的“{name}”报告已生成，但未通过内容审核，暂不可预览或下载。请查看下方报告区的说明，调整调研需求后重新生成，或申请人工复核。',
    expertOutlineReadyHint: '请在上方大纲卡中编辑并点击「开始调研」，确认后将弹出余额提示',
    expertModuleSelectionHint: '请在上方勾选调研模块并点击「开始调研」，确认后将弹出余额提示',
    expertBoundaryHint: '请先选择上方调研范围（靶点调研 / 整体调研）',
    writeReportGeneratingHint: '您的撰写文稿正在生成中，如需完成其他任务请开启新对话',
    reportGeneratingHint: '报告正在生成中，如需完成其他任务请开启新对话',
    reportGeneratingBlocked: '报告生成中，暂不可输入',
    quickQuestionCardHint: '请在上方五问卡片中编辑问题，并点击「开始调研」',
    modelsLoading: '模型加载中…',
    noModelsAvailable: '暂无可选模型',
    aiDisclaimer: '内容由 AI 生成，请仔细甄别'
  },
  quickTools: {
    title: '快速工具',
    templateLibrary: {
      title: '调研模版库',
      subtitle: '管理您的个人调研模版，在调研中更高效地完成主题调研任务',
      searchPlaceholder: '搜索调研模版',
      emptyDesc: '暂无匹配模版',
      modeBatch: '批量调研',
      modeExpert: '专家模式',
      modeQuick: '快速模式',
      newQuickTemplate: '新建快速模式模版'
    },
    batchTemplates: '批量模版',
    outlineTemplates: '大纲模版',
    batchDrawerTitle: '快速工具 · 批量主题调研',
    batch: {
      newTemplate: '新建批量模版',
      myTemplates: '我的模板',
      noTemplates: '暂无模板，请新建批量模版',
      loadTemplateFailed: '加载模板失败',
      questionUnit: '题',
      questionCount: '{count} 题',
      usedCount: '已用 {count} 次',
      edit: '编辑',
      delete: '删除',
      historySection: '历史调研',
      searchHistory: '搜索历史主题',
      noHistoryMatch: '未找到匹配历史',
      noHistory: '暂无调研历史',
      exampleCases: '示例案例 · 点击可创建模板',
      deleteHistory: '删除该历史',
      managerTitle: '模版管理',
      managerSubtitle: '管理快速工具中的批量调研模版',
      managerSubtitleMerged: '管理快速工具中的批量调研模版与大纲模版',
      templateKindAll: '全部',
      templateKindBatch: '批量模版',
      templateKindOutline: '大纲模版',
      sectionBatch: '批量模版',
      sectionOutline: '大纲模版',
      newOutlineTemplate: '新建大纲模版',
      searchTemplateMerged: '搜索模版名称、描述或调研对象',
      totalTemplatesMergedDetail: '共 {total} 个模版（批量 {batch} · 大纲 {outline}）',
      searchTemplate: '搜索模版名称或描述',
      sort: '排序',
      sortByCreated: '按创建时间',
      sortByName: '按名称',
      sortByRecent: '按最近使用',
      gridView: '网格视图',
      listView: '列表视图',
      totalTemplates: '共 {count} 个模版',
      noMatchTemplates: '暂无匹配模版',
      recentUse: '最近使用：{time}',
      runResearch: '运行调研',
      editTemplate: '编辑模板',
      back: '← 返回',
      emptySelectTitle: '选择调研模版',
      emptySelect: '请先选择一个模板，或进入模版管理',
      emptySelectPlaceholder: '请选择调研模版',
      emptySelectAction: '进入调研',
      templateManager: '模版管理',
      noTopics: '(无主题)',
      noDescription: '暂无描述',
      noRecentUse: '暂无',
      unsavedLeaveTitle: '未保存修改',
      unsavedLeaveMessage: '当前模板有未保存修改，离开后这些内容将丢失。是否继续？',
      continueLeave: '继续离开',
      stayOnPage: '留在当前页',
      templateUpdated: '模板已更新',
      templateCreated: '模板已创建',
      saveFailed: '保存失败',
      sampleExists: '已存在同名示例模板，已为你打开',
      deleteTemplateConfirm: '确认删除模版{name}吗？该模版下的历史运行记录将保留，但无法再基于本模版新建调研任务；',
      deleteConfirmTitle: '确认删除',
      deleted: '已删除',
      deleteFailed: '删除失败',
      loadHistoryFailed: '加载历史失败',
      deleteHistoryConfirm: '确认删除该历史记录？删除后不会影响已导出的文件或其他报告。',
      historyDeleted: '已删除',
      exported: '已导出 {format}',
      exportFailed: '导出失败',
      runnerHint: '输入调研主题后点击「开始调研」：系统将按问题列表调用临床试验、专利、FDA、文献与网络检索，整合为可对比的结构化结果。',
      runnerRunningHint: '调研正在运行，请勿关闭页面或切换模板。系统完成后会自动展示结果表格。',
      topicsTitle: '调研主题（最多 10 个）',
      topicPlaceholder: '输入主题后回车，如 HER2',
      addTopic: '+ 添加主题',
      run: '运行',
      topicsAdded: '已添加 {count} / 10',
      chipHint: '点击示例快速添加',
      dataSourcesTitle: '数据采集源',
      dataSourcesHint: '系统会根据每个问题的表述自动选择合适的数据源进行检索',
      questionListTitle: '问题列表（来自模板：{name}）',
      runSingleQuestion: '单独运行该问题',
      runSummary: '将调研 <strong>{topics}</strong> 个主题 × <strong>{questions}</strong> 个问题',
      startResearch: '开始调研（{topics} 主题 × {questions} 题）',
      maxTopics: '最多添加 10 个主题',
      needOneTopic: '请至少添加 1 个主题',
      runFailed: '运行失败，响应异常',
      allQuestionsFailed: '所有问题都失败了，请检查 LLM 配置或网络',
      partialFailed: '部分问题失败：成功 {success}/{total}',
      runComplete: '运行完成（{label}）',
      runFailedGeneric: '运行失败',
      sourceClinical: '临床试验',
      sourcePatent: '专利',
      sourceFda: 'FDA/监管',
      sourceLiterature: '文献 PubMed',
      sourceWeb: '网络检索',
      resultAllSuccess: '全部成功',
      resultPartial: '部分成功',
      resultFailed: '执行失败',
      resultStats: '{total} 题 / 成功 {success} / 耗时 {seconds}s',
      dataSourcesLabel: '数据源：{sources}',
      viewDetail: '分主题详情',
      viewCompare: '问题对比',
      exportCsv: '导出 CSV',
      exportExcel: '导出 Excel',
      citationDetail: '溯源详情',
      citationDocument: '溯源文献',
      citationQuote: '引用语句',
      citationSource: '来源信息',
      citationContext: '上下文',
      citationLinks: '相关资料',
      noCitationForSentence: '当前句子暂无关联溯源。可参考正文结论，并在后续调研中补充更明确的来源要求。',
      noSnippet: '(无摘要)',
      noSourceContext: '未能自动获取原文上下文，请点击下方相关资料访问原站查看。',
      sourcePrefix: '来源：{source}',
      compareByQuestion: '按问题横向对比 {count} 个主题',
      colQuestion: '问题',
      executeFailed: '执行失败',
      searchHits: '{count} 条检索',
      expandAll: '全部展开',
      collapseAll: '全部折叠',
      colQuestionShort: '问题简述',
      colAnswerDetail: '调研结果详情',
      unnamedQuestion: '(未命名问题)',
      retryHint: '可稍后单独重跑该问题，或缩短问题详情后再试。',
      viewCitation: '查看溯源',
      noCitation: '暂无溯源',
      expand: '展开',
      collapse: '折叠',
      copyAnswer: '复制答案',
      citationCount: '溯源({count})',
      noResults: '暂无调研结果',
      noResultsDesc: '运行完成后，结果会按“问题简述 | 调研结果详情”统一展示。',
      nothingToCopy: '暂无可复制内容',
      copiedAnswer: '已复制答案',
      copyFailed: '复制失败，请手动选择文本',
      exampleTag: '示例',
      statusRunning: '运行中',
      statusPartial: '部分成功',
      statusFailed: '失败',
      researchComplete: '调研已完成',
      pollInterrupted: '轮询中断，可在左侧历史记录中继续查看',
      submittingTask: '正在提交调研任务…',
      taskSubmitted: '调研任务已提交（{label}），正在后台运行',
      submitFailed: '提交失败，响应异常',
      submitFailedGeneric: '提交失败',
      topicsOverflow: '… 共 {count} 个',
      fullRunLabel: '全量',
      resultRunningBanner: '调研正在后台运行，可切换页面或查看已完成的部分结果',
      resultProgress: '已完成 {completed} / {total} 题',
      resultElapsed: ' · 已耗时 {seconds}s',
      rowStatusFailed: '失败',
      cancel: '返回',
      citation: '溯源',
      totalQuestions: '共 {count} 题',
      sampleTag: '示例',
      sampleTemplateTag: '示例模板',
      exampleCaseShort: '示例案例',
      listColName: '模版名称',
      listColSource: '模版来源',
      listColDesc: '模版描述',
      listColRecent: '最近使用',
      listColActions: '操作',
      sourceSample: '系统示例',
      sourcePersonal: '个人模板',
      sampleNotEditable: '系统示例模板不可编辑，可直接运行或新建自己的模板',
      sampleNotDeletable: '系统示例模板不可删除，可直接运行或新建自己的模板',
      editor: {
        guide: '创建一组 3-5 个调研问题，系统会按每个主题逐题生成统一表格。点击表格外或保存模板时会自动整理问题顺序。',
        templateName: '模板名称',
        namePlaceholder: '如：靶点调研速览',
        templateDesc: '模板描述',
        descPlaceholder: '简要说明模板用途（可选）',
        questionListTitle: '问题列表（{count} / 5，至少 3 个）',
        addQuestion: '添加问题',
        colTitle: '问题标题',
        colTitleHint: '(≤50字，如“在研药物及阶段”)',
        colDetail: '期望了解的方面',
        colDetailHint: '(≤250字，说明回答维度和字段)',
        titlePlaceholder: '如：在研药物及阶段',
        detailPlaceholder: '如：请列出该靶点全球进入临床阶段的药物名称、最高阶段、企业、适应症和相关里程碑',
        deleteMinTip: '至少保留 3 个问题',
        deleteQuestion: '删除该问题',
        emptyQuestions: '请添加至少 3 个问题',
        tableTip: '建议每个问题只聚焦一个调研角度，详情中写清楚期望字段，例如“药物名称、最高阶段、企业、适应症、里程碑”。',
        saveTemplate: '保存模板',
        previewTitle: '批量调研结果预览示例',
        previewSubtitle: '保存后，多个主题会按统一问题列进行横向对比。',
        previewTopic: '调研主题',
        questionFallback: '问题 {index}',
        previewCellText: '{title}的结构化调研结论将在这里展示',
        nameRequired: '请填写模板名称',
        minQuestions: '请至少保留 3 个问题',
        maxQuestions: '最多添加 5 个问题',
        titleRequired: '第 {index} 个问题的标题不能为空',
        detailRequired: '请填写第 {index} 个问题的期望了解方面'
      },
      samples: [
        {
          name: '靶点调研速览',
          description: '适合 HER2、KRAS G12C 等靶点的快速横向调研',
          questions: [
            { title: '在研药物及阶段', detail: '请列出该靶点全球进入临床阶段的药物名称、最高阶段、企业、适应症和相关里程碑。' },
            { title: '机制与生物学背景', detail: '请简述该靶点的作用机制、相关信号通路及在主要适应症中的生物学依据。' },
            { title: '竞争格局与差异化', detail: '请概述当前主流竞品的优势/不足、潜在 BIC 机会以及差异化路径。' }
          ]
        },
        {
          name: '技术方向对比',
          description: '适合 CAR-T 在实体瘤中的应用等技术主题对比',
          questions: [
            { title: '关键技术路线', detail: '请比较该主题下主要技术路线、核心机制、适用场景和关键技术瓶颈。' },
            { title: '代表性项目与企业', detail: '请列出代表性项目、研发企业或机构、最高研发阶段、适应症和近期里程碑。' },
            { title: '机会与风险', detail: '请总结该方向的临床转化机会、商业化风险、监管挑战和未来 2-3 年关键观察点。' }
          ]
        }
      ]
    },
    library: {
      title: '模版库',
      desc: '管理您的个人调研模板，在调研中更高效地完成主题调研任务',
      descBatch: '管理批量调研模板，快速复用问题集并发起批量任务',
      descExpert: '管理专家模式模板，沉淀可复用的大纲结构与研究框架',
      descQuick: '管理快速模式模板，沉淀高频快研场景并一键复用',
      modeBatch: '批量调研',
      modeExpert: '专家模式',
      modeQuick: '快速模式',
      newBatchTemplate: '新建批量模版',
      newExpertTemplate: '新建专家模版',
      newQuickTemplate: '新建快速模式模版',
      scopeAll: '全部模版',
      scopeMine: '我的模版',
      scopeShared: '共享给我',
      scopeFavorite: '我的收藏',
      totalCount: '共 {count} 个模版',
      searchPlaceholder: '搜索模版名称或描述',
      sortByCreated: '按创建时间',
      sortByName: '按名称',
      sortByRecent: '按最近使用',
      emptyTitle: '暂无匹配的模版',
      emptyDesc: '试着切换模式或关键字，或创建一个新模版',
      loadFailed: '加载模版列表失败',
      favoriteNotSupported: '批量调研模板暂不支持收藏'
    },
    card: {
      tagBatch: '批量调研',
      tagExpert: '专家模式',
      tagQuick: '快速模式',
      ownerOthers: '共享',
      lastUsed: '最近使用：{date}',
      lastUsedNever: '最近使用：暂无',
      usageCount: '已使用 {count} 次',
      btnUse: '使用',
      btnEdit: '编辑',
      btnDelete: '删除',
      btnPreview: '预览'
    },
    dialog: {
      useTitle: '使用模版',
      useEntityLabel: '调研对象名称',
      useEntityPlaceholder: '请输入调研对象名称，如 BRCA1',
      useEntityRequired: '请输入调研对象名称',
      useAdditionalLabel: '补充说明（可选）',
      useAdditionalPlaceholder: '为本次调研补充更多上下文（可选）',
      useConfirm: '确认使用',
      useCancel: '取消',
      useSuccess: '已应用模版，正在跳转调研',
      useFailed: '使用模版失败',
      previewTitle: '模版预览',
      previewClose: '关闭',
      previewEmpty: '该模版暂无可预览内容',
      deleteTitle: '确认删除',
      deleteMsg: '确定删除模版"{name}"吗？该操作不可撤销。',
      deleteConfirm: '删除',
      deleteCancel: '取消',
      deleteSuccess: '已删除',
      deleteFailed: '删除失败'
    }
  },
  // 布局和菜单相关
  layout: {
    appTitle: 'epiXora智能助手',
    refreshMenu: '刷新菜单',
    enterAdminConsole: '进入管理后台',
    backToChat: '返回问答',
    setAdmin: '设为管理员',
    debugMenu: '调试菜单',
    adminDebug: '管理员调试',
    logoutConfirmTitle: '提示',
    logoutConfirmMessage: '确定要退出登录吗？',
    logoutSuccess: '已退出登录',
    getUserInfoFailed: '无法获取用户信息，请重新登录',
    menuRefreshed: '菜单刷新成功',
    menuCacheCleared: '菜单缓存已清除，正在刷新...',
    refreshFailed: '刷新失败，请重新登录',
    menuRefreshFailed: '刷新菜单失败，请重新登录',
    adminStatusSet: '管理员状态已设置',
    setAdminFailed: '设置管理员状态失败',
    menuDebugged: '菜单状态已调试'
  },
  menu: {
    loadFailed: '加载菜单失败，请稍后重试',
    loadFailedWithMessage: '加载菜单失败'
  },
  // 后端返回数据的国际化映射
  backend: {
    // 会员等级名称映射
    membershipTiers: {
      'Pro 专业版': 'Pro 专业版',
      'Pro专业版': 'Pro 专业版',
      'Enterprise 企业版': 'Enterprise 企业版',
      'Enterprise企业版': 'Enterprise 企业版',
      'Free': 'Free',
      'Plus 升级版': 'Plus 升级版',
      'Plus升级版': 'Plus 升级版'
    },
    // 来源描述映射
    balanceSources: {
      '会员赠送': '会员赠送',
      '新用户注册赠送': '新用户注册赠送',
      '邀请奖励': '邀请奖励',
      '充值': '充值',
      '系统赠送': '系统赠送',
      '管理员发放': '管理员发放',
      '推广奖励': '推广奖励'
    },
    // 交易标题映射
    transactionTitles: {
      'target_chat消费': 'target_chat消费',
      'quick_qa消费': 'quick_qa消费',
      'quick_brief_generation消费': 'quick_brief_generation消费',
      'expert_qa消费': 'expert_qa消费',
      'expert_report_generation消费': 'expert_report_generation消费',
      'writing_qa消费': 'writing_qa消费',
      'writing_report_generation消费': 'writing_report_generation消费',
      '报告生成消费': '报告生成消费',
      '会员开通': '会员开通',
      '充值到账': '充值到账',
      '会员升级': '会员升级',
      '系统退款': '系统退款'
    },
    // 充值类型映射
    rechargeTypes: {
      'X-Coin充值': 'X-Coin充值',
      '会员': '会员'
    },
    // 支付状态映射
    paymentStatus: {
      '已完成': '已完成',
      '处理中': '处理中',
      '失败': '失败'
    }
  },
  balance: {
    fetchFailed: '无法获取用户余额，请稍后重试',
    insufficientBrief: '余额不足！当前余额: {balance} X-Coin，需要: {required} X-Coin，缺少: {shortage} X-Coin',
    insufficientOp: '余额不足无法执行操作！当前余额: {balance} X-Coin，需要: {required} X-Coin，缺少: {shortage} X-Coin',
    afterCriticalWarn: '⚠️ 执行后余额将严重不足，请谨慎操作！',
    afterLowWarn: '⚠️ 执行后余额较低，建议充值！',
    current: '当前余额',
    currentBalance: '当前余额',
    currentBalanceLabel: '当前余额',
    estimatedCostLabel: '预估费用',
    afterBalanceLabel: '操作后余额',
    confirmTitle: '余额确认',
    balanceDialogTitle: '余额确认',
    confirmGeneration: '确认生成',
    confirmGenerationPrompt: '确认生成分析报告吗？',
    confirmExecute: '确认执行',
    // 新增：余额确认弹窗相关文案
    insufficientTitle: '余额不足',
    insufficientTip: '余额不足，需要先充值才能继续',
    insufficientChatMessage: '您的X-Coin余额不足，请先充值后再进行对话。',
    insufficientChatMessageTemp: '您的X-Coin余额不足，请先充值或升级会员后再继续。',
    warningTitle: '余额可能不足',
    generationThresholdLabel: '最低要求',
    warningThresholdLabel: '推荐余额',
    shortageLabel: '缺少余额',
    upgradeMembershipTip: '升级会员可享更低生成门槛和更多权益',
    rechargeTip: '请充值后继续操作',
    zeroBalanceDesc: '您的账户余额不足，无法继续操作。请立即充值后再试。',
    partialReportWarning: '您的账户余额可能不足以生成完整报告。我们将扣除您的余额为您继续生成报告。',
    partialReportWarningSecondary: '如实际消费X-Coin大于您的账户余额，您可以先预览部分报告内容，在充值后可查看下载全部报告内容。',
    partialReportTip: '如需确保生成完整报告，建议先充值',
    rechargeRecommendation: '充值后可享受更多服务',
    becomeMember: '成为会员',
    confirmUpgrade: '确认升级',
    confirmContinue: '继续生成',
    rechargeNow: '立即充值',
    goRecharge: '去充值',
    operations: {
      targetAnalysis: '执行调研分析操作',
      reportGeneration: '生成分析报告',
      hallucinationDetection: '幻觉检测',
      chatMessage: '发送聊天消息',
      audioTranscribe: '音频转录',
      tts: '文字转语音',
      execute: '执行操作'
    },
    status: {
      critical: '余额严重不足！当前余额: {balance} X-Coin，请立即充值',
      warning: '余额较低！当前余额: {balance} X-Coin，建议尽快充值',
      low: '余额偏低，当前余额: {balance} X-Coin，建议适时充值',
      sufficient: '余额充足，当前余额: {balance} X-Coin'
    },
    notifications: {
      titles: {
        exhausted: '账户余额不足',
        critical: '账户余额严重不足', 
        warning: '账户余额较低',
        low: '账户余额提醒'
      },
      messages: {
        exhausted: '您的账户余额已不足（剩余: {remaining}元），请及时充值以继续使用服务。',
        critical: '您的账户余额严重不足（剩余: {remaining}元），建议尽快充值。',
        warning: '您的账户余额较低（剩余: {remaining}元），请注意及时充值。',
        low: '您的账户余额（剩余: {remaining}元）低于预警阈值，请关注余额变化。'
      }
    }
  },
  recharge: {
    title: '余额不足，需要充值',
    reportProgress: '报告生成进度',
    progressDesc: '已完成 {completedSteps}/{totalSteps} 步',
    costDetails: '费用明细',
    consumed: '已消耗',
    stillNeed: '还需',
    tip: '充值后报告将继续生成，您可以随时查看进度',
    goRecharge: '立即充值'
  },
  errors: {
    timeout: '请求超时，请稍后再试',
    chatTimeout: '聊天服务响应超时，您的消息已发送，但可能需要更长时间处理',
    networkFailed: '网络连接失败，请检查您的网络连接',
    networkFailedWithBackend: '网络连接失败，请检查网络连接并确保后端服务已启动',
    serverSlow: '请求超时，服务器响应过慢',
    unableConnect: '无法连接到服务器，请检查网络连接和后端服务状态',
    difyDisconnected: '后端AI服务暂时不可用，系统将使用降级模式运行',
    fileDownloadFailed: '文件下载失败，请稍后重试',
    fileDeleteFailed: '文件删除失败，请稍后重试',
    networkUnstable: '网络连接不稳定，请检查您的网络并重试',
    feishuIllegalRedirect: '飞书登录失败: redirect_uri 请求不合法，请联系管理员修改配置',
    feishuCodeInvalid: '飞书登录失败: 授权码无效或已过期，请重新登录',
    loginExpired: '登录已过期，请重新登录',
    loginInvalid: '登录状态已失效，请重新登录以继续操作',
    forbidden: '权限不足，无法访问该资源',
    badRequest: '请求参数错误',
    notFound: '请求的资源不存在',
    tooManyRequestsOrNoBalance: '请求过于频繁或X-Coin额度不足，请稍后重试',
    serverInternal: '服务器内部错误',
    serviceUnavailable: '服务暂时不可用，请稍后再试',
    fileDownloadEnFailed: '该历史任务暂不支持英文报告，已为您提供中文版'
  },
  
  // 用户反馈
  feedback: {
    errors: {
      redirectError: '请求重定向错误，请联系管理员',
      badRequest: '请求参数有误，请检查输入内容',
      authFailed: '身份认证失败，请重新登录',
      noPermission: '没有权限提交反馈',
      validationFailed: '数据验证失败，请检查输入格式',
      serverError: '服务器内部错误，请稍后重试',
      submitFailedCode: '提交失败 (错误代码: {code})',
      networkFailed: '网络连接失败，请检查网络连接',
      unknownError: '发生未知错误：{msg}'
    },
    title: '用户反馈',
    subtitle: '我们重视每一条反馈，期待您的宝贵意见',
    // 管理页面/公共
    searchLabel: '搜索内容',
    searchPlaceholder: '搜索反馈内容、用户名或邮箱',
    status: '处理状态',
    statusPlaceholder: '请选择处理状态',
    statusPending: '待处理',
    statusProcessing: '处理中',
    statusCompleted: '已完成',
    statusClosed: '已关闭',
    username: '用户名',
    email: '用户邮箱',
    actions: '操作',
    view: '查看详情',
    edit: '编辑',
    detail: '反馈详情',
    id: '反馈ID',
    contact: '联系方式',
    createdAt: '提交时间',
    updatedAt: '更新时间',
    processor: '处理人',
    processedAt: '处理时间',
    search: '搜索',
    reset: '重置',
    export: '导出CSV',
    submitTimeRange: '提交时间',
    startTime: '开始时间',
    endTime: '结束时间',
    empty: '暂无反馈数据',
    // 表单与类型
    content: '反馈内容',
    type: '反馈类型',
    typeRequirement: '需求建议',
    typeException: '功能异常',
    typeOther: '其他',
    contentPlaceholder: '请详细描述您遇到的问题或建议，至少输入10个字符',
    typePlaceholder: '请选择反馈类型',
    characterCount: '已输入字数',
    minCharacters: '至少输入10个字符',
    maxCharacters: '最多输入1000个字符',
    options: {
      function_exception: '功能异常',
      requirement_suggestion: '功能建议',
      complaint: '问题投诉',
      other: '其他问题'
    },
    typeDescriptions: {
      function_exception: '页面报错、功能无法正常使用等',
      requirement_suggestion: '希望增加的新功能或改进建议',
      complaint: '服务质量或体验问题投诉',
      other: '其他类型的意见或建议'
    },
    processNote: '处理说明',
    actions: {
      cancel: '取消',
      submit: '提交反馈',
      submitting: '提交中...'
    },
    steps: {
      step1: '请选择问题标签',
      step2: '描述您的问题',
      step3: '上传图片/文件（最多上传5个图片/文件）'
    },
    upload: {
      images: '图片',
      files: '文件',
      maxImages: '最多5张图片',
      maxFiles: '最多5个文件',
      clickToUpload: '点击上传',
      reachedLimit: '已达上限',
      pasteHint: '支持粘贴图片（Ctrl+V / ⌘+V）或点击上传',
      imagePreview: '图片预览',
      previewImage: '预览图片',
      onlyImages: '只能上传图片文件!',
      imageSizeLimit: '图片大小不能超过 50MB!',
      onlyDocuments: '只能上传 PDF、Word、Excel、TXT、ZIP、RAR 文件!',
      fileSizeLimit: '文件大小不能超过 50MB!',
      maxImagesWarning: '最多只能上传 5 张图片，当前已有 {count} 张。请先移除部分图片后再上传。',
      maxFilesWarning: '最多只能上传 5 个文件，当前已有 {count} 个。请先移除部分文件后再上传。',
      pasteSuccess: '已粘贴图片: {name}',
      pasteLimit: '最多只能上传 5 张图片',
      pasteSizeLimit: '粘贴的图片大小不能超过 50MB!',
      uploadingFiles: '正在批量上传 {count} 个文件，请稍候...'
    },
    operation: '操作',
    rules: {
      contentRequired: '请填写反馈内容',
      contentTooShort: '反馈内容至少需要10个字符',
      contentTooLong: '反馈内容不能超过1000个字符',
      typeRequired: '请选择反馈类型'
    },
    messages: {
      submitSuccess: '感谢您的反馈！我们会认真处理',
      submitError: '提交失败，请稍后重试',
      sendMessageFailed: '发送消息失败',
      sendMessageFailedWithTimeout: '请求超时（已等待10分钟）。临床试验搜索等复杂查询可能需要更长时间，请稍后重试或联系管理员',
      sendMessageFailedWithServerInternal: '服务器内部错误，请稍后重试',
      sendMessageFailedWithTooManyRequests: '请求过于频繁，请稍后重试'
    }
  },
  target: {
    createFailed: '创建任务失败，请重试',
    messages: {
      sendMessageFailed: '发送消息失败',
      sendMessageFailedWithTimeout: '请求超时，调研分析可能需要更长时间，请稍后重试',
      sendMessageFailedWithServerInternal: '服务器内部错误，请稍后重试',
      sendMessageFailedWithTooManyRequests: '请求过于频繁，请稍后重试'
    },
    contract: {
      unclassified: '未分类',
      taskMode: {
        quick: '快速模式',
        expert: '专家模式',
        writing: '撰写模式',
      },
      workflowProfile: {
        'target-survey': '靶点调研',
        'deep-research': '深度研究',
        'quick-brief': '快速简报',
        writing: '撰写报告',
      },
    },
    analysisPage: '任务分析页',
    searchPlaceholder: '搜索（名称/描述）',
    empty: '暂无任务数据',
    selectToView: '请选择一个任务查看分析报告',
    confirmRightPanel: '请先完成右侧对话区的信息确认，确认后系统将自动开始分析。',
    generating: '正在分析中...',
    reportGenerating: 'epiXora生成任务分析报告中，您可以关闭页面，稍后重新进入查看报告',
    report: '分析报告',
    selectTargetFirst: '请先选择任务',
    loadListFailed: '加载任务列表失败',
    createAnalysisTitle: '创建调研分析任务',
    createAnalysisConfirm: '确认创建"{name}"的调研分析任务吗？',
    createSuccess: '任务创建成功',
    selectTaskFirst: '请先选择一个任务',
    analysisInProgressTip: '当前调研任务正在执行，预计耗时 约 30～60 分钟，请您耐心等待。您可关闭当前窗口，任务将自动在后台继续进行。',
    cancelGeneration: '取消生成',
    reportGenerationFailed: '报告生成失败',
    retryOrContactSupport: '请重新生成，或联系管理员处理',
    // 2026-06-01 P1-I: writing-mode (llm_agent) specific copy.
    // Reuses the existing target.* namespace so consumers don't need
    // to learn a new key prefix.
    writingTaskSubmitted: '已提交撰写报告任务，请关注进度区域',
    writingReportGenerationFailed: '撰写报告生成失败',
    writingModeUnavailable: '撰写服务暂不可用，请稍后重试',
    writingReportMarkdownHint: '撰写模式产物为 Markdown 文档，可在下方编辑/导出，或通过下载菜单获取 .md / .docx。',
    v2MarkdownOnlyHint: '该报告暂无 PDF 预览，已启用 Markdown 查看与编辑能力，可在 Markdown 编辑页签中进行保存、版本管理、幻觉检测与导出。',
    writingAck: {
      defaultIntent: '已记录您的写作需求',
      confirmEyebrow: '撰写任务已就绪',
      confirmTitle: '已理解您的写作需求',
      confirmHint: '可以继续补充要求，或直接生成正式 Markdown 报告。',
      routeTitle: '准备生成调研报告',
      regenerateEyebrow: '建议重新生成报告',
      regenerateTitle: '当前修改幅度较大',
      regenerateHint: '针对报告的大幅结构调整或全文重写，建议重新生成报告。',
      taskIntent: '任务目标',
      deliverable: '交付形式',
      focus: '重点关注',
      constraints: '约束条件',
      continueSupplement: '继续补充',
      generateReport: '生成撰写报告',
      regenerateReport: '重新生成报告'
    },
    workspace: {
      reportLayout: '报告布局',
      splitLayout: '左右分栏',
      stackLayout: '上下单列',
      reportGenerating: '报告生成中',
      reportProgressSection: '报告进度',
      reportDraftPreview: '报告草稿预览',
      reportFailed: '报告生成失败',
      reportCancelled: '报告已取消',
      navigation: '导航',
      chatTop: '对话顶部',
      preReportChat: '报告前对话',
      postReportChat: '报告后对话',
      postReportComposerFollowUp: '追问报告',
      reportSection: '报告区域',
      fullscreenReport: '全屏报告',
      chat: '对话',
      followUp: '追问',
      report: '报告',
      fullscreen: '全屏',
      continueChat: '继续对话...',
      useOutlineTemplate: '选用大纲模版',
      manageOutlineTemplates: '管理模版',
      outlineTemplateTip: '从已保存模版快速生成专家模式大纲',
      quickOutlineTemplateTip: '选用已保存的问题框架，一键发起快速调研',
      quickTemplateApplyQuery: '使用调研问题模版：{name}',
      resizeReportHeight: '拖拽调节报告预览高度，双击恢复默认',
      resizeSplitPane: '拖拽调节对话与报告区域宽度，双击恢复默认',
      reportNav: '报告区导航',
      reportQuickNav: '报告快捷导航',
      analysisReportSidebar: '分析报告侧栏',
      feedbackSourceV2: '任务分析 V2',
      messages: {
        emptyInputDialogTitle: '输入不能为空',
        emptyInputDialogMessage: '您未提供任何描述信息，您可以输入想要调研的主题获取文献简版或上传文件进行材料问答。',
        balanceConfirmFailed: '余额确认失败，请稍后重试',
        balanceConfirmMessage: '即将生成报告，请确认是否继续。',
        reportTaskStarted: '报告生成任务已启动',
        reportAlreadyRunning: '报告已在生成中，无需重复提交',
        resumeReportStarted: '恢复生成已启动，将从失败点继续',
        resumeLocalSurveyStarted: '恢复生成已启动，将继续未完成的调研步骤',
        resumeCheckpointPartialStarted: '恢复生成已启动，将复用已保存的调研进度（已完成 {completed}/{total} 个调研模块）',
        resumeCheckpointSynthesisStarted: '恢复生成已启动，将跳过已完成的数据采集并继续整理报告',
        resumeHermesWritingStarted: '恢复生成已启动，将继续未完成的报告撰写任务',
        reportGenerationFailed: '报告生成失败，请稍后重试',
        reportEnqueueInProgress: '报告正在启动中，请勿重复提交',
        reportCancelled: '已取消报告生成',
        cancelReportFailed: '取消报告生成失败',
        writeModeDescribeFirst: '请先在撰写模式中描述报告需求',
        writingPdfUnavailable: '撰写模式报告以 Markdown 交付，请下载 Markdown 或使用编辑器导出 Word',
        adminWritingEngineLabel: '撰写引擎',
        adminWritingEngineDefault: '跟随系统配置',
        adminWritingEngineRemote: '远端智能体',
        adminWritingEngineLocal: '本地 LangGraph',
        adminWritingEngineHermes: 'Hermes 自由撰写',
        adminEngineBadge: '管理员',
        adminWritingEngineDefaultDesc: '读取后台 WRITING_ENGINE 全局配置',
        adminWritingEngineRemoteDesc: '远端 AGENT_SERVER llm_agent 流程',
        adminWritingEngineLocalDesc: '本机 LangGraph 撰写执行器',
        adminWritingEngineHermesDesc: 'Hermes Gateway 自由撰写 skill',
        adminSurveyEngineLabel: '靶点调研引擎',
        adminSurveyEngineHint: '选择本次靶点调研的报告生成引擎。Hermes 为默认推荐；本地智能体走 integrated_agent 流程；跟随系统配置则读取后台 TARGET_SURVEY_ENGINE。',
        adminSurveyEngineDefault: '跟随系统',
        adminSurveyEngineLocal: '本地智能体',
        adminSurveyEngineHermes: 'Hermes',
        adminSurveyEngineDefaultDesc: '读取后台 TARGET_SURVEY_ENGINE 全局配置',
        adminSurveyEngineLocalDesc: '本地 integrated_agent 靶点调研流程',
        adminSurveyEngineHermesDesc: 'Hermes API Gateway 靶点调研',
        adminHermesSurveyFlowLabel: 'Hermes 调研 Skills',
        adminHermesSurveyFlowHint: '选择 Hermes 靶点调研 skills 流程。默认读取后台 TARGET_HERMES_SURVEY_FLOW；普通用户始终使用该默认值。',
        adminHermesSurveyFlowH2Outline: 'hermes-h2_outline',
        adminHermesSurveyFlowH2OutlineDesc: '8 lane 并行采集 + synthesis（h2_outline 模式）',
        adminHermesSurveyFlowOutlinePlanner: 'hermes-outline_planner',
        adminHermesSurveyFlowOutlinePlannerDesc: '按用户大纲 H2 章节任务分解（outline_planner 模式）',
        adminEngineConfirmLine: '管理员引擎覆盖：{engine}',
        adminWritingEngineHint: '选择本次撰写任务的报告生成引擎。未选择时读取后台 WRITING_ENGINE 配置。',
        outlineTemplateLoaded: '已加载大纲模版：{name}，可直接发送或继续编辑',
        quickOutlineTemplateLoaded: '已加载快速调研模版：{name}，发送后将按问题框架生成调研',
        quickTemplateQuestionsLoaded: '已加载模版「{name}」的 {count} 个调研问题，可在下方卡片中编辑后开始调研',
        templateAppliedLabel: '【已应用模板：{name}】',
        loadAttachmentsFailed: '加载附件列表失败',
        selectTaskBeforeUpload: '请先选择或创建任务后再上传附件',
        uploadBindSuccess: '已上传并绑定 {success}/{total} 个附件',
        uploadAttachmentFailed: '附件上传失败',
        removeAttachmentConfirm: '确定从当前任务移除附件"{name}"吗？',
        removeAttachmentTitle: '移除附件',
        removeAttachmentButton: '移除',
        attachmentRemoved: '附件已移除',
        removeAttachmentFailed: '移除附件失败',
        noPreviewContent: '未找到可预览的报告内容',
        reportContentLoadFailed: '报告内容加载失败',
        auditRejectedNoDownload: '报告审核未通过，暂不可下载',
        downloadPreparing: '正在准备 {format} 报告...',
        downloadStarted: '{format} 下载已开始',
        reportDownloadFailed: '报告下载失败，请稍后重试',
        ratingSaved: '报告评价已保存',
        ratingDeleted: '报告评价已删除',
        segmentAddedToChat: '已带入报告片段，请补全问题后发送',
        sectionAddedToChat: '已带入「{title}」章节，请补全问题后发送',
        reportContentUpdated: '报告内容已更新',
        createTaskBeforeAttachment: '请先创建任务后再上传或引用附件',
        deleteTaskConfirm: '确定要删除任务"{name}"吗？创建人：{creator}。删除后该任务将从列表中移除。',
        deleteTaskSuccess: '任务删除成功',
        deleteTaskFailed: '删除任务失败，请稍后重试',
        readingSelectedFilesPrompt: '正在阅读您选择的{count}份文件...',
        analyzeAttachmentsPrompt: '请基于引用的 {count} 个附件进行分析。',
        reportSegmentPrompt: '请基于以下报告片段继续分析：\n\n"{preview}"\n\n我的问题：',
        reportSectionPromptWithContext: '请针对报告中的「{title}」章节进行追问、细化或修正：\n\n> 章节节选：{preview}{ellipsis}\n\n我的问题：',
        reportSectionPrompt: '请针对报告中的「{title}」章节进行追问、细化或修正：\n\n我的问题：',
        exportHtmlNeedMarkdown: '请先载入 Markdown 报告后再导出 HTML',
        downloadHttpStatus: '下载失败，状态码 {status}',
        uploadMissingFileId: '上传响应缺少文件 ID',
        downloadNoContent: '下载接口未返回文件内容',
        browserDownloadFailed: '浏览器下载失败',
        downloadNoUrl: '后端未返回下载地址',
        defaultUser: '用户',
        forkConversationSuffix: '新对话',
        modeSwitchTitle: '切换任务类型',
        modeSwitchTitleTo: '切换至{mode}？',
        modeSwitchContinue: '继续切换',
        modeSwitchLeaveWriteWithRefs: '切换模式后，将为您新建对话并清除目前上传的附件，已有对话将会保存在历史调研中，是否继续切换？',
        modeSwitchLeaveWriteInChat: '您当前的撰写模式对话尚未结束，切换后我们将为您开启新对话，已有对话内容将会与本对话任务一起保存在历史调研中，是否继续切换？',
        modeSwitchToWriteInResearch: '您当前的调研报告生成尚未开始，切换后将开启新对话，当前进度将会保存在历史调研中，是否继续切换？',
        modeSwitchExpertDoneToQuick: '您当前的调研任务已完成，切换后将开启新对话，当前调研内容与对话将保存在历史调研中，是否继续切换？',
        modeSwitchQuickBriefToExpert: '当前任务已生成快速简报（对话区可查看），尚无专家调研报告。切换专家模式后需重新生成正式报告，快速简报内容仍保留在对话中。是否继续？',
        modeSwitchConfirmReportRunning: '切换任务类型将新建对话以新的上下文开始，当前对话记录将被保留，是否继续？',
        modeSwitchConfirmMidFlow: '当前对话处于「{phrase}」中间态，切换任务类型将新建对话开始新上下文，旧对话记录会保留。继续？',
        modeSwitchOutlineFlow: '调研对话',
        modeSwitchForkSuccess: '已开启新对话',
        modeSwitchLeaveWriteRefs: '离开撰写模式将清空当前参考资料引用（服务器文件仍保留）。继续切换？'
      }
    },
    reportPanel: {
      title: '报告生成',
      writingTitle: '撰写生成',
      refresh: '刷新',
      cancel: '取消生成',
      resume: '恢复生成',
      loadingProgress: '正在加载报告进度...',
      noProgress: '暂无报告进度',
      defaultStep: '报告生成',
      statusGenerating: '报告正在生成，请稍候。',
      statusFailed: '报告生成失败，可尝试恢复生成。',
      statusCancelled: '报告生成已取消，可从中断处恢复。',
      statusCompleted: '报告已生成完成。',
      statusDefault: '报告进度会在开始调研后显示。',
      draftPreview: '以下为生成中的报告草稿预览，终稿生成后自动替换。',
      durationRange: '预估耗时 {min}–{max} 分钟',
      durationSingle: '预估耗时约 {minutes} 分钟',
      durationHighComplexity: '章节较多，可能接近或超过系统超时上限，建议恢复生成或联系管理员调高 timeout。',
      durationHint: '预估耗时'
    },
    attachment: {
      title: '附件与文档引用',
      toolbarTitle: '当前任务附件',
      toolbarDesc: '上传并引用后，将仅基于材料内容回答（不联网搜索）；发送前会自动解析正文并注入上下文。',
      formatHint: '支持 {formats}；单个文件 ≤ {maxMb}MB（以会员套餐为准，不超过 20MB）',
      modeQuickNote: '【快速模式】附件配额独立于专家/撰写模式。',
      modeExpertNote: '【专家/撰写模式】附件配额按知识库会话规则计算。',
      quickQuotaHint: '快速模式：单会话最多 {perTask} 个附件，单文件 ≤ {maxMb}MB',
      quickQuotaUnlimited: '快速模式：单会话附件数量不限，单文件 ≤ {maxMb}MB',
      quickUsageUnlimited: '快速模式 · 已引用 {count} 个附件（数量不限）',
      quickUsageLimited: '快速模式 · 已引用 {count}/{perTask} 个附件',
      expertQuotaPerTask: '专家/撰写模式：单会话 ≤ {perTask} 个附件，单文件 ≤ {maxMb}MB',
      expertQuotaTotal: '专家/撰写模式：账号知识库总容量 {total} 个文件',
      expertQuotaBoth: '专家/撰写模式：单会话 ≤ {perTask} 个，账号总容量 ≤ {total} 个，单文件 ≤ {maxMb}MB',
      expertUsageLimited: '专家/撰写模式 · 已引用 {count}/{perTask} 个附件',
      expertUsageCount: '专家/撰写模式 · 已引用 {count} 个附件',
      localFormats: '支持 {formats}',
      localMaxMb: '单文件 ≤ {maxMb}MB',
      localPerTask: '本任务最多 {perTask} 个文件',
      localTotal: '账号总容量 {total} 个文件',
      localQuickUnlimited: '本任务附件数量不限',
      quotaHintPerTask: '单个知识库/会话最多可绑定 {perTask} 个附件（会员套餐）',
      quotaHintTotal: '账号知识库总容量 {total} 个文件（会员套餐）',
      quotaHintBoth: '单个知识库/会话 ≤ {perTask} 个附件，账号总容量 ≤ {total} 个（会员套餐）',
      unsupportedType: '不支持该文件类型（{ext}），请上传 PDF、Word、Excel、PPT、TXT、Markdown、HTML、CSV',
      sizeExceeded: '文件大小超过限制（最大 {max}MB）',
      refresh: '刷新',
      upload: '上传附件',
      localUploadTitle: '上传本地文献',
      dragUploadHint: '拖拽文件到此处上传',
      selectFile: '选择文件',
      uploadedFiles: '已上传文件',
      uploadCompleted: '已完成',
      empty: '暂无附件',
      fileName: '文件名',
      size: '大小',
      actions: '操作',
      referenced: '已引用',
      reference: '引用',
      remove: '移除',
      close: '关闭',
      unnamedFile: '未命名文件'
    },
    sourcePanel: {
      title: '溯源详情',
      collapse: '收起面板',
      expand: '展开溯源详情',
      hide: '隐藏面板',
      clear: '清除',
      emptyTitle: '点击左侧溯源标记',
      emptyDesc: '查看引用句子与文献来源，支持 PubMed、ClinicalTrials 等数据库。',
      step1: '① 选句子',
      step2: '② 看来源',
      step3: '③ 打开原文',
      quotedSentence: '引用语句',
      sourceExcerpt: '原文摘录',
      reportExpression: '报告表述',
      articleInfo: '文章信息',
      contextInfo: '上下文信息',
      issue: '卷期',
      trialInfo: '试验信息',
      patentInfo: '专利信息',
      materialInfo: '材料信息',
      materialBadge: '用户材料',
      knowledgeBaseInfo: '知识库信息',
      authors: '作者',
      loadingPubmed: '正在加载 PubMed 文献信息…',
      journal: '出处',
      openOriginal: '打开原文',
      copyLink: '复制链接',
      pubmedAbstract: 'PubMed 摘要页',
      embedPreviewTitle: '溯源页面预览',
      referenceMaterial: '参考资料',
      literature: '文献',
      literatureSource: '文献来源',
      externalLink: '外部链接',
      opensearchBadge: '内部文献库 · 索引命中',
      internalIndexHit: '索引命中',
      pubmedTip: '学术站点通常禁止页内嵌入，已为您高亮摘要中与引用句匹配的关键词。',
      loadingClinicalTrial: '正在加载 ClinicalTrials.gov 试验信息…',
      trialStatus: '状态',
      trialPhase: '阶段',
      trialConditions: '适应症',
      trialSponsor: '申办方',
      clinicalTrialTip: 'ClinicalTrials.gov 禁止页内嵌入，已展示试验元数据与高亮摘要；可点击「打开原文」查看完整页面。',
      clinicalTrialPage: 'ClinicalTrials 详情页',
      clinicalTrialFetchFailed: '在线元数据暂不可用，已使用检索摘要展示；可点击「打开原文」访问注册库页面。',
      trialInterventions: '干预',
      trialStartDate: '开始日期',
      registryEmbedTip: '该临床试验注册库禁止页内嵌入，已展示检索摘要；请使用「打开原文」查看完整登记信息。',
      citationPending: '溯源信息生成中，稍后将自动补全。',
      citationUnavailable: '该简报暂无句级溯源，请先参考已展示的检索来源。',
      corpusFallbackHint: '未在原文中精确定位该句，引用句来自报告表述；上下文为检索摘要或按需拉取的原文摘录。',
      bibliographyOnlyHint: '当前为书目级溯源；未能从文献库拉取与该句对齐的原文摘录。',
      loadingSourceExcerpt: '正在从文献索引拉取原文摘录…',
      linkCopied: '链接已复制',
      copyLinkFailed: '复制失败，请手动复制链接'
    },
    quickBrief: {
      badge: '调研简报',
      headline: '调研简报',
      headlineWithTopic: '【调研简报】{topic}',
      subtitle: '调研结果如下，您可以滑动词句或按键保存部分或完整内容到知识地图',
      questionTag: '问题 {index}',
      metaWithSources: '{sentences} 句 · {sources} 个来源',
      metaNoSource: '待补句级溯源 · 可先阅读结构化简报',
      metaRetrievalOnly: '已关联检索来源 · 点击句末标记查看详情',
      sourceLinked: '已关联检索来源',
      syntheticSourceFootnote: '依据检索来源',
      metaModelSummary: '模型归纳简报 · 可展开深度调研补充文献',
      exportBrief: '导出简报',
      exportMarkdown: 'Markdown 格式',
      exportHtml: 'HTML 网页',
      exportWord: 'Word 格式',
      exportPdf: 'PDF 格式',
      sourceHint: '当前简报按章节展示，尚未关联句级文献来源。可先保存/导出草稿，服务接入检索证据后将支持点击句子查看右侧溯源详情。',
      sourceHintSoft: '部分句子尚未展示可点击来源标记，可继续阅读结论或发起深度调研补充证据。',
      empty: '暂无带溯源的简报内容',
      statusFormal: '正式生成',
      sourcePending: '待补文献证据',
      viewCitationAria: '查看该句溯源来源',
      sourceFallback: '来源',
      saveToMap: '保存到知识地图',
      noExportContent: '暂无可导出的简报内容',
      exportedMarkdown: '简报已导出为 Markdown',
      unsupportedFormat: '不支持的导出格式',
      generating: '正在生成 {format}，请稍候...',
      exportedAs: '简报已导出为 {format}',
      exportFailed: '{format} 导出失败，请重试',
      summaryTable: '要点摘要表',
      logicDiagram: '调研逻辑示意',
      referenceIndexTitle: '参考文献与来源索引',
      copyGbt7714: '复制 GB/T 7714',
      copyBibtex: '复制 BibTeX',
      unnamedSource: '未命名来源',
      noReferencesToCopy: '暂无可复制的参考文献',
      citationsCopied: '已复制 {count} 条 {format} 引用',
      copyFailed: '复制失败，请重试',
      citationSource: {
        webSearch: '网络搜索',
        internalLiterature: '内部文献库',
        internalClinicalTrial: '内部临床试验库',
        internalPatent: '内部专利库',
        internalKnowledgeBase: '内部知识库',
        matchedExcerpt: '命中片段',
        matchedExcerptExport: '**命中片段：**'
      },
      progress: {
        centerTitle: '正在生成调研简报',
        centerHint: '右侧聊天区同步显示生成进度，完成后将自动展示带溯源的简报',
        connecting: '正在连接实时进度…',
        searchingDefault: '正在检索文献与整理要点…',
        generatingDefault: '正在生成简报…',
        finalizing: '简报生成完成，正在整理结果…',
        streamInterrupted: '进度流中断，继续等待生成结果…',
        sessionRestored: '已恢复会话，正在同步生成进度…',
        streamDisconnected: '实时进度已断开，正在等待生成结果…',
        httpTimeoutStillGenerating: '连接等待时间较长，简报仍在后台生成，请稍候或刷新页面查看结果',
        streamConnectFailed: '进度流连接失败，正在等待生成结果…',
        syncingProgress: '正在同步生成进度…',
        chatPlaceholder: '正在生成「{topic}」调研简报...',
        steps: {
          analyzeDimensions: '分析维度',
          evidenceSearch: '证据检索',
          sectionWriting: '章节撰写',
          sectionWritingProgress: '章节撰写 {done}/{total}',
          finalOptimize: '最终优化',
          literatureCollection: '文献采集',
          keyPoints: '要点梳理',
          citationMarkup: '溯源标注',
          patentCollection: '专利采集',
          clinicalTrials: '临床试验',
          outlineGeneration: '大纲生成'
        }
      }
    },
    modes: {
      expert: {
        manageTemplates: '管理大纲模版'
      },
      write: {
        title: '生成撰写报告',
        description: '我会基于上面的撰写需求生成正式 Markdown 报告。还需要补充要求的话，可以继续在下方输入。',
        generate: '生成撰写报告',
        regenerate: '重新生成报告',
        postReportDescription: '报告已生成。如需大幅调整结构或重写全文，可重新生成；针对报告内容的追问请在下方输入。',
        generatingDescription: '报告正在生成中，请稍候。生成完成后可继续追问或重新生成。'
      },
      quick: {
        manageTemplates: '管理大纲模版',
        saveQuestionsTip: '将当前问题清单存为模版，可在其他任务中一键复用',
        saveBriefAsTemplate: '存简报为模版',
        actionsHint: '划词可保存到知识地图，也可右键保存章节或整篇简报',
        saveToMap: '存入知识地图',
        copyBrief: '复制简报',
        regenerateBrief: '重新生成简报',
        regenerateBriefNoQuestions: '无法从当前简报恢复问题列表（至少需要 {min} 个问题），请重新发起调研',
        saveSectionToMap: '保存当前章节到知识地图',
        copySectionMd: '复制当前章节 Markdown',
        saveTableToMap: '保存表格到知识地图',
        copyTableMd: '复制表格 Markdown',
        tableParseFailed: '表格解析失败',
        tableCopied: '表格 Markdown 已复制',
        saveSelectionToMap: '保存选中文本到知识地图',
        saveFullBriefToMap: '保存整篇简报到知识地图',
        quickSaving: '快速保存中...',
        quickSaveToMap: '快速保存到知识地图',
        copySelection: '复制选中文本',
        copyFullBrief: '复制整篇简报',
        generatingBrief: '正在生成「{topic}」调研简报...',
        statusProcessing: '处理中',
        statusHistorical: '历史问题',
        statusCompleted: '已完成调研',
        statusPending: '待调研',
        emptyContent: '内容为空，无法保存到知识地图',
        emptyCopy: '内容为空，无法复制',
        mapOpened: '已打开知识地图，请确认保存位置',
        sectionCopied: '当前章节 Markdown 已复制',
        briefCopied: '整篇简报 Markdown 已复制',
        copied: '已复制到剪贴板',
        copyFailed: '复制失败，请手动选择文本复制',
        quickSaveSuccess: '已快速保存到知识地图，Wiki 将在后台整理',
        quickSaveSuccessMapOnly: '已快速保存到知识地图',
        quickSaveConfirm: '已保存到「{topic}」，是否现在打开知识地图查看？',
        saveSuccessTitle: '保存成功',
        openKnowledgeMap: '打开知识地图',
        continueResearch: '继续调研',
        quickSaveFailed: '快速保存失败，请使用确认弹窗重试',
        briefFooter: '来源：快速模式调研简报《{name}》',
        defaultTopic: '当前主题',
        unnamedTask: '未命名任务',
        unnamedTopic: '未命名主题',
        defaultDirectory: '靶点',
        defaultCategory: '综合内容',
        citationExport: {
          contextTitle: '当前溯源上下文',
          citationId: '引用编号',
          source: '来源',
          title: '标题',
          link: '链接',
          sentence: '对应句子',
          snippet: '命中片段',
          sectionDefault: '章节内容',
          dimension: '维度',
          status: '状态',
          provenance: '溯源',
        },
      }
    },
    reportResult: {
      generated: '已生成',
      locateSuccess: '已定位到原文，请在编辑器中查看选中内容',
      fullscreenViewEsc: '全屏查看（Esc 退出）',
      fullscreen: '全屏',
      expand: '展开',
      collapse: '收起',
      expandReportPreview: '展开报告预览',
      collapsePreviewSaveSpace: '收起预览，节省空间',
      reloadReportContent: '重新加载报告内容',
      refresh: '刷新',
      fullscreenView: '全屏查看',
      fullscreenRead: '全屏阅读',
      auditRejectedTitle: '报告审核未通过',
      auditRejectedDesc: '当前报告已被审核拒绝，暂不展示报告正文。请调整调研需求后重新生成，或联系管理员复核。',
      auditRejectedAdjustAction: '调整需求并重新生成',
      auditRejectedFeedbackAction: '申请人工复核',
      loadingReport: '正在加载报告内容...',
      loadFailedTitle: '报告加载失败',
      reload: '重新加载',
      noPreviewContent: '暂无可预览的报告内容',
      accessLimitedBalanceTitle: '账户余额不足，当前仅开放部分报告内容',
      accessLimitedPreviewHint: '充值后可查看和下载完整报告。',
      accessLimitedUnlocked: '已解锁 {percentage} 内容',
      accessLimitedUnlockNeed: '还需充值 {amount} X-Coin',
      accessLimitedRecharge: '去充值',
      subtitleDraft: '报告仍在生成中，以下为当前草稿预览。',
      collapsedPlaceholder: '报告预览已收起。展开预览或使用全屏查看完整内容。',
      exitFullscreenEsc: 'Esc 退出',
      exitFullscreen: '退出全屏',
      fullscreenAriaWithName: '全屏查看报告：{name}',
      fullscreenAria: '全屏查看分析报告',
      downloadFromMarkdown: '基于当前 Markdown 编辑内容导出（含未保存修改）',
      downloadFromServer: '从服务器下载已生成的报告文件',
      subtitleRejected: '报告审核未通过，正文暂不可查看。',
      subtitleWritingMarkdownOnly: '撰写文稿已生成，当前以 Markdown 形式预览、编辑与导出。',
      subtitleMarkdownOnly: 'Markdown 报告已就绪，可预览编辑或全屏查看。',
      subtitleDualFormat: '支持 PDF / Markdown 切换，建议全屏获得更佳阅读体验。',
      subtitleDefault: '报告已生成，点击全屏可沉浸式查看与操作。',
      collapsedHintWithName: '「{name}」报告已生成，当前为收起状态。',
      collapsedHint: '报告已生成，当前为收起状态。',
      qualityGateTitleFail: '报告存在需复核的可核验表述（高风险）',
      qualityGateTitleWarn: '报告存在建议复核的未脚注表述',
      qualityGateSummary: '规则扫描：高风险未脚注 {high} 处，中风险 {medium} 处。',
      qualityGateObserveOnlyPrefix: '【仅观测，不阻断发布】',
      qualityGateSummaryWithScore: '质量评分 {score}/{threshold}（QA）；致命 {critical}。规则扫描：高风险 {ruleHigh}、中风险 {ruleMedium}；QA 另计高风险 {qaHigh}、中风险 {qaMedium}。建议补充脚注或删除无法证实的句子。',
      qualityGateScoreTag: '评分 {score}/{threshold}',
      qualityGatePublishBlocked: '质量门控未通过发布阈值，当前报告建议修订后再对外使用。',
      qualityGateRecommendation: '请为 NCT/PMID/专利号/PDB/百分比等可核验内容补充 [N] 脚注（与正文引用格式一致）；无法证实时应改为「公开证据不足」或删除相关句子。',
      qualityGateIssuesTitle: '问题摘录（展示 {displayed} / 共 {total}{truncated}，致命优先）',
      qualityGateIssuesTruncated: '，仅展示前 {limit} 条',
      qualityGateSeverityCritical: '致命',
      qualityGateSeverityHigh: '高',
      qualityGateSeverityMedium: '中',
      qualityGateOpenReview: '打开幻觉检测复核',
      qualityGateIssue: {
        placeholder_or_tbd: '占位符或未填项',
        uncited_trial_or_pmid: '未脚注临床试验/文献编号',
        uncited_patent_id: '未脚注专利号',
        uncited_pdb_id: '未脚注 PDB 结构编号',
        uncited_trial_phase_stat: '未脚注临床阶段/统计',
        uncited_numeric_claim: '未脚注数值或疗效指标',
        uncited_regulatory_claim: '未脚注监管/获批表述',
        footnote_semantic_mismatch: '脚注与事实句不匹配',
        clinical_trial_field_needs_verification: '临床试验字段待核验',
        patent_unclear_with_conclusion: '专利信息不清却下结论',
        missing_reference: '缺失引用',
        hallucination: '疑似幻觉',
        concept_confusion: '概念混淆',
        time_inconsistency: '时间不一致',
        qa_issue: '质量问题',
      },
    },
    taskNameRequired: '调研任务名称不能为空',
    taskNameEmpty: '请输入任务名称',
    taskIdInvalid: '靶点ID无效，请刷新页面重试',
    updateNameFailed: '更新调研任务名称失败',
    targetNotExist: '靶点 {id} 不存在或您无权访问',
    selectFirst: '请先选择一个任务',
    // TargetList 页面相关
    list: {
      title: '任务管理',
      newTask: '新建任务',
      newTaskShort: '新建',
      questionnaireCreate: '问答创建',
      questionnaireCreateShort: '问答',
      filters: '筛选条件',
      status: '状态',
      allStatus: '全部状态',
      taskId: '任务ID',
      taskIdPlaceholder: '请输入任务ID',
      search: '搜索',
      searchPlaceholder: '搜索任务名称或描述',
      creator: '创建人',
      creatorPlaceholder: '输入用户名或邮箱搜索',
      membershipTier: '会员等级',
      allMembershipTiers: '全部等级',
      allWorkflows: '全部工作流',
      createdAt: '创建时间',
      dateRangeSeparator: '至',
      startTimePlaceholder: '开始时间',
      endTimePlaceholder: '结束时间',
      searchButton: '搜索',
      resetButton: '重置',
      statistics: {
        total: '总数量',
        analyzing: '分析中',
        completed: '已完成',
        pending: '待分析'
      },
      table: {
        taskId: '任务ID',
        taskName: '任务名称',
        description: '描述',
        status: '状态',
        workflow: '工作流',
        creator: '创建人',
        createdAt: '创建时间',
        updatedAt: '更新时间',
        reportDuration: '耗时',
        reportCost: '费用',
        actions: '操作',
        view: '查看',
        generate: '生成报告',
        regenerate: '重新生成',
        generating: '生成中',
        chat: '对话',
        unknown: '未知',
        intelligenceSubscribe: '情报订阅',
        intelligenceFeed: '情报更新',
        more: '更多'
      },
      mobile: {
        viewDetail: '查看详情',
        startChat: '开始对话'
      },
      createDialog: {
        title: '新建任务',
        taskName: '任务名称',
        taskNamePlaceholder: '请输入任务名称',
        taskDescription: '任务描述',
        taskDescriptionPlaceholder: '请输入任务描述',
        taskType: '任务类型',
        taskTypePlaceholder: '请输入调研类型',
        priority: '优先级',
        priorityPlaceholder: '请选择优先级',
        remark: '备注',
        remarkPlaceholder: '请输入备注',
        cancel: '取消',
        create: '创建'
      },
      questionnaireDialog: {
        title: '通过问答创建任务',
        taskName: '任务名称',
        taskNamePlaceholder: '请输入调研任务名称',
        taskDescription: '任务描述',
        taskDescriptionPlaceholder: '请输入任务描述',
        questions: '问答信息',
        question: '问题',
        questionPlaceholder: '请输入问题',
        answer: '答案',
        answerPlaceholder: '请输入答案',
        delete: '删除',
        addQuestion: '添加问题',
        cancel: '取消',
        createTask: '创建任务',
        taskNameRequired: '请输入任务名称',
        qaRequired: '请至少填写一个完整的问答'
      },
      messages: {
        createSuccess: '任务创建成功',
        createFailed: '创建任务失败',
        loadFailed: '加载任务列表失败',
        noData: '未获取到有效数据',
        pageAutoJump: '已自动跳转到第{page}页',
        cancelSuccess: '已取消报告生成',
        statusNotSupportCancel: '当前状态不支持取消操作',
        taskNotExist: '任务不存在或已被删除',
        cancelFailed: '取消操作失败，请稍后重试',
        reportGenerateStarted: '报告生成任务已启动，请查看生成进度',
        startReportFailed: '启动报告生成失败'
      },
      pageSizeLimitWarning: '每页数量已限制为1000'
    },
    // TargetChat 页面相关
    chat: {
      backToDetail: '返回详情',
      targetChat: '靶点对话',
      reportChat: '报告对话',
      clearHistory: '清空对话',
      downloadReport: '下载报告',
      welcomeTitle: '欢迎与调研报告对话',
      welcomeMessage: '您可以询问关于"{name}"的任何问题，我会基于生成的报告为您解答。',
      suggestedQuestions: '建议问题：',
      you: '您',
      aiAssistant: 'AI助手',
      inputPlaceholder: '请输入您的问题...',
      writingPlaceholder: '描述您的写作需求，或上传参考资料，我将帮您整理成定制化文档。',
      writingChatPlaceholder: '您可以简单描述撰写需求，或要求修改已生成内容...',
      sending: '发送中...',
      send: '发送',
      invalidTaskId: '无效的任务ID，请重新进入',
      reportNotReady: '报告尚未生成完成，无法进行对话',
      taskIdInvalid: '任务ID无效，请重新选择任务',
      loadFailed: '加载任务信息失败',
      sendFailed: '发送消息失败',
      clearConfirmTitle: '确认清空',
      clearConfirmMessage: '确定要清空所有对话记录吗？此操作不可恢复。',
      clearSuccess: '对话记录已清空',
      downloadPreparing: '正在生成下载链接，请稍候...',
      downloadCancelled: '下载已取消',
      downloadTimeout: '下载链接生成超时，请稍后重试',
      downloadFailed: '下载报告失败',
      fileNotExist: '报告文件不存在或无法生成下载链接',
      justNow: '刚刚',
      minutesAgo: '{minutes}分钟前',
      hoursAgo: '{hours}小时前',
      defaultQuestion1: '这个靶点的主要功能是什么？',
      defaultQuestion2: '相关的研究现状如何？',
      defaultQuestion3: '临床应用前景怎样？',
      unknownResponseFormat: '收到未知格式的响应',
      noValidResponse: '未收到有效响应'
    },
    // TargetDetail 页面相关
    detail: {
      backToList: '返回列表',
      targetDetail: '靶点详情',
      forceGenerate: '强制生成',
      chatReport: '对话报告',
      downloading: '下载中...',
      downloadReport: '下载报告',
      targetInfo: '靶点信息',
      targetName: '靶点名称：',
      targetDescription: '靶点描述：',
      targetType: '任务类型：',
      contractType: '任务类型：',
      priority: '优先级：',
      status: '状态：',
      reportStatus: '报告状态：',
      duration: '生成耗时：',
      cost: '生成花费：',
      sampleReport: '示例报告(不计费)',
      creator: '创建人：',
      createdAt: '创建时间：',
      updatedAt: '更新时间：',
      remark: '备注：',
      none: '无',
      unclassified: '未分类',
      unknown: '未知',
      qaInfo: '问答信息',
      question: '问题：',
      answer: '答案：',
      dataDownload: '数据下载',
      resourceConsumption: '资源消耗',
      tokenConsumption: 'Token消耗',
      searchConsumption: '搜索消耗',
      model: '模型：',
      inputTokens: '输入Token：',
      outputTokens: '输出Token：',
      totalTokens: '总Token：',
      searchCredits: '搜索积分：',
      reportProgress: '报告生成进度',
      refresh: '刷新',
      noLogs: '暂无生成记录',
      chatHistory: '聊天记录',
      enterChat: '进入对话',
      noChatHistory: '暂无聊天记录',
      user: '用户',
      showAll: '显示全部 {count} 条记录',
      collapse: '收起记录',
      reportOutline: '报告大纲',
      expand: '展开',
      collapseOutline: '收起',
      noOutline: '暂无大纲信息',
      showFullOutline: '显示完整大纲 (共 {count} 项)',
      reportRating: '报告评价',
      inProgress: '进行中',
      completed: '已完成',
      failed: '失败',
      startedAt: '开始：',
      completedAt: '完成：',
      invalidTaskId: '无效的任务ID，请重新进入',
      taskIdInvalid: '任务ID无效，请重新选择任务',
      loadFailed: '加载任务信息失败',
      reportGenerateFailed: '报告生成失败',
      refreshChatHistoryFailed: '刷新聊天历史失败',
      cancelSuccess: '已取消报告生成',
      statusNotSupportCancel: '当前状态不支持取消操作',
      taskNotExist: '任务不存在或已被删除',
      cancelFailed: '取消操作失败，请稍后重试',
      reportGenerateStarted: '报告生成任务已启动',
      startReportFailed: '启动报告生成失败',
      fileNotExist: '报告文件不存在或无法生成下载链接',
      downloadCancelled: '下载已取消',
      downloadTimeout: '下载链接生成超时，请稍后重试',
      downloadFailed: '下载报告失败',
      downloadStarted: '{fileType}文件下载开始',
      getDownloadLinkFailed: '获取下载链接失败',
      downloadFileFailed: '下载{fileType}文件失败: {msg}',
      metadata: '元数据',
      noReportContent: '暂无报告内容',
      intelligenceSubscription: '情报订阅',
      intelligenceUpdates: '情报更新',
      intelligenceAccessDeniedTier: '当前会员等级未开放情报订阅功能',
      intelligenceAccessDeniedMenu: '未分配情报订阅权限，请联系管理员在角色菜单中分配',
      intelligenceFeedAccessDeniedTier: '当前会员等级未开放情报更新查看',
      intelligenceFeedAccessDeniedMenu: '未分配情报更新查看权限，请联系管理员在角色菜单中分配'
    },
    intelligence: {
      configTitle: '情报订阅配置',
      feedTitle: '情报更新',
      emptyRunsHint: '启用订阅后将按间隔自动巡检；也可在订阅配置页点击「立即巡检」',
      feedIntroTitle: '巡检结果流',
      feedIntroDesc: '按时间展示报告情报巡检命中与推送记录',
      backToTask: '返回任务',
      viewFeed: '查看更新记录',
      enabled: '启用定时巡检',
      enabledOn: '已启用',
      enabledOff: '未启用',
      scheduleSection: '巡检计划',
      unsavedChanges: '有未保存的更改',
      configSynced: '配置已同步',
      interval: '巡检间隔（分钟）',
      categories: '关注的采集维度',
      catAll: '全部',
      catLiterature: '文献',
      catPatent: '专利',
      catClinical: '临床试验',
      catWeb: '网页',
      catPipeline: '报告流水线',
      channels: '通知渠道',
      chInApp: '通知中心',
      chEmail: '邮件',
      chFeishuHook: '飞书群机器人 Webhook',
      chFeishuUser: '飞书应用消息（需绑定飞书账号）',
      notifyEmail: '通知邮箱（可选，默认任务创建人邮箱）',
      webhookUrl: 'Webhook 地址',
      webhookHint: '在飞书群添加自定义机器人后复制 Hook 地址；保存时选择「更新 Webhook」',
      webhookPreserve: '保持已有 Webhook 不变',
      webhookSet: '更新 Webhook',
      webhookClear: '清除 Webhook',
      save: '保存配置',
      triggerRun: '立即巡检',
      testNotify: '测试通知',
      loadFailed: '加载配置失败',
      saveSuccess: '已保存',
      saveFailed: '保存失败',
      triggerOk: '巡检已执行',
      triggerQueued: '巡检任务已提交',
      testOk: '测试通知已发送（请检查各渠道）',
      emptyRuns: '暂无巡检记录',
      runStatus: '状态',
      runTime: '时间',
      runSummary: '摘要',
      nextRun: '下次计划巡检',
      lastRun: '上次巡检',
      watermark: '日志水位线',
      hintDefaultOff: '默认关闭；启用后按间隔扫描报告日志增量，并按渠道推送。',
      loadMore: '加载更多',
      logEntriesTitle: '日志条目（{count}）',
      webhookConfiguredShort: 'Webhook',
      statusQueued: '排队中',
      statusRunning: '执行中',
      statusSucceeded: '成功',
      statusPartialFailed: '部分失败',
      statusFailed: '失败',
      statusSkipped: '本次无新增',
      statusSkippedDuplicate: '今日已推送过相同内容',
      searchStatsTitle: '检索与过滤统计',
      itemKindExternal: '外部',
      itemKindReportLog: '报告',
      pollRunPending: '巡检任务执行中，请稍候…',
      pollRunTimeout: '巡检仍在后台执行，请稍后在情报更新页查看结果',
      testNotifyPartial: '部分渠道未成功，请查看详情或检查配置',
      triggerFailed: '巡检失败',
      intervalPresets: '常用间隔',
      preset1h: '1 小时',
      preset6h: '6 小时',
      preset24h: '24 小时',
      preset7d: '7 天',
      warnEmailNoCreator: '任务创建人账号未绑定邮箱且未填写通知邮箱时，邮件渠道将无法投递。',
      warnFeishuUser: '任务创建人尚未缓存飞书账号，系统会尝试通过 xtalpi.com 邮箱从飞书通讯录匹配后投递。',
      reportSubscriptionTypeTitle: '报告内容更新订阅',
      reportSubscriptionTypeDesc: '本页用于靶点报告任务：除文献/专利/临床/网络外，还可订阅报告生成流水线日志增量。',
      knowledgeMapSubscriptionHint: '若需按知识地图主题一级分类关键词采集更新，请前往「知识地图 → 订阅更新」配置。',
      notifyDetailTitle: '各渠道推送结果',
      notifyHint: '提示',
      notifyDeliveryOk: '投递成功',
      notifyDeliveryFail: '投递失败',
      notifyAttempted: '已尝试推送',
      webhookUrlPlaceholder: 'https://open.feishu.cn/open-apis/bot/v2/hook/...',
      runTimeRange: '{start} → {end}',
      totalNewLogs: '窗口内日志 {n} 条',
      matchedItems: '命中 {n} 条',
      externalHits: '外部 {n}/{raw}',
      reportLogHits: '报告有效 {n}',
      notifyNoDetailHint: '本次无各渠道明细（未开启通知或无需向渠道推送）。',
      categoriesMutualHint: '「全部」与下方具体维度互斥：勾选「全部」会只保留全部；勾选具体维度时会自动取消「全部」。',
      saveBeforeAction: '当前配置尚未保存，请先保存后再执行巡检或测试通知。'
    }
  },
  targetReportDetail: {
    title: '任务详情',
    backToList: '返回列表',
    interactiveEdit: '交互编辑',
    basicInfo: '基本信息',
    taskName: '任务名称',
    taskDescription: '任务描述',
    reportName: '报告名称',
    reportDescription: '报告描述',
    targetName: '任务名称',
    status: '状态',
    createdAt: '创建时间',
    reportDuration: '任务耗时',
    priority: '优先级',
    inputTokens: '输入Tokens',
    outputTokens: '输出Tokens',
    totalTokens: '总Tokens',
    xCoinConsumption: 'X-Coin消耗',
    resourceConsumption: '资源消耗',
    tokenConsumption: 'Token消耗',
    searchConsumption: '搜索消耗',
    model: '模型',
    searchCredits: '搜索积分',
    outline: '报告大纲',
    questionsAndAnswers: '问答详情',
    question: '问题',
    answer: '回答',
    dataDownload: '数据下载',
    chineseReport: '中文报告',
    englishReport: '英文报告',
    markdownDoc: 'Markdown文档',
    metadataTable: '元数据表格',
    downloading: '下载中...',
    download: '下载',
    regenerate: '重新生成',
    regenerateConfirm: '此操作将重新生成报告并消耗约 {cost} X-Coin。是否确认继续？',
    regenerateConfirmTitle: '确认重新生成',
    regenerateSuccess: '报告生成请求已提交，请稍后查看进度',
    regenerateError: '重新生成报告失败，请稍后重试',
    reportNotReady: '报告尚未生成完成，请稍后再试',
    noQuestionsAnswers: '暂无问答信息',
    noDownloadData: '暂无下载数据',
    reportRating: '报告评价',
    regenerateMessage: '重新生成任务"{name}"的报告',
    priority: {
      high: '高',
      medium: '中',
      low: '低'
    },
    status: {
      pending: '待分析',
      processing: '分析中',
      completed: '已完成',
      failed: '失败',
      cancelled: '已取消'
    },
    messages: {
      invalidTaskId: '无效的任务ID，请重新进入',
      noPermission: '您没有权限查看此任务，可能该任务由其他用户创建',
      targetNotFound: '任务不存在或已被删除',
      loadTargetFailed: '加载任务信息失败，请稍后重试',
      pdfDownloadStarted: 'PDF报告下载开始',
      downloadLinkFailed: '获取下载链接失败',
      downloadReportFailed: '下载报告失败: {msg}',
      fileDownloadStarted: '{fileType}文件下载开始',
      downloadFileFailed: '下载{fileType}文件失败: {msg}'
    }
  },
  
  chat: {
    files: '附件',
    quickReplyConfirm: '确认',
    quickReplyConfirmTip: '点击回复"确认"',
    close: '关闭对话',
    start: '开始对话',
    selectTaskToStart: '请选择一个任务开始对话',
    uploadTip: '上传文件（最大{maxSize}MB）',
    upload: '上传文件',
    fileList: '文件列表',
    thinking: 'AI正在思考中，请稍候...',
    creatingTask: '正在创建任务，请稍候...',
    generatingOutline: '正在生成大纲，请稍候...',
    documentAnalysis: '正在结合引用文档分析，请稍候...',
    confirmingOutline: '正在确认大纲，请稍候...',
    preparingReport: '正在进入报告生成确认...',
    submittingReport: '正在提交报告生成任务...',
    inputPlaceholder: '请输入你的问题...',
    inputRequired: '请输入问题',
    inputTips: '按 Ctrl/Cmd + Enter 发送，Enter 换行',
    switchModel: '切换模型',
    send: '发送',
    newline: '换行',
    getStarted: '开始与AI对话，了解详情',
    resize: {
      leftMin: '左侧面板已达到最小宽度限制',
      rightMin: '右侧面板已达到最小宽度限制'
    },
    welcomeMessage: '在这里我可以帮助您对选中的任务进行深度分析和对话：',
    quickQuestion1: '请介绍一下这个任务的基本信息',
    quickQuestion2: '分析这个任务的市场前景',
    quickQuestion3: '这个任务有哪些竞争优势',
    quickQuestionText1: '请介绍一下这个靶点的基本信息',
    quickQuestionText2: '分析这个靶点的市场前景',
    quickQuestionText3: '这个靶点有哪些竞争优势',
    start: '开始对话',
    close: '关闭对话',
    selectTaskToStart: '请选择一个任务开始对话',
    modelSwitch: {
      title: '温馨提示',
      message: '您已成功切换至【{modelName}】，单次生成所消耗的X-Coin可能产生波动。',
      confirmButtonText: '确定'
    },
    templateLoaded: '已加载模板: {name}{targetInfo}，请发送或修改后发送',
    newTargetSuffix: '（新靶点: {target}）',
    newResearchObjectSuffix: '（调研对象: {object}）',
    createTaskSuccess: '已创建新任务：{name}',
    createTaskFailed: '创建新任务失败：{msg}',
    emptyReply: '接收到空回复，请重试'
  },
  // @文档引用功能
  docMention: {
    selectDocument: '选择引用文档',
    searchPlaceholder: '搜索文件名...',
    tipSelectDoc: '选择文档后，AI将基于文档内容回答问题',
    selectedDocs: '已选文档',
    clearAll: '清空',
    noFiles: '该任务暂无关联文件',
    noMatchedFiles: '没有匹配的文件',
    maxSelectReached: '最多选择 {max} 个文档',
    // 快捷操作按钮
    quickActions: '快捷操作',
    quickPrompts: '快捷指令',
    summarize: '总结',
    translateZh: '译成中文',
    translateEn: '译成英文',
    analyze: '深度分析',
    extract: '抽取要点',
    qa: '问答',
    moreTemplates: '更多',
    // 更多模板选项
    outline: '生成大纲',
    keypoints: '提取关键点',
    compare: '对比分析',
    rewrite: '改写润色',
    expand: '扩展内容',
    simplify: '简化表达',
    // Prompt模板内容
    tplSummarize: '请对以上文档进行全面总结，包括：\n1. 核心主题和主要观点\n2. 关键结论和发现\n3. 重要数据和事实\n请用简洁清晰的语言概括。',
    tplTranslateZh: '请将以上文档内容准确翻译成中文，要求：\n1. 保持原文的结构和格式\n2. 专业术语使用规范译法\n3. 语言流畅自然',
    tplTranslateEn: '请将以上文档内容准确翻译成英文，要求：\n1. 保持原文的结构和格式\n2. 使用专业术语\n3. 语言地道流畅',
    tplExtract: '请从以上文档中抽取以下信息：\n1. 关键数据和指标\n2. 重要结论和发现\n3. 核心观点和论据\n4. 值得关注的细节\n请以结构化的形式呈现。',
    tplAnalyze: '请对以上文档进行深度分析，包括：\n1. 主要论点和论据评估\n2. 逻辑结构和推理过程\n3. 潜在问题和不足之处\n4. 可能的改进建议',
    tplQa: '我想就以上文档内容进行问答。请先告诉我这个文档主要讲了什么，然后我会提出具体问题。',
    tplOutline: '请为以上文档生成详细大纲，包括：\n1. 主标题\n2. 各章节/段落的小标题\n3. 每个部分的核心内容摘要\n使用层级结构清晰展示。',
    tplKeypoints: '请从以上文档中提取5-10个最重要的关键点，每个关键点用一句话概括，并说明其重要性。',
    tplCompare: '请分析以上文档内容，与同类型的研究/报告进行对比，指出其独特之处、优势和不足。',
    tplRewrite: '请对以上文档内容进行改写润色，要求：\n1. 语言更加流畅专业\n2. 结构更加清晰合理\n3. 表达更加精准到位\n保持原意不变。',
    tplExpand: '请对以上文档的核心观点进行扩展，补充相关的背景知识、案例分析和深入解读。',
    tplSimplify: '请用简单易懂的语言重新解释以上文档内容，让非专业人士也能理解，避免使用专业术语。',
    // 输入框相关
    referencedDocs: '引用文档',
    inputWithDocPlaceholder: '请输入针对引用文档的问题或指令...',
    hint: "输入 {'@'} 引用文档",
    defaultPrompt: '请帮我分析以下文档：{files}',
    fileNotIndexed: '该文件仍在入库中或入库失败，请稍后再引用',
    fileNotIndexedWithName: '以下文件未完成入库，请稍后再引用：{files}'
  },
  home: {
    inputPlaceholder: '请输入问题，Ctrl/Cmd + Enter 发送',
    askEpixoraPlaceholder: '向 epiXora 提问，例如：HER2靶点在乳腺癌中的研究进展',
    expertModePlaceholder: '输入深度调研主题或靶点名称，如：PD-L1 或 阿尔茨海默病最新研究进展',
    writeModePlaceholder: '您可以简单描述撰写需求，或上传参考资料；例如：总结上传文献的核心发现',
    greetingMorning: '早上好，{name}！',
    greetingAfternoon: '下午好，{name}！',
    greetingEvening: '晚上好，{name}！',
    greetingDesc: '您可以先提出问题，也可以选择要分析的文档进行深入研究。',
    modes: {
      quick: '快速模式',
      expert: '专家模式',
      write: '撰写模式'
    },
    nav: {
      home: '靶点分析',
      homeShort: '分析',
      homeDesc: '新建对话、三种调研模式、报告预览与历史任务',
      knowledgeBase: '知识库',
      knowledgeBaseShort: '知识库',
      knowledgeBaseDesc: "上传文档、文件夹管理、对话中 {'@'} 引用",
      knowledgeMap: '知识地图',
      knowledgeMapShort: '地图',
      knowledgeMapDesc: '主题 Wiki、脑图、大纲与 3D 图',
      quickTools: '快速工具',
      quickToolsShort: '工具',
      quickToolsDesc: '批量主题调研与模板库'
    }
  },
  historyDrawer: {
    title: '历史调研',
    newChat: '开启新对话',
    searchPlaceholder: '搜索任务名称，或输入任务 ID',
    empty: '暂无历史调研',
    emptySearch: '未找到匹配的任务',
    emptyById: '未找到该任务，或您无权查看',
    untitled: '未命名任务',
    pin: '置顶',
    unpin: '取消置顶',
    delete: '删除',
    pinSuccess: '已置顶',
    pinFailed: '置顶失败，请稍后重试',
    unpinSuccess: '已取消置顶',
    unpinFailed: '取消置顶失败，请稍后重试',
    groups: {
      pinned: '置顶',
      today: '今天',
      yesterday: '昨天',
      within7Days: '7 天内',
      within30Days: '30 天内'
    }
  },
  files: {
    dialogTitle: '任务相关文件列表',
    emptyTip: '您可以通过上传文件按钮为此任务添加文件',
    getListFailed: '获取文件列表失败',
    refreshed: '文件列表已刷新',
    searchPlaceholder: '搜索文件名...',
    selectFirst: '请先选择文件',
    alreadyBoundSelected: '选中的文件均已绑定',
    bindSuccessWithCount: '成功绑定 {count} 个文件',
    bindFailed: '文件绑定失败',
    unsupportedType: '不支持的文件类型，请上传PDF、DOC、DOCX、PPT、PPTX、TXT、MD、CSV、JSON、XML、EML、EPUB、MSG、YAML或PROPERTIES文件',
    sizeExceeded: '文件大小不能超过 {max}',
    uploadSuccessBindFailed: '文件上传成功，但绑定到任务失败: {msg}',
    uploadFailed: '文件上传失败',
    previewFailed: '预览文件失败',
    removeConfirmTitle: '确认移除',
    removeConfirmMessage: '确定要从该任务中移除文件"{name}"吗？',
    removeSuccess: '文件移除成功',
    removeFailed: '移除文件失败',
    downloadFailed: '下载文件失败',
    cloudFilesLimit: '云盘文件总数已达上限（{max}个），请删除部分文件后再上传',
    taskFilesLimit: '当前知识库/会话文件数量已达上限（{max}个），请删除部分文件后再上传',
    uploadPending: '未选择靶点，文件已上传但未绑定',
    checkUploadFailed: '检查上传条件失败，请重试',
    indexStatus: {
      ready: '可引用',
      pending: '入库中',
      failed: '入库失败',
      unknown: '待确认'
    },
    uploadSuccessIndexing: '「{name}」已添加，正在入库（约 1–3 分钟）',
    kbAutoCreateSuccess: '已同步到知识库文件夹「{topic}」',
    kbBindSuccess: '已从知识库添加 {count} 个文件',
    loadKbListFailed: '加载知识库列表失败',
    loadKbFilesFailed: '加载知识库文件失败',
    cleared: '已清空附件',
    difySync: {
      successTitle: '知识库同步成功',
      successMessage: '文件 "{fileName}" 已成功同步到知识库',
      failedTitle: '知识库同步提示',
      failedMessage: '文件 "{fileName}" 已上传到系统，但同步到知识库失败',
      errorTitle: '知识库同步失败',
      errorMessage: '文件 "{fileName}" 同步到知识库时发生错误',
      batchTaskCreatedTitle: '批量上传任务已创建',
      batchTaskCreatedMessage: '正在后台处理，请稍后查看处理结果'
    }
  },
  permission: {
    noAccessManual: '无权限访问使用手册',
    noAccessKnowledgeBase: '无权限访问知识库',
    knowledgeBaseComingSoon: '该功能为【正式版】功能，敬请期待！'
  },
  voice: {
    notSupported: '您的浏览器不支持录音功能',
    recognitionSuccess: '语音识别成功',
    recognitionFailed: '语音识别失败，请重新录音或直接输入文字',
    balanceCheckFailed: '余额检查失败，请稍后重试',
    startRecording: '开始录音...',
    startRecordingFailed: '启动录音失败，请检查麦克风权限',
    stopRecording: '录音结束'
  },
  tenant: {
    switchSuccess: '租户切换成功，正在刷新数据...',
    getUserFailed: '无法获取用户信息，租户切换功能不可用',
    getUserError: '获取用户信息失败，租户切换功能不可用',
    dialogOpenFailed: '打开租户切换对话框失败，请刷新页面后重试'
  },
  urlUpload: {
    title: '通过链接上传文件',
    subtitle: '支持文件链接和网站链接',
    fileUrlLabel: '文件/网站链接',
    fileUrlPlaceholder: '请输入文件URL或网站URL，如：https://example.com/document.pdf',
    customFilenameLabel: '自定义文件名（可选）',
    customFilenamePlaceholder: '如：研究报告.pdf（不填写则自动使用URL中的文件名）',
    customFilenameRequiredPlaceholder: '请输入文件名，如：网站内容.txt',
    formatHint: '支持格式：PDF、Word、Excel、TXT、Markdown等文件，或任意网站链接',
    websiteFilenameHint: '网站链接需要指定文件名',
    tip1: '支持直接访问的文件链接或网站链接',
    tip2: '文件大小不超过{size}MB',
    cancel: '取消',
    submit: '开始上传',
    uploading: '上传中...',
    validation: {
      required: '请输入文件链接或网站链接',
      invalidProtocol: '请使用 HTTP 或 HTTPS 协议',
      noExtension: '未识别到文件扩展名，请确保URL包含完整的文件路径',
      invalidFormat: 'URL格式不正确',
      websiteUrl: 'ℹ 网站链接 - 请指定文件名',
      fileUrl: '✓ 文件链接 - URL格式正确',
      filenameRequired: '网站链接必须指定文件名'
    }
  },
  examples: {
    try: '试试：',
    sample1: 'PRMT5任务的市场空间如何？',
    sample2: '整理一份关于减肥药研发新任务与挑战的分析报告'
  },
  form: { enterTaskName: '请输入任务名称' },
  boundaryClarify: {
    tip: '请选择本次调研的范围：',
    target: '靶点调研',
    overall: '整体调研'
  },
  moduleSelect: {
    tip: '请勾选您需要的报告模块（可多选，支持自定义新增）：',
    confirm: '开始调研'
  },
  report: {
    generating: '正在生成分析报告...',
    generatingReport: '正在生成分析报告...',
    completed: '已完成',
    failed: '失败',
    queueing: '排队中',
    target: {
      noReportContent: '暂无报告内容'
    },
    outlineConfirmedWithTarget: '好的，已收到您确认的大纲，正在提交[{target}]调研分析报告生成任务。报告生成由AI驱动，流程包含文献、专利、临床试验和网络搜索数据收集和分析、智能体协同生成大纲与章节内容以及深度优化。预计耗时 约 30～60 分钟，请您耐心等待。您可关闭当前窗口，任务将自动在后台继续进行。',
    outlineConfirmedNoTarget: '好的，已收到您确认的大纲，正在提交报告生成任务，标题：{topic}，关键词：{keywords}，报告生成由AI驱动，流程包含文献、专利、临床试验和网络搜索数据收集和分析、智能体协同生成大纲与章节内容以及深度优化。预计耗时 约 30～60 分钟，请您耐心等待。您可关闭当前窗口，任务将自动在后台继续进行。',
    preparingNoTarget: '正在为您准备报告生成，标题：{topic}，关键词：{keywords}，报告生成由AI驱动，流程包含文献、专利、临床试验和网络搜索数据收集和分析、智能体协同生成大纲与章节内容以及深度优化。预计耗时 约 30～60 分钟，请您耐心等待。您可关闭当前窗口，任务将自动在后台继续进行。',
    startGeneratingWithTarget: '好的，开始为您生成[{target}]调研分析报告。报告生成由AI驱动，流程包含文献、专利、临床试验和网络搜索数据收集和分析、智能体协同生成大纲与章节内容以及深度优化。预计耗时 约 30～60 分钟，请您耐心等待。您可关闭当前窗口，任务将自动在后台继续进行。',
    cancelledInsufficient: '因账户X-Coin余额不足，取消报告生成，请充值后继续。',
    cancelledByUser: '已取消报告生成。',
    cancelSuccess: '已取消报告生成',
    cancelNotSupported: '当前状态不支持取消操作',
    cancelFailed: '取消操作失败，请稍后重试',
    targetNotFound: '任务不存在或已被删除',
    outlineMissing: '未检测到可用大纲，请重新确认后再试',
    generateFailed: '生成报告失败，请稍后重试',
    generateTitle: '生成分析报告',
    generateConfirm: '确认为"{name}"生成分析报告吗？**这是一个费用较高的操作**。',
    taskStarted: '报告生成任务已启动',
    generationFailed: '生成报告失败',
    generateReportFailed: '报告生成失败，请重试',
    fileMissing: '报告文件不存在或无法生成下载链接',
    downloadFailed: '下载报告失败: {msg}',
    downloadReportFailed: '下载报告失败',
    prepareTimeout: '报告准备超时，文件可能较大，请稍后重试或联系管理员',
    loadPreviewFailed: '加载报告预览失败',
    saveToServerMayFailed: '报告内容保存到服务器可能未成功，请检查',
    saveContentFailed: '报告内容保存失败，修改仅保留在本地',
    emptyReply: '接收到空回复，请重试',
    createTargetFailed: '创建新任务失败：{msg}',
    // 部分报告相关
    partialPreview: '部分预览',
    currentPreview: '当前可预览：',
    pageUnit: '页',
    remainingPages: '剩余 {count} 页未解锁，充值后可查看完整报告',
    unlockNow: '立即解锁',
    partialReportTitle: '您正在查看部分报告',
    partialReportDesc: '剩余 {count} 页未读，充值后可查看和下载完整报告',
    unlockFullReport: '充值阅读全文',
    unlockCostHint: '解锁费用: {cost} X-Coin',
    reportName: '报告名称',
    totalPages: '总页数',
    viewedPages: '已阅读',
    consumed: '本次消耗',
    deducted: '已扣除',
    remainingCost: '剩余需要',
    unlockTip: '解锁后您可以查看和下载完整报告内容',
    confirmUnlock: '立即解锁',
    unlockConfirmMessage: '确认使用 {cost} X-Coin 解锁完整报告？',
    unlockSuccess: '解锁成功！',
    unlockFailed: '解锁失败，请稍后重试',
    // 下载相关
    downloadReport: '下载',
    downloading: '下载中',
    downloadBrief: '导出简报',
    downloadFormats: {
      pdf: 'PDF格式',
      word: 'Word格式',
      markdown: 'Markdown格式',
      html: 'HTML格式'
    },
    downloadMessages: {
      preparing: '正在准备下载{format}报告...',
      pdfStarted: 'PDF文件下载已开始',
      wordStarted: 'Word文件下载已开始',
      markdownStarted: 'Markdown文件下载已开始',
      htmlStarted: 'HTML文件下载已开始',
      pdfOpenedIOS: 'PDF已在新窗口中打开，请使用浏览器的保存功能下载文件',
      pdfWordStaleHint: '报告内容已修改并保存，当前 PDF/Word 为生成时的版本。最新内容请下载 Markdown 或使用编辑器的「导出」功能。'
    },
    // 审核拒绝提示
    rejected: {
      title: '您好，根据系统识别，您本次请求生成的内容包含不宜分发的内容，因此平台无法提供预览或下载。',
      description: '平台建议您：',
      adjustRequest: '调整请求',
      adjustRequestDesc: '建议您调整任务描述或输入信息，并尝试重新生成。',
      requestReview: '人工复核',
      requestReviewDesc: "若您认为判断有误需要进一步的协助，您可以通过 epixora{'@'}xtalpi.com 进行反馈。"
    },
    // Markdown编辑器相关
    pdfPreview: 'PDF预览',
    mdEditor: 'Markdown编辑',
    loadMd: '载入MD报告',
    loadMdSuccess: 'Markdown报告载入成功',
    loadMdFailed: '载入Markdown报告失败',
    noTargetSelected: '请先选择一个任务',
    noPdfAvailable: '暂无PDF报告',
    editMode: '编辑',
    previewMode: '预览',
    splitMode: '分屏',
    export: '导出',
    exportMd: '导出为 Markdown',
    exportHtml: '导出为 HTML',
    exportSuccess: '导出成功',
    noContentToExport: '没有可导出的内容',
    markdown: 'Markdown',
    preview: '预览',
    modified: '已修改',
    editorPlaceholder: '在此输入或粘贴Markdown内容...',
    emptyEditorTip: '点击下方按钮载入报告内容，或直接在编辑器中输入Markdown内容',
    emptyTitle: '开始编辑报告',
    // 文本选择相关
    loadMdTip: '从服务器载入Markdown格式报告',
    editModeTip: '仅显示编辑器',
    previewModeTip: '仅显示预览（可选中文本发送到对话）',
    splitModeTip: '同时显示编辑器和预览',
    selectedChars: '已选择 {count} 字符',
    sendToChat: '发送到对话',
    sendToChatTip: '将选中内容作为上下文发送到对话框',
    sentToChat: '已发送到对话框',
    noTextSelected: '请先选择要发送的文本',
    selectTextTip: '选择文本后可发送到对话作为上下文',
    canSelectText: '可选择文本',
    copyText: '复制文本',
    copySuccess: '已复制到剪贴板',
    more: '更多',
    selectAll: '全选',
    versionHistory: '版本历史',
    reportVersionHistory: '报告版本历史',
    versionCountUnit: '个版本',
    versionLatest: '最新归档',
    versionArchiveTip: '每次保存或回滚前，系统会归档「修改前」的快照（非当前在线版），便于与当前内容对比差异。',
    versionLabel: '版本',
    versionRemark: '备注',
    versionSize: '大小',
    versionViewCompare: '查看并对比',
    versionRestore: '恢复此版本',
    versionRestoreConfirm: '确定要回滚到此版本吗？当前未保存的修改将会丢失。',
    versionNoHistory: '暂无历史版本',
    versionNoHistoryHint: '编辑报告并保存后，系统会自动归档保存前的快照，便于在此查看与对比。',
    versionRefresh: '刷新版本列表',
    versionListLoadFailed: '无法获取历史版本列表',
    versionContentLoadFailed: '无法载入历史版本内容',
    versionManualSaveSuccess: '报告手动保存成功，已归档新版本！',
    versionManualSaveFailed: '手动保存失败，请稍后重试',
    versionRollingBack: '正在恢复到版本 {id}…',
    versionRollbackSuccess: '成功恢复到版本 {id}！',
    versionRollbackFailed: '恢复历史版本失败，请稍后重试',
    versionTypeRollback: '回滚版本',
    versionTypeManual: '手动保存',
    versionTypeAutosave: '自动保存',
    versionTypeHallucinationFix: '幻觉修复',
    versionTypeHallucinationNoRewrite: '幻觉检测（未改写）',
    versionTypeBaseline: '生成初稿',
    versionRestoreBaselineDraft: '恢复生成初稿',
    versionRestoreBaselineEarliest: '恢复最早归档',
    versionRestoreBaselineConfirmDraft: '确定要恢复到报告生成初稿吗？当前未保存的修改将会丢失。',
    versionRestoreBaselineConfirmEarliest: '该报告无生成初稿快照，将恢复到最早归档版本（{versionId}）。当前未保存的修改将会丢失，且内容可能并非原始生成稿。',
    versionBaselineTagDraft: '生成初稿',
    versionBaselineTagEarliest: '最早归档',
    versionBaselineMissing: '未找到可恢复的历史版本',
    versionBaselineRestoreSuccessDraft: '已恢复到报告生成初稿',
    versionBaselineRestoreSuccessEarliest: '已恢复到最早归档版本',
    versionCompareTitle: '历史版本对比预览',
    versionCompareSubtitle: '{id} · {summary}',
    versionCompareBaselineHint: '当前对比：历史快照 {id} ↔ 编辑器中的正文（可能含未归档修改）',
    versionDiffLegend: '− 历史版本  + 当前版本',
    versionDiffCompactOnly: '仅显示变更行',
    versionDiffHideWhitespace: '隐藏空白变更',
    versionDiffShowWhitespace: '显示空白变更',
    versionDiffHideCitationRenumber: '隐藏引用重编号',
    versionDiffShowCitationRenumber: '显示引用重编号',
    versionNoChangesHint: '该归档快照与当前编辑器内容一致；可尝试对比更早的版本查看历史修改。',
    versionRenderCompare: '渲染对比',
    versionDiffHighlight: '差异高亮',
    versionPrevChange: '上一处',
    versionNextChange: '下一处',
    versionChangePos: '{current} / {total}',
    versionChangesTitle: '修改项说明',
    versionDiffFromLine: '差异行 #{line} 起',
    versionNoChanges: '两版本内容一致，无修改项',
    versionCurrentOnline: '当前在线版本',
    versionCurrentEditor: '当前编辑器版本',
    versionHistoryPane: '历史版本 ({id})',
    versionClosePreview: '关闭预览',
    versionRestoreNow: '立即恢复到此版本',
    modelGroupRecommended: '系统推荐',
    modelGroupMembership: '会员档位',
    modelGroupOther: '其他可用',
    switchModelTitle: '切换模型：{model}',
    hallucinationModeSections: '章节模块',
    hallucinationSectionsTooltip: '选择一个或多个报告章节进行局部检测',
    hallucinationNoSectionsTooltip: '未识别到可检测章节，请使用全文或选中内容检测',
    hallucinationSelectSections: '选择检测章节',
    hallucinationSectionsSelected: '已选 {count} 个 · {chars} 字符',
    hallucinationNoMarkdownSections: '未识别到 Markdown 标题章节，请切换为全文检测或先选中正文片段。',
    hallucinationSectionPreview: '待检测章节内容预览',
    hallucinationSelectSectionHint: '请至少选择一个有效章节，或切换为全文模式。',
    hallucinationSectionCount: '{count} 个',
    hallucinationModeTabLabel: '检测模式',
    selectedContentPreview: '待检测内容',
    hallucinationSelectRange: '请选择您的检测范围',
    hallucinationSelectedIntro: '请在报告中选择您想要进行幻觉检测的语句并点击工具栏或上方的幻觉检测按钮则可进行针对选中内容的幻觉检测',
    hallucinationFullTextLogic: '检测逻辑：系统将依次进行参考文献验证、任务分解与智能复核，自动识别疑似幻觉并给出判断依据与文献溯源。',
    editorReadonlyHint: '当前为只读模式，无报告编辑权限',
    regenerateDiffTab: '行级差异',
    regenerateSideTab: '并排预览',
    diffLinesRemoved: '−{n} 行',
    diffLinesAdded: '+{n} 行',
    diffLinesSame: '{n} 行未变',
    diffHunkCount: '{n} 处修改块',
    diffHunkCountHint: '版本对比中的行级差异块数，可能包含引用重编号、空白与版式变化，不等于幻觉修复条数',
    versionHallucinationAppliedCount: '应用 {n} 项修复',
    diffWhitespaceHunkHint: '空白块 {hidden}/{total} 已隐藏',
    diffCitationRenumberHunkHint: '引用重编号 {hidden}/{total} 已隐藏',
    manualSave: '手动保存',
    saveCurrentReport: '保存当前报告内容',
    reloadFromServer: '重新从服务器载入报告',
    addToMapShort: '添加至地图',
    addToMapTip: '将选中内容添加到知识地图',
    copyFailed: '复制失败',
    highlightText: '高亮标记',
    highlightAdded: '已添加高亮标记',
    highlightRemoved: '已取消高亮',
    // 问答和重新生成相关
    ask: '智能问答',
    interactiveEdit: '交互编辑',
    askAboutThis: '针对选中内容提问',
    askDialogTitle: '针对内容提问',
    askDialogSubtitle: '基于选中内容进行深度分析',
    selectedContent: '选中内容',
    yourQuestion: '您的问题',
    questionLabel: '问题',
    questionPlaceholder: '请输入您想问的问题，例如：这段内容的主要观点是什么？',
    quickQuestions: '快捷问题：',
    quickQ1: '这段内容的主要观点是什么？',
    quickQ2: '请解释这段内容的关键术语',
    quickQ3: '这段内容有哪些不足之处？',
    quickQ4: '如何改进这段内容？',
    aiGenerated: 'AI推荐',
    refreshQuestions: '刷新问题建议',
    aiResponse: 'AI回答',
    submitQuestion: '提交问题',
    questionSubmitted: '问题已提交',
    questionFailed: '提问失败，请重试',
    answerSyncedToChat: '回答已同步到问答区，可继续追问',
    questionSentToChat: '问题已发送到问答区',
    questionSentToDock: '问题已发送到报告问答区，请在下方查看回答进度',
    reportQaDockTitle: '报告选中问答',
    reportQaDockHint: '基于报告选中内容的问答记录，刷新后仍可从历史恢复',
    reportQaDockPending: '任务已提交，正在生成回答...',
    detectionDetail: '检测详情',
    latestRecord: '最新',
    historyRecord: '历史记录',
    retrySaveIssues: '重试保存',
    // 报告问答思考步骤
    qaStep1: '分析选中内容',
    qaStep2: '理解用户问题',
    qaStep3: '智能推理分析',
    qaStep4: '生成回答',
    qaAnalyzing: '正在分析内容...',
    qaUnderstanding: '理解问题意图...',
    qaReasoning: '智能推理中...',
    qaGenerating: '生成回答...',
    qaCompleted: '回答生成完成',
    // 问答思考过程相关
    thinkingProcess: 'AI 思考过程',
    thinkingText: '正在思考中...',
    thinkingStep1Title: '解析问题',
    thinkingStep1Detail: '分析用户提问意图',
    thinkingStep2Title: '检索上下文',
    thinkingStep2Detail: '定位选中内容关键信息',
    thinkingStep3Title: '智能推理',
    thinkingStep3Detail: '基于专业知识生成回答',
    thinkingStep4Title: '优化输出',
    thinkingStep4Detail: '整理格式化回答内容',
    regenerate: '重新生成',
    regenerateThis: '重新生成选中内容',
    rewriteIntent: '改写意图',
    regenerateDialogTitle: '智能改写',
    regenerateDialogSubtitle: '基于AI优化选中内容',
    originalContent: '原始内容',
    customInstruction: '自定义指令',
    regenerateInstruction: '修改要求',
    regeneratePlaceholder: '请描述您希望如何修改这段内容，例如：让内容更详细、更简洁、添加数据支持等',
    regenerateStyle: '改写风格',
    styleDetailed: '更详细',
    styleConcise: '更简洁',
    styleProfessional: '更专业',
    styleCustom: '自定义',
    regeneratedContent: '改写结果',
    applyChange: '应用修改',
    discard: '放弃',
    startRegenerate: '开始生成',
    chars: '字符',
    contentTooLong: '选中内容过长，请缩短选择范围后重试',
    regenerateSubmitted: '生成请求已提交',
    regenerateFailed: '重新生成失败，请重试',
    cancelRegenerate: '取消生成',
    regenerateCancelled: '已取消生成',
    changeApplied: '修改已应用',
    optimizingOutputFormat: '正在优化输出格式...',
    // 优化新增
    undoChange: '撤销上次修改',
    undoSuccess: '已撤销修改',
    retry: '重新生成',
    generating: '正在生成回答...',
    generatingContent: '正在生成内容...',
    noResponseReceived: '未收到回答，请稍后重试',
    noTargetForQA: '请先选择目标后再进行问答',
    noContentGenerated: '未生成内容，请重试',
    noTargetForRegenerate: '请先选择目标后再进行重新生成',
    noContentToRegenerate: '没有选中的内容',
    pleaseEnterQuestion: '请输入问题',
    noSelectedContent: '请先选中要提问的内容',
    minCharsForQA: '请至少选中 10 个字符',
    minCharsForRegenerate: '请先选中至少10个字符的内容再进行改写',
    // 幻觉检测相关
    detectHallucination: '幻觉检测',
    hallucinationCheck: '幻觉检测',
    hallucinationDialogTitle: '幻觉检测',
    hallDockTitle: '幻觉修复对话',
    hallucinationStepSelectShort: '选择',
    hallucinationStepConfirmShort: '确认',
    hallucinationStepRunningShort: '检测',
    hallucinationStepResultShort: '结果',
    hallucinationStepSelect: '选择检测范围',
    hallucinationStepConfirm: '确认费用',
    hallucinationStepRunning: '后台分析中',
    hallucinationStepFailed: '检测失败',
    hallucinationStepResult: '查看结果',
    hallucinationPollingStoppedHint: '你已停止等待，检测任务仍在后台执行。可点击刷新查看最新结果。',
    autoTrack: '自动回看',
    autoTrackRunning: '自动追踪中',
    autoTrackLoaded: '已自动加载最新结果',
    autoTrackTimeout: '自动追踪超时，请手动刷新',
    autoTrackDisabled: '自动追踪已关闭',
    manual: '手动',
    viewLatestResult: '查看最新结果',
    copy: '复制',
    refreshNow: '立即刷新',
    stopWaitingKeepRunning: '停止等待（后台继续）',
    backToReport: '返回报告',
    detecting: '检测中...',
    contentInsufficient: '内容不足',
    featureRestricted: '功能受限',
    hallucinationCostHint: '预计消耗 ~800 X-Coin',
    waited: '已等待',
    issuesCount: '个问题',
    hallucinationConfirmHintChat: '确认后将在本对话区显示检测进度与结果',
    hallucinationDetailInReport: '详细对照表与修复操作请在右侧报告预览区查看',
    hallucinationPreviewNotReady: '报告预览未就绪，请确认右侧报告区已加载后重试',
    hallucinationPreviewOpenReport: '报告预览未就绪，请打开右侧报告区后重试',
    hallucinationDataLoadFailed: '未能加载幻觉检测数据，请刷新后重试',
    hallucinationEmbedResultTitle: '幻觉检测结果（报告侧修复）',
    hallucinationSectionsTruncatedHint: '章节较多，仅展示前 24 个；可在报告区切换章节模式查看全部',
    hallucinationAppliedShort: '已处理 {count} 处',
    hallucinationIssueDetails: '问题说明与修改建议',
    detectedIssues: '检测到的问题',
    severityHigh: '高',
    severityMedium: '中',
    severityLow: '低',
    hallucinationTableHeadline: '共有 {count} 处内容建议修改',
    hallucinationTableHeadlineFull: '共有 {count} 处内容建议修改，请确认后决定是否替换',
    hallucinationTableHeadlineMixed: '已确认 {refuted} 处、建议再看 {uncertain} 处',
    hallucinationTableHeadlineMixedFull: '已确认 {refuted} 处、建议再看 {uncertain} 处，请核对后决定是否替换',
    hallucinationIssueCountMixed: '已确认 {refuted} 处，建议再看 {uncertain} 处',
    hallucinationIssueCountRefuted: '已确认 {count} 处',
    hallucinationIssueCountUncertain: '建议再看 {count} 处',
    hallucinationIssueCountTotal: '{count} 处建议修改',
    hallucinationAppliedBanner: '已应用 {count} 处修改',
    hallucinationAppliedBannerFull: '已应用 {count} 处修改，报告内容已更新',
    hallucinationColNo: '序号',
    hallucinationColProblem: '问题语句',
    hallucinationColContext: '上下文内容',
    hallucinationColSuggestion: '重新生成的内容',
    hallucinationColAction: '选择是否替换',
    hallucinationColTools: '操作',
    hallucinationActionReplace: '替换',
    hallucinationActionDelete: '删除',
    hallucinationActionKeep: '保留',
    hallucinationProcessBtn: '处理修改建议',
    hallucinationBatchProcess: '批量处理',
    hallucinationBatchReplaceAll: '全部替换',
    hallucinationBatchKeepAll: '全部保留',
    hallucinationBatchDeleteAll: '全部删除',
    hallucinationBatchHint: '选择替换/删除后点「应用此行」，或不改正文时用「标记误报」；批量可全部替换/删除或仅应用可信项',
    hallucinationApplyingFixes: '正在后台应用修复，请勿关闭页面…',
    hallucinationApplying: '修复应用中',
    hallucinationApplyStepValidate: '校验修复项…',
    hallucinationApplyStepRewrite: 'LLM 改写与参考文献重排…',
    hallucinationApplyStepSave: '保存报告并同步 issues…',
    hallucinationApplyStepSync: '同步检测结果…',
    hallucinationApplyTimeoutHint: '任务可能仍在后台执行，请稍后刷新报告或重新打开幻觉检测历史查看结果。',
    hallucinationApplyPollingStoppedHint: '你已停止等待，修复任务仍在后台执行。可点击刷新查看最新结果。',
    hallucinationApplyCancelledBackend: '已停止等待，修复任务在后台继续，可点击刷新查看结果',
    refreshApplyResult: '刷新修复结果',
    hallucinationApplyResultLoaded: '修复结果已加载',
    hallucinationApplyStillRunning: '修复仍在进行中，请稍后再试',
    hallucinationApplyBackgroundDone: '后台修复已完成，报告已更新',
    hallucinationApplyLocatableOnly: '仅处理可定位项',
    hallucinationApplyTrustedOnly: '仅应用可信修复',
    hallucinationNoTrustedActions: '没有可应用的可信修复项',
    hallucinationSpecialistPolished: '专家抛光',
    hallucinationPostRecheckServerOk: '服务端复核通过 {passed} 项',
    hallucinationPostRecheckServerWarning: '服务端复核：{still}/{candidates} 项仍存疑',
    hallucinationTruncationGuidance: '本次只检查了部分内容，可选中未检查的段落或切换「按章节」再查',
    hallucinationRecheckRollbackNotice: '复核未通过，已自动回滚 {rolled} 处修复',
    hallucinationRecheckRollbackOnly: '修复已回滚，报告保持原状',
    hallucinationContinueWithSections: '切换章节模式补检',
    hallucinationContinueWithSectionsHint: '已预选 {count} 个章节，请确认后开始补检',
    hallucinationTruncationOpenReportPanel: '在报告区选中补检',
    hallucinationTagReplaced: '已替换',
    hallucinationTagDeleted: '已删除',
    hallucinationTagKept: '已保留',
    hallucinationTagDismissed: '误报',
    hallucinationSuggestionTooLong: '建议过长',
    hallucinationRefRenumbered: '参考文献已重排为 {count} 条',
    hallucinationUncitedRemoved: '（移除未引用 {count} 条）',
    openHallucinationInNewPage: '在新页面打开',
    openHallucinationReportPage: '打开检测报告页面',
    hallucinationConfirmHint: '确认后将在本对话框内显示检测进度与结果',
    hallucinationDetecting: '正在核对内容是否准确...',
    hallucinationDetectFailed: '幻觉检测失败',
    hallucinationConnectionError: '无法连接后端服务，请检查：1) 后端是否已启动 2) 网络/代理配置 3) API 地址是否正确',
    minCharsForHallucination: '请先选中至少10个字符的内容，或切换为全文检测模式',
    hallucinationSelectTip: '请先在报告中选中至少 10 个字符，或切换为「全文」模式',
    selectContentPlaceholder: '请先在报告预览中选中至少10个字符，或切换为「全文」模式',
    hallucinationLoadingEstimate: '通常需要 2-5 分钟，请耐心等待',
    hallucinationErrorRetryHint: '请检查网络后点击下方「重试」',
    docTooShortForHallucination: '报告内容过短，无法进行幻觉检测',
    noHallucinationFound: '未发现需要修改的内容',
    issuesFound: '发现可能需要修改的内容',
    noIssuesFound: '未发现需要修改的内容',
    suggestion: '建议',
    refVerification: '参考文献验证',
    referenceVerification: '参考文献验证',
    verified: '通过',
    unverified: '未通过',
    goToCorrect: '去修正',
    hallucinationModeLabel: '检测模式',
    hallucinationModeSelected: '选中内容',
    hallucinationModeFullText: '全文',
    hallucinationSelectTip: '请先在报告预览区选中至少 10 个字符',
    hallucinationFullTextTip: '检查整份报告中的引用、数据和表述是否与公开资料一致',
    hallucinationSelectedTip: '检查您选中的这段文字是否准确、有据可查',
    selectedContentPreview: '待检测内容',
    startHallucinationDetect: '开始检测',
    refreshHallucinationStatus: '刷新状态',
    detectHallucinationTip: '比对公开文献与临床试验信息，检查引用、数据和表述是否准确',
    hallucinationDetectingSteps: '正在核对报告内容，请稍候...',
    hallucinationStepRefs: '正在核对参考文献...',
    hallucinationStepDecompose: '正在逐项检查...',
    hallucinationStepReflection: '正在汇总检查结果...',
    hallucinationUpgradeToUse: '升级会员后可使用幻觉检测',
    editorFeatureDeniedTier: '当前会员等级未开放「{name}」',
    editorFeatureDeniedMenu: '未分配「{name}」菜单权限，请联系管理员',
    editorFeatureDeniedGeneric: '暂无使用该功能的权限',
    editorFeatureNameInteractive: '交互编辑',
    editorFeatureNameHallucination: '幻觉检测',
    editorFeatureNameSelectionQa: '选中问答',
    editorFeatureNameSelectionRegenerate: '选中重写',
    editorFeatureNameSelectionAddToMap: '选中添加至地图',
    detectionCompletedIn: '检测完成',
    seconds: '秒',
    reDetect: '重新检测',
    retryHallucination: '重试',
    hallucinationHistory: '历史检测记录',
    hallucinationHistoryEmpty: '暂无历史记录，点击下方「开始检测」查看结果',
    cancelHallucination: '取消检测',
    hallucinationCancelled: '已取消检测',
    hallucinationCancelledBackend: '已停止轮询，检测任务在后台继续，可点击刷新查看历史记录',
    hallucinationTaskDeduped: '已有检测任务进行中，将继续等待该任务完成',
    hallucinationStaleTask: '检测任务已中断或超时，请重新提交',
    hallucinationStaleTaskHint: '任务已被系统判定为中断；可先刷新检测历史查看失败留痕，或点击重试重新提交',
    hallucinationStaleTaskIdLabel: '任务 ID',
    hallucinationFullscreenCloseConfirm: '幻觉检测进行中，退出全屏将停止等待（后台任务仍会继续）。确定退出全屏吗？',
    hallucinationTimeout: '检测超时，请通过历史记录查看结果',
    hallucinationCanLeaveHint: '可离开页面，稍后通过历史记录查看结果',
    deductFailedForHallucination: '检测完成，但扣费未成功，请及时充值',
    hallucinationConfirmMessage: '幻觉检测将消耗约 800 X-Coin，是否继续？',
    hallucinationConfirmMessageChat: '幻觉检测将消耗较多 token，是否继续？',
    hallucinationBalanceDialogTitle: '幻觉检查确认',
    hallucinationBalanceConfirmTitle: '幻觉检查确认',
    hallucinationBalanceConfirmMessage: '即将进行幻觉检查，预计消耗约 800 X-Coin，是否继续？',
    hallucinationBalanceConfirmButton: '确认进行幻觉检查',
    hallucinationConfirmBtn: '确认',
    hallucinationSkipBtn: '暂不处理',
    hallucinationApplyBtn: '应用',
    hallucinationUserRequestFullText: '我需要针对{report}进行全文幻觉检测',
    hallucinationUserRequestSelected: '请针对「{text}」进行幻觉检测',
    hallucinationUserRequestSections: '我需要针对{report}选定章节进行幻觉检测',
    hallucinationExpandHistory: '查看 {count} 条历史检测',
    hallucinationCollapseHistory: '收起历史检测',
    hallucinationResultCardTitleFull: '全文检查结果（{report}）：发现 {count} 处建议修改的内容，请核对后决定是否替换。',
    hallucinationResultCardTitleSelected: '选中内容检查结果：发现 {count} 处建议修改的内容，请核对后决定是否替换。',
    hallucinationLoadingSelected: '正在核对选中内容...',
    hallucinationLoadingFullText: '正在核对全文内容...',
    hallucinationReportDefault: '深度调研报告',
    hallucinationColActionFull: '选择是否替换表达',
    justNow: '刚刚',
    minutesAgo: '{n}分钟前',
    hoursAgo: '{n}小时前',
    contentTruncatedNotice: '内容已截断：全文共',
    analyzedFirst: '本次仅检测前',
    truncationMayMiss: '后半部分可能未覆盖',
    refVerificationIncomplete: '部分参考文献未能完整核对，涉及引用的句子建议人工再看',
    evidenceEnrichmentNotice: '已补充 {count} 条文献的全文片段，便于对照核对',
    hallucinationUncertainHeadline: '暂未发现明确问题，建议结合最新资料人工浏览',
    verdictUncertain: '证据不足',
    verdictRefuted: '与公开资料不一致',
    verdictNotEnoughEvidence: '暂时无法核实',
    verdictSupported: '与公开资料一致',
    verdictCitationMismatch: '引用错配',
    issueRationaleLabel: '判断依据',
    issueEvidenceLabel: '溯源证据',
    issueEvidenceHintLabel: '证据提示',
    issueContextSnippetLabel: '周边上下文（检测定位）',
    evidenceVerifiedShort: '已验证',
    evidenceSearchShort: '外部检索',
    evidenceUnverifiedShort: '未验证',
    evidenceDirectMatch: '直接证据',
    evidenceCrossLanguageMatch: '跨语言对齐',
    evidenceContextOnly: '关联摘要',
    evidenceSecondarySearch: '换源检索',
    crossLanguageTraceNotice: '已对 {count} 条证据完成中英文术语对齐溯源',
    p4UncertainEvidenceLoopNotice: '不确定项工具闭环：处理 {processed} 项，改判 {updated} 项',
    p5SpecialistPolishNotice: 'Specialist 抛光已增强 {count} 项 refuted 修复',
    evidenceStrengthStrong: '依据充分',
    evidenceStrengthModerate: '依据一般',
    evidenceStrengthWeak: '依据较弱',
    evidenceStrengthNone: '暂无依据',
    confidenceLabel: '把握程度',
    refCoverageNotice: '已核对 {covered}/{expected} 条参考文献，通过 {ok} 条；未覆盖部分建议人工确认。',
    hallucinationPruningNotice: '为加快检查，部分细项已跳过（{detail}）；如需更全面可换检测范围再查。',
    historyIssuesFound: '发现需修改内容',
    historyUncertainFound: '建议人工再看',
    historyNoHallucinationFound: '未发现问题',
    noVerifiableRefs: '未检测到可验证的引用（PMID/DOI/NCT 等）',
    issueTypeCitation: '引用可能有问题',
    issueTypeData: '数据可能有误',
    issueTypeFact: '事实描述可能有误',
    issueTypeOvergeneralization: '说法过于笼统',
    issueTypeAttribution: '归属或来源可能有误',
    issueTypeOther: '其他',
    locateInReport: '定位',
    locateInReportTip: '在报告中定位并选中原文',
    locateReference: '定位文献',
    locateReferenceSuccess: '已定位到报告正文对应位置',
    locateReferenceInPanel: '已定位到参考文献验证列表',
    locateReferenceMissing: '该问题未关联可定位文献',
    locateReferenceNotFound: '未在报告中找到对应文献条目',
    locateReferenceExternal: '已在新标签页打开关联文献',
    secondaryReflectionUpdated: '二次复核',
    claimEvidenceAuditTitle: '主张检索审计',
    locateSuccess: '已定位到原文，请在编辑器中查看选中内容',
    openInNewWindow: '新窗口打开',
    expandLocation: '展开',
    collapseLocation: '收起',
    issueLocation: '原文位置',
    relatedRef: '关联引用',
    correctThisIssue: '修正',
    selectParagraphFirst: '未在报告中定位到该段文字，请先在报告中选中包含该问题的段落后，再点击「去修正」进行批量修正',
    // 自动加载相关
    loadingMd: '正在载入报告...',
    loadingMdTip: '请稍候，正在从服务器获取Markdown报告内容',
    preloadingMdTip: '后台预加载中，即将完成...',
    loadFailed: '载入失败',
    retryLoad: '重新载入',
    createNew: '新建空白报告',
    // 替换相关
    replaceManually: '自动替换失败，请手动替换内容',
    contentCopied: '新内容已复制到剪贴板',
    noRegeneratedContent: '没有可应用的改写内容',
    originalTextLost: '原始选中文本丢失，无法完成替换',
    documentContentError: '文档内容异常，无法完成替换',
    replaceFailedCopied: '自动替换失败，改写内容已复制到剪贴板，请手动粘贴替换',
    manualReplaceHint: '💡 提示：请在编辑器中找到原始内容，删除后粘贴新内容',
    replaceProcessError: '替换过程发生错误',
    autoRestoredContent: '已自动恢复到替换前的内容',
    replaceSuccess: '✅ 替换成功',
    applySuccess: '已自动应用修正',
    replaceExactSuccess: '✅ 精确替换成功',
    replaceAnchorSuccess: '✅ 锚点定位替换成功',
    replaceAiSuccess: '✅ AI智能替换成功',
    referencesOrganized: '，参考文献已整理({count}条)',
    canUndoIn1Min: '，1分钟内可撤销',
    // 改写意图选项
    intent: '意图',
    style: '风格',
    intentAuto: '智能识别',
    intentAutoDesc: 'AI自动判断改写意图',
    intentOptimizeDetail: '不改变内容范围，只优化表达方式',
    intentEnhanceDetail: '保留原内容，补充数据和背景',
    intentReplaceDetail: '可改变主题和论述角度',
    intentOptimize: '优化表达',
    intentOptimizeDesc: '保持原意，优化语言和逻辑',
    intentEnhance: '补充内容',
    intentEnhanceDesc: '围绕主题添加相关信息',
    intentReplace: '完全重写',
    intentReplaceDesc: '用新内容替换选中部分',
    // 改写风格选项
    styleDetailedDesc: '补充细节和论据',
    styleDetailedExample: '添加数据、案例、背景',
    styleConciseDesc: '精简冗余保留核心',
    styleConciseExample: '去除修饰、直达要点',
    styleProfessionalDesc: '使用专业术语表达',
    styleProfessionalExample: '规范用词、学术风格',
    styleAccessible: '更通俗',
    styleAccessibleDesc: '易于理解的表达',
    styleAccessibleExample: '生活化、口语化表达',
    styleCustomDesc: '按您的要求改写',
    styleCustomExample: '完全自由定制',
    // 改写思考步骤
    rewriteStep1: '解析原文',
    rewriteStep1Detail: '分析原始内容结构',
    rewriteStep2: '理解意图',
    rewriteStep2Detail: '应用"{style}"改写策略',
    rewriteStep3: '智能改写',
    rewriteStep3Detail: '调用AI模型重新组织内容',
    rewriteStep4: '格式优化',
    rewriteStep4Detail: '保持Markdown格式输出',
    preparingRewrite: '正在准备改写...',
    parsingOriginal: '正在解析原文结构...',
    callingAiModel: '正在调用AI模型改写...',
    optimizingFormat: '正在优化输出格式...',
    extractContentFailed: '未能提取到改写内容',
    rewriteInProgress: '正在改写中...',
    // 应用替换步骤
    applyStep1: '精确定位',
    applyStep1Detail: '在文档中定位选中内容',
    applyStep2: '智能替换',
    applyStep2Detail: '将改写内容替换到正确位置',
    applyStep3: '参考文献处理',
    applyStep3Detail: '合并、去重、重新编号',
    applyStep4: '格式优化',
    applyStep4Detail: '修复标题、列表等格式问题',
    applyStepNoProcess: '无需处理',
    applyStepFrontendNoProcess: '前端方案无需处理',
    frontendReplaceRefHint: '本次使用前端替换方案，参考文献未自动整理。若选中内容含引用，请检查参考文献格式与编号。',
    methodExactMatch: '精确匹配替换',
    methodNormalizedMatch: '规范化匹配替换',
    methodPositionMatch: '位置替换',
    methodAnchorMatch: '锚点匹配替换',
    methodApiSuccess: '使用{method}方法定位',
    methodApiFailedFallback: 'API失败，使用前端方案',
    methodApiErrorFallback: 'API异常，使用前端方案',
    contentReplacedCorrectly: '内容已替换到正确位置',
    formatOptimized: '格式已优化',
    // 对比预览
    diffPreviewTitle: '替换对比预览',
    willBeReplaced: '将被替换',
    afterReplace: '替换后',
    rewriteContent: '改写内容',
    undoHint: '刚刚的替换可以撤销',
    // AI改写过程
    aiRewriteProcess: 'AI 改写过程',
    editModeHint: '编辑模式 - 修改改写内容',
    editRegeneratedContent: '编辑改写内容...',
    rewriteLabel: '改写:',
    // 章节索引相关
    tableOfContents: '章节索引',
    expandToc: '展开目录',
    collapseToc: '收起目录',
    noHeadings: '暂无章节',
    noHeadingsTip: '使用 # ## ### 创建标题',
    searchHeading: '搜索章节...',
    noSearchResult: '无匹配结果',
    tocLevel1: '一级',
    tocLevel2: '二级',
    tocLevel3: '三级',
    clickToHideLevel: '点击隐藏{level}标题',
    clickToShowLevel: '点击显示{level}标题',
    // 改写对话框额外
    intentDescription: '意图说明:',
    intentAutoLabel: '智能识别',
    intentAutoDetail: 'AI自动分析您的要求',
    intentOptimizeLabel: '优化表达',
    intentOptimizeDetail2: '保持原意，只改进表达',
    intentEnhanceLabel: '补充内容',
    intentEnhanceDetail2: '添加相关信息和细节',
    intentReplaceLabel: '完全重写',
    intentReplaceDetail2: '可改变主题和角度',
    selectOneStyle: '选择一种风格',
    recommended: '推荐',
    previewModeView: '预览模式 - 查看渲染效果',
    supportMarkdown: '支持 Markdown，Ctrl+E 切换模式，Ctrl+Enter 应用',
    originalLabel: '原文:',
    processingIntelligently: '正在智能处理...',
    discardBtn: '放弃',
    diffPreviewBtn: '对比预览',
    regenerateBtn: '重新生成',
    applyChangeBtn: '应用修改',
    appliedToReport: '已成功应用到报告',
    autoCloseIn: '{seconds}秒后自动关闭',
    closeNow: '立即关闭',
    exitFullscreen: '退出全屏',
    fullscreenMode: '全屏模式',
    originalContentLabel: '原始内容',
    originalLength: '原始长度:',
    newContentLength: '新内容长度:',
    changeLabel: '变化:',
    charUnit: '字符',
    closeBtn: '关闭',
    confirmApply: '确认应用',
    undoBtn: '撤销',
    ignoreBtn: '忽略',
    undoApply: '已撤销应用',
    refNotFound: '未找到参考文献 [{refId}]，可能报告中没有参考文献列表',
    refNotFoundScrollTip: '已滚动至文档末尾，请在报告末尾补充参考文献列表',
    refNotFoundScrollToRefSection: '已滚动至参考文献区域，请检查编号是否正确',
    currentChapter: '当前章节: {chapter}',
    fetchQuestionsFailed: '获取问题失败',
    selectTextToCopy: '请先选择要复制的文本',
    reportFileNotExist: '报告文件不存在，请先生成报告',
    networkFailed: '网络连接失败，请检查网络',
    contentEmpty: '内容为空',
    pageNumber: '第 {current} 页 / 共 {total} 页',
    exportDate: '导出日期：{date}',
    platformGenerated: '本文档由 AI4S 平台自动生成',
    mdToHtmlFailed: 'Markdown转换HTML失败',
    cannotFindPdfContainer: '无法找到PDF内容容器',
    unknownError: '未知错误',
    pdfInvalidFormat: 'PDF文件格式无效或已损坏',
    pdfViewerLoadFailed: 'PDF查看器加载失败',
    newReport: '新报告',
    startWriting: '开始编写您的报告内容...',
    renderError: 'Markdown渲染错误',
    requestTimeout: '请求超时',
    modelCallFailed: '模型调用失败',
    locatedWith: '使用{method}方法定位',
    apiReturnFailed: 'API返回失败',
    apiCallError: 'API调用异常',
    proxyError: '代理接口: {msg}',
    ossError: 'OSS接口: {msg}',
    legacyError: 'Legacy接口: {msg}',
    pdfViewerComponentFailed: '无法加载PDF查看器组件',
    // NetworkStatus
    networkDisconnected: '网络连接已断开',
    networkDisconnectedDesc: '您的网络连接已断开，部分功能可能无法正常工作。',
    retryConnection: '重试连接',
    backendUnavailable: '后端服务暂时不可用',
    backendUnavailableDesc: '服务器响应异常，部分功能可能受到影响。我们正在努力恢复。',
    // FileDisplay
    previewable: '可预览',
    previewBtnLabel: '预览',
    downloadBtnLabel: '下载',
    deleteBtnLabel: '删除',
    noFiles: '暂无文件',
    fileTypeImage: '图片',
    fileTypeDocument: '文档',
    fileTypeVideo: '视频',
    fileTypeAudio: '音频',
    fileTypeOther: '其他',
    fileTypeUnknown: '未知',
    openFileFailed: '打开文件失败: {msg}',
    downloadFileFailed: '下载文件失败: {msg}',
    confirmDeleteFile: '确定要删除文件 "{name}" 吗？',
    confirmDeleteTitle: '确认删除',
    fileDeleted: '文件 "{name}" 已删除',
    deleteFileFailed: '删除文件失败: {msg}',
    // AuthStatusMonitor
    loginNow: '立即登录',
    renewLogin: '续期登录',
    dismissTemporarily: '暂时忽略',
    loginExpiringSoon: '登录即将在{minutes}分钟内过期',
    loginWillExpire: '登录将在{minutes}分钟后过期',
    loginExpired: '登录已过期',
    expiringSoon: '即将过期',
    loginNormal: '登录正常',
    expired: '已过期',
    hoursMinutes: '{hours}小时{minutes}分钟',
    minutesUnit: '{minutes}分钟',
    reloginConfirmMsg: '即将跳转到登录页面，当前页面的未保存数据可能会丢失。',
    confirmRelogin: '确认重新登录',
    continueBtn: '继续',
    statusRefreshed: '状态已刷新',
    tokenValid: 'Token有效',
    tokenInvalid: 'Token无效',
    clearAuthConfirmMsg: '确定要清除所有认证数据吗？这将导致立即退出登录。',
    confirmClear: '确认清除',
    authDataCleared: '认证数据已清除',
    // 导出相关
    exportWord: '导出为 Word',
    exportPdf: '导出为 PDF',
    exporting: '正在导出...',
    preparingPdf: '正在准备PDF，请在打印对话框中选择"另存为PDF"...',
    generatingPdf: '正在生成PDF文件，请稍候...',
    noContentToExport: '没有可导出的内容，请先加载Markdown报告',
    exportFailed: '导出失败',
    // F1 一句一溯源 (citation traceability)
    citationTraceTitle: '溯源详情',
    citationRefLabel: '参考文献 [{refId}]',
    citationPassagesLabel: '原文片段：',
    citationSyntheticAlert: '原文证据暂不可用，以下为根据元数据合成的概述内容，仅供参考。',
    citationDataType: {
      europepmc_article: '文献 · EuropePMC',
      pmc_article: '文献 · PMC',
      openalex_work: '文献 · OpenAlex',
      biorxiv_article: '预印本 · bioRxiv',
      arxiv_article: '预印本 · arXiv',
      google_patent: '专利 · Google Patents',
      drug_products: '药品信息',
      drug_registration: '药品注册',
      clinical_trial: '临床试验',
      web_page: '网页'
    },
    addToKnowledgeMap: '添加到知识地图',
    // P1-C 分析进度路径 chip
    progressRouteRemote: '深度调研模式',
    progressRouteLocal: '快速生成模式',
    progressRouteRemoteTooltip: '当前报告由深度调研引擎生成，数据收集与分析更全面，耗时较长',
    progressRouteLocalTooltip: '当前报告由快速生成引擎生成，速度较快'
  },
  outline: {
    editTemplate: '编辑大纲模板',
    saveTemplate: '保存大纲模板',
    templateName: '模板名称',
    templateNamePlaceholder: '请输入模板名称，如：通用调研分析大纲',
    templateDesc: '模板描述',
    templateDescPlaceholder: '简要描述这个大纲模板的用途和特点',
    templateIcon: '模板图标',
    selectIcon: '选择图标',
    templateColor: '模板颜色',
    promptTemplate: '引导提示语',
    promptTemplatePlaceholder: '使用模板时的引导语，将添加在大纲后面',
    promptTemplateHint: '使用此模板时，系统会在大纲后添加此引导语，指导AI参考此大纲格式生成新的大纲',
    tags: '标签',
    addTag: '+ 添加标签',
    outlineContent: '大纲内容',
    outlinePreview: '大纲预览',
    addToFavorite: '添加到收藏',
    openShareAfterSave: '保存后立即设置共享',
    publicShare: '公开分享（其他用户可以使用）',
    saveChanges: '保存修改',
    nameRequired: '请输入模板名称',
    nameLengthLimit: '模板名称长度在2到100个字符之间',
    templateUpdated: '模板已更新',
    templateSaved: '大纲模板已保存',
    saveFailed: '保存失败，请重试',
    chapterDescription: '章节描述',
    contentPlan: '内容生成方案',
    confirmButton: '确认大纲',
    confirmTip: '确认大纲后进入报告生成确认',
    editOutline: '编辑大纲',
    changePerspective: '换个角度',
    saveAsTemplate: '存为模板',
    saveAsNewTemplate: '另存为新模板',
    updateTemplate: '更新模板',
    updateTemplateConfirm: '确定要更新当前模板吗？',
    updateOriginalTemplate: '更新原模板',
    saveUpdate: '保存更新',
    updateSuccess: '模板已更新',
    updateFailed: '更新模板失败，请稍后重试',
    updateNoTemplate: '当前会话未应用模板',
    saveTip: '存为通用模版（自动替换调研对象为【ENTITY】占位符），方便复用到其他任务',
    tag: '大纲',
    noOutlineContent: '未找到大纲内容',
    noQuickOutlineContent: '未找到可保存的快速调研内容',
    saveDialog: {
      generalizedDescription: '由「{target}」泛化保存，含占位符 {entity}',
      currentTask: '当前任务',
      targetOutlineName: '{name}分析大纲',
      tagGeneric: '通用模版',
      tagPlaceholder: '占位符',
      noSaveableContent: '当前没有可保存的大纲内容',
      quickTemplateName: '{name}快速调研问题框架',
      quickTemplateNameDefault: '快速调研问题框架'
    },
    cardEditor: {
      switchedBack: '已切换回原大纲'
    },
    templateEditor: {
      moduleSectionTitle: '报告模块配置',
      moduleSectionHint: '编辑模块名称与子项，可添加自定义模块与子项',
      questionSectionTitle: '调研问题配置',
      questionSectionHint: '编辑问题标题与期望了解方面，可添加自定义问题',
      addModule: '添加模块',
      addSubItem: '添加子项',
      moduleTitlePlaceholder: '如：机制与通路',
      subItemPlaceholder: '请描述该模块需要覆盖的调研要点与生成要求',
      questionTitlePlaceholder: '如：在研药物及阶段',
      questionDetailPlaceholder: '请说明期望了解的方面，如药物名称、最高阶段、企业、适应症等',
      previewTitle: '报告结构预览',
      previewEmpty: '填写模块名称与子项后，将在此实时预览报告结构',
      moduleFallback: '模块',
      subItemFallback: '子项 {index}',
      saveTemplate: '保存模版',
      moduleRequired: '请至少配置一个模块或问题',
      subItemRequired: '请为第 {index} 个模块填写至少一个子项或期望了解方面',
      dragSort: '拖动排序',
      quickDefaultPrompt: '请按以上问题框架生成调研问题清单，并开展快速调研。',
      quickFrameworkTitle: '快速调研问题框架',
      quickTopicLabel: '主题',
      quickMaxQuestions: '快速模式问题数量不能超过 {max} 个',
      quickMinQuestions: '快速模式问题数量不能少于 {min} 个',
      quickQuestionCountRange: '快速模式问题数量需在 {min} 到 {max} 个之间',
      defaults: {
        expert: [
          {
            title: '机制与通路',
            children: ['请深入阐述靶点相关信号通路、关键生物学节点、上下游调节机制，并引用核心文献支撑机制结论。']
          },
          {
            title: '临床证据评估',
            children: ['请系统检索并整理与该主题相关的临床研究、试验读出、疗效安全性数据，并标注证据强度。']
          },
          {
            title: '差异化策略',
            children: ['请从适应症定位、作用机制、联合用药和专利布局等角度，提炼差异化竞争要点。']
          }
        ],
        quick: [
          {
            title: '靶点概述',
            children: ['请简要介绍该靶点的生物学功能、疾病关联及成药历史。']
          },
          {
            title: '在研药物及阶段',
            children: ['请列出全球进入临床阶段的药物名称、最高阶段、企业、适应症和相关里程碑。']
          },
          {
            title: '竞争格局',
            children: ['请总结主要竞争企业、差异化策略及近期关键临床/readout 事件。']
          }
        ]
      }
    },
    selectTemplate: '选择大纲模板',
    selectTemplateBtn: '大纲模板',
    searchTemplate: '搜索大纲模板...',
    myTemplates: '我的模板',
    recentUsed: '最近使用',
    favorites: '收藏',
    noTemplates: '暂无大纲模板',
    emptyTip: '在聊天确认大纲后可保存为模板',
    outlineOnHomepageTip: '请先输入问题创建任务后，再使用大纲模板',
    usedTimes: '使用{count}次',
    useTemplate: '使用模板',
    favorite: '收藏',
    unfavorite: '取消收藏',
    preview: '预览',
    newTargetOptional: '调研对象（可选）',
    enterNewTarget: '输入调研对象名称，如 KRAS、非小细胞肺癌、mRNA 疫苗技术',
    newTargetTip: '如果输入调研对象，系统将基于所选大纲模板为该对象生成类似结构的大纲',
    researchObjectOptional: '调研对象（可选）',
    enterResearchObject: '输入调研对象名称，如 KRAS、非小细胞肺癌、mRNA 疫苗技术',
    researchObjectTip: '如果输入调研对象，系统将基于所选大纲模板为该对象生成类似结构的大纲',
    researchObjectHomepageHint: '当前尚未创建任务，请手动输入调研对象（如 KRAS、非小细胞肺癌），否则占位符无法正确替换',
    researchObjectRequiredOnHomepage: '请填写调研对象，或先发送首条消息创建任务后再使用大纲模板',
    useThis: '使用此模板',
    templateCount: '{count}个模板',
    allTemplates: '全部模板',
    publicTemplates: '公共模板',
    // 共享相关
    sharedToMe: '共享给我',
    sharedToUsers: '已共享给用户',
    sharedToTenants: '已共享给组织',
    public: '公开',
    publicTemplate: '公开模板',
    sharedTemplate: '共享模板',
    sharedBy: '由 {name} 共享',
    shareSettings: '共享设置',
    shareUpdated: '共享设置已更新',
    accessControl: '访问权限',
    privateAccess: '私有',
    privateDesc: '仅自己可见和使用',
    shareToUsers: '共享给用户',
    shareToUsersDesc: '选择特定用户进行共享',
    shareToTenants: '共享给组织',
    shareToTenantsDesc: '共享给整个组织的所有成员',
    publicAccess: '公开',
    publicDesc: '所有用户都可以查看和使用',
    selectUsers: '选择用户',
    selectTenants: '选择组织',
    searchUsers: '搜索用户...',
    searchUsersByNameOrEmail: '输入用户名或邮箱搜索',
    searchUsersHint: '请输入用户名或邮箱后搜索',
    searchTenants: '搜索组织...',
    permission: '权限',
    viewOnly: '仅查看',
    canUse: '可使用',
    canEdit: '可编辑',
    noResults: '暂无结果',
    pleaseSelectTargets: '请选择共享目标',
    saveFailed: '保存失败',
    loadFailed: '加载失败',
    addedToFavorites: '已添加到收藏',
    removedFromFavorites: '已取消收藏',
    useFailed: '使用模板失败',
    templateApply: {
      quickWithEntity: '请参考以下快速调研问题框架，围绕「{entity}」开展调研：\n\n{outline}\n\n{prompt}',
      quickWithCurrentTarget: '请参考以下快速调研问题框架，围绕当前调研对象「{target}」开展调研：\n\n{outline}\n\n{prompt}',
      quickGeneric: '请参考以下快速调研问题框架开展调研：\n\n{outline}\n\n{prompt}',
      expertWithEntity: '请参考以下大纲模板，为调研对象「{entity}」生成类似结构的分析大纲：\n\n{outline}\n\n{prompt}',
      expertWithCurrentTarget: '请参考以下大纲模板，为当前调研对象「{target}」生成类似结构的分析大纲：\n\n{outline}\n\n{prompt}',
      expertGeneric: '请参考以下大纲模板生成分析大纲：\n\n{outline}\n\n{prompt}'
    },
    manager: {
      title: '大纲模版管理',
      subtitle: '管理专家模式保存的大纲结构，支持共享与复用',
      newTemplate: '新建大纲模版',
      searchPlaceholder: '搜索模版名称、描述或调研对象',
      gridView: '网格',
      listView: '列表',
      totalCount: '共 {count} 个模版',
      emptyDesc: '暂无大纲模版，可在专家模式确认大纲后存为模板',
      shareSettings: '共享设置',
      previewAction: '预览',
      usageCount: '使用 {count} 次',
      genericPlaceholder: '通用占位符',
      use: '使用',
      editTemplateTitle: '编辑模版',
      createTemplateTitle: '新建模版',
      outlineMarkdown: '大纲内容（Markdown）',
      placeholderHint: '占位符：{entity} 调研对象（靶点、技术、适应症等；与保存泛化效果一致）',
      outlinePlaceholder: '支持 Markdown；使用【ENTITY】表示调研对象',
      useTemplateTitle: '使用大纲模版',
      useTemplateIntro: '将「{name}」应用到当前任务。可指定调研对象以替换模版中的 {entity}。',
      researchObjectLabel: '调研对象（替换 {entity}，可选）',
      researchObjectPlaceholder: '留空则使用当前任务名称，如 KRAS、非小细胞肺癌',
      useFallbackHint: '留空将使用当前任务名称「{name}」',
      confirmUse: '确认使用',
      nameRequired: '请输入模版名称',
      outlineRequired: '请输入大纲内容',
      created: '大纲模版已创建',
      updated: '大纲模版已更新',
      deleteConfirm: '确定删除大纲模版「{name}」吗？',
      deleteConfirmTitle: '删除确认',
      deleted: '已删除',
      deleteFailed: '删除失败',
      favoriteAdded: '已收藏',
      favoriteRemoved: '已取消收藏',
      actionFailed: '操作失败',
      publicTemplate: '公开模版',
      sharedTemplate: '共享模版',
      sharedBy: '由 {name} 共享',
      defaultTemplateName: '通用调研分析大纲',
      defaultTemplateDesc: '示例模版：章节结构使用【ENTITY】占位符，可替换为任意调研对象'
    }
  },
  tooltips: {
    fileManagement: '附件管理',
    viewBoundFiles: '查看已绑定的文件',
    chooseFile: '选择文件'
  },
  buttons: {
    cancel: '取消',
    confirm: '确定',
    close: '关闭',
    refreshList: '刷新列表',
    preview: '预览',
    download: '下载',
    remove: '移除',
    localUpload: '本地上传',
    uploadList: '上传列表',
    linkUpload: '链接上传',
    cloudSelect: '从网盘选择',
    kbSelect: '从知识库选择',
    create: '创建',
    update: '更新',
    joinNow: '立即加入'
  },
  dialog: {
    editKnowledgeBase: '编辑知识库',
    createKnowledgeBase: '创建知识库',
    nameLabel: '名称',
    namePlaceholder: '请输入知识库名称',
    descriptionLabel: '描述',
    descriptionPlaceholder: '请输入知识库描述（可选）',
    confirmDelete: '确认删除',
    deleteMessage: '确定要删除知识库"{name}"吗？此操作不可恢复。',
    deleteFileMessage: '此操作将永久删除文件 "{name}"，且不可恢复。是否继续？',
    delete: '删除',
    validation: {
      nameRequired: '请输入知识库名称',
      nameLength: '名称长度在 1 到 50 个字符',
      nameEmpty: '知识库名称不能为空'
    }
  },
  upgrade: {
    title: '升级Pro会员，解锁你的专属知识库',
    subtitle: '生成报告前加入你的专属内容，为你提供更有针对性的报告内容',
    uploadTooltip: '升级至Pro会员即可上传文件'
  },
  targetStatusTooltips: {
    pending: '报告开始生成之前',
    processing: '报告生成中',
    success: '报告已成功生成',
    failed: '报告生成失败',
    // 中文状态key（与代码中的状态值对应）
    '待分析': '报告开始生成之前',
    '分析中': '报告生成中',
    '已完成': '报告已成功生成',
    '失败': '报告生成失败',
    '已取消': '已取消',
    unknown: '未知状态'
  },
  filesExt: {
    noBoundFiles: '该任务暂无绑定文件',
    noMatched: '未找到匹配的文件',
    tryDifferentKeywords: '请尝试使用其他关键词搜索',
    columns: {
      id: 'ID',
      name: '文件名',
      size: '大小',
      uploadTime: '上传时间'
    }
  },
  kb: {
    backToAnalysis: '返回分析',
    list: '知识库列表',
    title: '知识库管理',
    subtitle: '创建和管理您的知识库文档',
    searchPlaceholder: '搜索知识库名称...',
    files: '个文件',
    empty: '暂无知识库',
    noDescription: '暂无描述',
    preview: '预览',
    open: '打开',
    download: '下载',
    remove: '移除',
    renameFile: '重命名文件',
    renameFilePrompt: '新文件名',
    noFiles: '该知识库暂无文件',
    uploadFirst: '上传第一个文件',
    upload: '上传文件',
    uploadFormatSizeHint: '支持 PDF、DOC、DOCX、TXT、MD 等格式，单文件最大 {max}MB',
    uploadSupportedTypes: '支持 {types} 等格式',
    uploadMaxFileSize: '单文件最大 {max}MB',
    uploadPerKbLimit: '单知识库最多 {max} 个文件',
    uploadTotalLimit: '总计最多 {max} 个文件',
    batchUploading: '正在上传 {count} 个文件，请稍候...',
    related: '关联任务',
    noLinkedTargets: '暂无绑定任务',
    searchFilePlaceholder: '搜索文件名...',
    editKB: '编辑知识库',
    createKB: '创建知识库',
    folderListTitle: '主题文件夹',
    newFolder: '新建文件夹',
    noMatchedFolder: '没有匹配的文件夹',
    sourceAuto: '自动归档',
    fileCount: '{count} 个文件',
    reportCount: '{count} 份报告',
    updatedAt: '更新于 {time}',
    selectedCount: '已选 {count} 项',
    selectedSuffix: ' 个已选择',
    batchMode: '批量操作',
    batchDelete: '批量删除',
    sortLabel: '排序',
    moveTo: '移动到',
    removeFromFolder: '移出文件夹',
    selectFolderHint: '请选择左侧文件夹查看资料',
    uploadTargetTip: '将上传到主题文件夹：{name}',
    uploadDragHint: '将文件拖到此处，或',
    uploadClickHint: '点击上传',
    moveTip: '将 {count} 个文件从「{from}」移动到：',
    noTargetFolder: '暂无可选的目标文件夹，请先创建',
    sort: {
      recentUpdate: '最近更新',
      createdAt: '创建时间',
      name: '名称',
      updatedDesc: '按更新时间 (新→旧)',
      updatedAsc: '按更新时间 (旧→新)',
      nameAsc: '按名称 (A→Z)',
      nameDesc: '按名称 (Z→A)'
    },
    col: {
      name: '文件名',
      type: '类型',
      size: '大小',
      status: '入库状态',
      updatedAt: '更新时间'
    },
    form: {
      name: '名称',
      description: '描述',
      namePlaceholder: '请输入知识库名称',
      fileBaseNamePlaceholder: '输入文件名',
      fileNamePlaceholder: '请输入文件名',
      descriptionPlaceholder: '请输入知识库描述（可选）'
    },
    validation: {
      nameRequired: '请输入知识库名称',
      nameLength: '名称长度在 1 到 50 个字符',
      nameNotEmpty: '知识库名称不能为空',
      nameDuplicate: '已存在同名文件夹，请更换名称',
      fileNameRequired: '请输入文件名',
      fileNameLength: '文件名不能超过 255 个字符',
      fileNameNoPathSeparator: '文件名不能包含路径分隔符',
      fileNameExtensionUnchanged: '重命名不能修改文件扩展名 {ext}',
      fileTooLarge: '文件「{name}」超过单文件 {max}MB 限制',
      currentKbFull: '当前知识库最多可上传 {max} 个文件',
      totalFull: '所有知识库最多可上传 {max} 个文件',
      folderQuotaExceeded: '当前文件夹剩余可上传 {remaining} 个文件，本次选择 {count} 个，已超出上限',
      totalQuotaExceeded: '总文件剩余可上传 {remaining} 个，本次选择 {count} 个，已超出上限'
    },
    messages: {
      updateSuccess: '知识库更新成功',
      createSuccess: '知识库创建成功',
      deleteConfirmTitle: '确认删除',
      deleteConfirmMessage: '确定要删除知识库"{name}"吗？此操作不可恢复。',
      deleteSuccess: '知识库删除成功',
      noPermission: '无权访问此内容',
      fetchFailed: '获取内容失败，请重试',
      uploadSuccess: '文件 {name} 上传成功',
      uploadBatchSuccess: '上传完成：成功 {ok} 个，失败 {fail} 个',
      uploadAllFailed: '所有文件上传失败，请重试',
      downloadStart: '文件下载开始',
      removeFileConfirmTitle: '确认删除',
      removeFileConfirmMessage: '此操作将永久删除文件 "{name}"，且不可恢复。是否继续？',
      removeBatchConfirmMessage: '确定要从当前文件夹移出选中的 {count} 个文件吗？',
      removeBatchSuccess: '移出完成：成功 {ok} 个，失败 {fail} 个',
      fileDeleted: '文件已删除',
      moveSuccess: '移动完成：成功 {ok} 个，失败 {fail} 个',
      moveAllFailed: '操作全部失败，请稍后再试',
      renameSuccess: '文件重命名成功',
      batchDeleteFolderConfirm: '确定删除已选 {count} 个文件夹吗？',
      batchDeleteFolderSuccess: '成功删除 {ok} 个文件夹，失败 {fail} 个',
      batchDeleteFolderFailed: '批量删除失败，共 {fail} 个'
    },
    relative: {
      justNow: '刚刚',
      minutesAgo: '{count}分钟前',
      hoursAgo: '{count}小时前',
      daysAgo: '{count}天前',
      weeksAgo: '{count}周前',
      monthsAgo: '{count}个月前'
    },
    // 文件处理状态
    fileStatus: {
      pending: '待处理',
      uploading: '上传中',
      processing: '处理中',
      completed: '已完成',
      failed: '失败'
    },
    closeConfirm: {
      title: '文件状态确认',
      message: '为确保您的【报告生成】与【智能问答】的最佳效果，请确认：',
      point1: '您所需的所有文件状态均已显示"上传成功"。',
      point2: '上传失败的文件已得到处理。',
      point3: '您可以在任务面板中检查对应文件状态。',
      button: '确认'
    }
  },
  knowledgeMap: {
    v2: {
      searchPlaceholder: '模糊搜索主题名称...',
      pinnedTopics: '置顶主题',
      allTopics: '全部主题',
      noTopicsFound: '未找到主题',
      newTopic: '新建主题',
      batchMode: '批量操作',
      mindmapView: '思维导图视图',
      outlineView: '大纲视图',
      knowledgePointsCount: '{count} 个知识点'
    }
  },
  ipSecurity: {
    batchDeleteConfirm: '确定要删除选中的 {count} 条记录吗?',
    batchDeleteSuccess: '批量删除完成: {count}个',
    batchDeleteFailed: '批量删除失败',
    selectRecordsToDelete: '请选择要删除的记录'
  },
  // 认证相关
  command: {
    refreshed: '已刷新，共 {count} 个命令',
    refreshFailed: '刷新失败',
    loadingCommands: '正在加载命令...',
    loadFailed: '加载失败',
    noCommands: '暂无命令，请点击添加',
    labelRequired: '请输入命令标签',
    textRequired: '请输入命令文本',
    behaviorRequired: '请选择命令行为',
    hotkeyConflict: '快捷键 {hotkey} 已被「{label}」使用，请更换',
    publicHelp: '公开的命令可被其他用户看到并使用'
  },
      targetSimple: {
    backToList: '返回列表',
    targetDetail: '靶点详情',
    generating: '生成中',
    generateReport: '生成报告',
    chatReport: '对话报告',
    downloading: '下载中...',
    downloadReport: '下载报告',
    downloadFailed: '下载失败: {status}',
    reportNotExist: '报告文件不存在或无法生成下载链接',
    preparingDownload: '正在准备下载，请稍候...',
    loadTargetFailed: '加载靶点信息失败',
    confirmGenerate: '确定要为靶点"{name}"生成报告吗？',
    confirmGenerateTitle: '确认生成',
    reportStarted: '报告生成任务已启动',
    reportStartFailed: '启动报告生成失败'
  },
      notifDetail: {
    downloadResearchReport: '下载调研分析报告 (PDF)',
    clickToDownload: '点击按钮下载完整的调研分析报告',
    overspendDetails: '超支详情',
    overspendAmount: '超支金额',
    actionMethod: '处理方式',
    tempCredit: '临时信用额度',
    viewBalance: '查看余额详情',
    rechargeNow: '立即充值',
    markAsRead: '标记已读',
    overspendReason: '超支原因',
    entityId: '关联对象ID',
    entityType: '关联对象类型',
    overspendThreshold: '超支阈值',
    preparingDownload: '正在准备下载{type}...',
    downloadStarted: '{type}下载已开始',
    noDownloadUrl: '未获取到下载链接',
    downloadFailed: '下载失败，请稍后重试',
    confirmDelete: '确定要删除这条通知吗？',
    missingEntityInfo: '缺少关联对象信息',
    noTargetPermission: '无权访问此靶点，可能该靶点由其他用户创建',
    targetNotExist: '靶点不存在或已被删除',
    cannotAccessTarget: '无法访问靶点详情，请联系管理员',
    unsupportedEntityType: '暂不支持跳转到 {type} 类型的页面',
    navigationFailed: '页面跳转失败，请检查您是否有访问权限',
    reportTypes: {
      pdf: 'PDF报告',
      markdown: 'Markdown文件',
      metadata: '元数据文件',
      details: '详细数据'
    },
    types: {
      overspend: '超支提醒',
      balanceLow: '余额不足',
      reportSuccess: '报告生成成功',
      reportFailed: '报告生成失败',
      system: '系统通知',
      security: '安全提醒',
      notification: '通知'
    },
    actions: {
      allowNegative: '允许负余额',
      creditExtension: '临时信用额度',
      setZero: '余额归零保护'
    }
  },
      chatDialog: {
    smartAssistant: '智能助手',
    inputPlaceholder: '请输入您的问题...',
    send: '发送',
    analyzing: '感谢您的问题，我正在为您分析相关信息...'
  },
      cmdEditor: {
    editCommand: '编辑命令',
    addCommand: '添加命令',
    displayName: '显示名称',
    namePlaceholder: '如：确认、继续等',
    replyContent: '回复内容',
    replyPlaceholder: '点击按钮时发送的消息内容',
    category: '分类',
    selectCategory: '选择分类',
    icon: '图标',
    iconPlaceholder: '图标名称（可选）',
    select: '选择',
    color: '颜色',
    hotkey: '快捷键',
    hotkeyPlaceholder: '如：Ctrl+1, Alt+A 等（可选）',
    clear: '清除',
    hotkeyTip: '点击输入框并按下组合键来设置快捷键',
    priority: '优先级',
    priorityTip: '优先级越高，在快捷按钮区显示的可能性越大',
    update: '更新',
    add: '添加',
    nameRequired: '请输入显示名称',
    nameLengthLimit: '长度在 1 到 20 个字符',
    replyRequired: '请输入回复内容',
    replyLengthLimit: '长度在 1 到 200 个字符',
    categoryRequired: '请选择分类'
  },
      iconPicker: {
    title: '选择图标',
    searchPlaceholder: '搜索图标...',
    categories: {
      basic: '基础',
      communication: '通讯',
      document: '文档',
      interface: '界面',
      action: '操作',
      business: '商务',
      system: '系统',
      science: '科学'
    }
  },
      targetSimple: {
    backToList: '返回列表',
    targetDetail: '靶点详情',
    generating: '生成中',
    generateReport: '生成报告',
    chatReport: '对话报告',
    downloading: '下载中...',
    downloadReport: '下载报告',
    downloadFailed: '下载失败: {status}',
    reportNotExist: '报告文件不存在或无法生成下载链接',
    preparingDownload: '正在准备下载，请稍候...',
    loadTargetFailed: '加载靶点信息失败',
    confirmGenerate: '确定要为靶点"{name}"生成报告吗？',
    confirmGenerateTitle: '确认生成',
    reportStarted: '报告生成任务已启动',
    reportStartFailed: '启动报告生成失败'
  },
      notifDetail: {
    downloadResearchReport: '下载调研分析报告 (PDF)',
    clickToDownload: '点击按钮下载完整的调研分析报告',
    overspendDetails: '超支详情',
    overspendAmount: '超支金额',
    actionMethod: '处理方式',
    tempCredit: '临时信用额度',
    viewBalance: '查看余额详情',
    rechargeNow: '立即充值',
    markAsRead: '标记已读',
    overspendReason: '超支原因',
    entityId: '关联对象ID',
    entityType: '关联对象类型',
    overspendThreshold: '超支阈值',
    preparingDownload: '正在准备下载{type}...',
    downloadStarted: '{type}下载已开始',
    noDownloadUrl: '未获取到下载链接',
    downloadFailed: '下载失败，请稍后重试',
    confirmDelete: '确定要删除这条通知吗？',
    missingEntityInfo: '缺少关联对象信息',
    noTargetPermission: '无权访问此靶点，可能该靶点由其他用户创建',
    targetNotExist: '靶点不存在或已被删除',
    cannotAccessTarget: '无法访问靶点详情，请联系管理员',
    unsupportedEntityType: '暂不支持跳转到 {type} 类型的页面',
    navigationFailed: '页面跳转失败，请检查您是否有访问权限',
    reportTypes: {
      pdf: 'PDF报告',
      markdown: 'Markdown文件',
      metadata: '元数据文件',
      details: '详细数据'
    },
    types: {
      overspend: '超支提醒',
      balanceLow: '余额不足',
      reportSuccess: '报告生成成功',
      reportFailed: '报告生成失败',
      system: '系统通知',
      security: '安全提醒',
      notification: '通知'
    },
    actions: {
      allowNegative: '允许负余额',
      creditExtension: '临时信用额度',
      setZero: '余额归零保护'
    }
  },
      chatDialog: {
    smartAssistant: '智能助手',
    inputPlaceholder: '请输入您的问题...',
    send: '发送',
    analyzing: '感谢您的问题，我正在为您分析相关信息...'
  },
      cmdEditor: {
    editCommand: '编辑命令',
    addCommand: '添加命令',
    displayName: '显示名称',
    namePlaceholder: '如：确认、继续等',
    replyContent: '回复内容',
    replyPlaceholder: '点击按钮时发送的消息内容',
    category: '分类',
    selectCategory: '选择分类',
    icon: '图标',
    iconPlaceholder: '图标名称（可选）',
    select: '选择',
    color: '颜色',
    hotkey: '快捷键',
    hotkeyPlaceholder: '如：Ctrl+1, Alt+A 等（可选）',
    clear: '清除',
    hotkeyTip: '点击输入框并按下组合键来设置快捷键',
    priority: '优先级',
    priorityTip: '优先级越高，在快捷按钮区显示的可能性越大',
    update: '更新',
    add: '添加',
    nameRequired: '请输入显示名称',
    nameLengthLimit: '长度在 1 到 20 个字符',
    replyRequired: '请输入回复内容',
    replyLengthLimit: '长度在 1 到 200 个字符',
    categoryRequired: '请选择分类'
  },
      iconPicker: {
    title: '选择图标',
    searchPlaceholder: '搜索图标...',
    categories: {
      basic: '基础',
      communication: '通讯',
      document: '文档',
      interface: '界面',
      action: '操作',
      business: '商务',
      system: '系统',
      science: '科学'
    }
  },
  chatPage: {
    unknownFileName: '未知文件名',
    uploadNoFileId: '上传响应中未找到文件ID',
    uploadSyncFailed: '文件 "{name}" 已上传到系统，但同步到Dify失败',
    uploadSuccess: '文件 "{name}" 已成功上传并绑定到任务 "{target}"',
    uploadPartialSuccess: '文件 "{name}" 已上传并绑定到任务 "{target}"（Dify同步失败）',
    unknownSize: '未知大小',
    uploadFailed: '上传失败',
    cannotGetDownloadUrl: '无法获取下载链接',
    downloadFileFailed: '下载文件失败',
    modelSelect: '模型选择',
    notice: '注意',
    balanceLimitNotice: '由于余额限制，本次可能仅生成部分报告。报告完成后，您可以充值解锁完整内容。',
    insufficientBalance: '余额不足',
    upgradeVipBenefit: '升级会员可享更低生成门槛和更多专属权益',
    xcoinInsufficient: 'X-Coin余额不足',
    upgradeNow: '立即升级',
    laterTalk: '稍后再说',
    audioTranscribe: '音频转录',
    confirmTranscribe: '确认转录此音频文件吗？',
    speechServiceError: '语音识别服务响应错误: {status}',
    speechInputPlaceholder: '[请在此输入您刚才说的内容]',
    reportQuotePrefix: '【报告引用】',
    reportQuoteSuffix: '请基于以上引用内容，',
    reportContentSentToInput: '已将报告内容发送到输入框，请在输入框中补充问题后发送',
    reportQuestionPrefix: '📄 **基于报告内容提问：**',
    questionLabel: '**问题：**',
    processingError: '处理出错',
    generatingAnswer: '正在生成回答...',
    referencesTitle: '📚 **参考资料：**',
    referenceItem: '参考资料 {n}',
    relevance: '相关度',
    references: '{n}条参考',
    reportQaFailed: '报告内容问答失败，请查看错误详情',
    noResponseError: '❌ 未收到回答。可能的原因：1) 请求超时 2) 服务器错误 3) 网络问题。请检查网络连接后重试。',
    commandExecuted: '已执行命令: {label}',
    commandFilled: '已填入"{label}"，请继续输入具体内容',
    outlineSaved: '大纲模板「{name}」保存成功！您可以在快捷命令面板中使用它',
    serverEmptyResponse: '服务器返回空响应',
    sendFailed: '发送消息失败',
    sendFailedDetail: '发送消息失败: {msg}',
    requestTimeout: '请求超时（已等待10分钟）。临床试验搜索等复杂查询可能需要更长时间，请稍后重试或联系管理员',
    serverError: '服务器内部错误，请稍后重试',
    tooManyRequests: '请求过于频繁，请稍后重试',
    noReplyContent: '未能获取到回复内容',
    qaEvidenceHintEnough: '证据充分',
    qaEvidenceHintSelectedOnly: '仅基于选中内容',
    qaEvidenceHintInsufficient: '证据不足，建议补检索或复核',
    quickBriefQualityGatePendingWithTotal: '质量门控：{failed}/{total} 段待复核',
    quickBriefQualityGatePending: '质量门控：{failed} 段待复核',
    quickBriefVerifierFail: 'Verifier 未通过：{count} 项',
    quickBriefVerifierWarn: 'Verifier 预警：{count} 项',
    outlineDetectedSwitching: '检测到靶点"{name}"的分析大纲已生成，正在自动切换...',
    pendingConfirm: '待确认',
    outlineGeneratedConfirm: '靶点"{name}"的分析大纲已生成，请切换到该靶点查看并确认',
    reportGeneratingMsg: '正在为您准备报告生成，标题：{topic}，关键词：{keywords}，报告生成由AI驱动，流程包含文献、专利、临床试验和网络搜索数据收集和分析、智能体协同生成大纲与章节内容以及深度优化。预计耗时 约 30～60 分钟，请您耐心等待。',
    reportStartMsg: '好的，开始为您生成[{name}]调研分析报告。报告生成由AI驱动，流程包含文献、专利、临床试验和网络搜索数据收集和分析、智能体协同生成大纲与章节内容以及深度优化。预计耗时 约 30～60 分钟，请您耐心等待。',
    networkErrorDetail: '❌ 网络连接失败：{msg}\n\n请检查网络连接并确保后端服务已启动。',
    timeoutErrorDetail: '❌ 请求超时：{msg}\n\n请稍后重试或联系管理员。',
    qaErrorDetail: '❌ 问答失败：{msg}\n\n请稍后重试。',
    qaSteps: {
      contentAnalysis: '分析选中内容',
      questionUnderstanding: '理解用户问题',
      knowledgeRetrieval: '知识检索增强',
      reasoning: '智能推理分析',
      answerGeneration: '生成回答',
      llmGeneration: 'AI模型推理',
      finalAnswer: '完成回答',
      onlineSearch: '在线搜索最新数据',
      contextPrep: '准备上下文',
      reasoningContext: '智能推理分析',
      cacheHit: '⚡ 缓存命中'
    }
  },
  reportDetail: {
    sampleReport: '示例报告(不计费)',
    expandCollapseAll: '展开/折叠全部',
    copyOutline: '复制大纲',
    quickNav: '快速导航',
    expandFullOutline: '展开完整大纲',
    regenFailed: '重新生成报告失败',
    fileOpenedInNewWindow: '{type}已在新窗口中打开，请使用浏览器的保存功能下载文件',
    outlineCopied: '大纲已复制到剪贴板',
    copyFailed: '复制失败，请手动选择复制'
  },
  cmdSettings: {
    title: '快捷命令设置',
    basicSettings: '基本设置',
    customCommands: '自定义命令',
    allCommands: '所有命令',
    usageStats: '使用统计',
    enableQuickCmd: '启用快捷命令',
    enableTip: '关闭后将不显示快捷回复按钮',
    showCategories: '显示分类',
    categoriesTip: '按分类组织显示命令',
    showHotkeys: '显示快捷键',
    hotkeysTip: '在按钮提示中显示快捷键',
    smartSuggestion: '智能建议',
    smartTip: '基于对话上下文智能推荐命令',
    maxButtons: '最大快捷按钮',
    maxButtonsTip: '主区域显示的快捷按钮数量',
    recentCount: '最近命令数',
    recentCountTip: '保存的最近使用命令数量',
    suggestThreshold: '建议触发阈值',
    suggestThresholdTip: '对话多少轮后开始智能建议',
    addCommand: '添加命令',
    import: '导入',
    export: '导出',
    searchPlaceholder: '搜索命令...',
    custom: '自定义',
    priority: '优先级',
    recentUsed: '最近使用',
    favoriteCommands: '收藏命令',
    commandDistribution: '命令分布',
    resetDefault: '重置默认',
    saveSettings: '保存设置',
    settingsSaved: '设置已保存',
    confirmReset: '确定要重置所有设置吗？这将清除自定义命令和偏好设置。',
    confirmResetTitle: '确认重置',
    confirmDeleteCmd: '确定要删除这个自定义命令吗？',
    commandDeleted: '命令已删除',
    commandUpdated: '命令已更新',
    commandAdded: '命令已添加',
    commandAlreadyAdded: '该命令已添加过',
    justNow: '刚刚',
    minutesAgo: '{n}分钟前',
    hoursAgo: '{n}小时前',
    daysAgo: '{n}天前',
    configExported: '配置已导出',
    exportFailed: '导出失败',
    importFailed: '导入失败，文件格式错误',
    unfavorite: '取消收藏',
    favorite: '收藏',
    selectCmdType: '选择命令类型',
    loadCmdTypeFailed: '加载命令类型失败'
  },
  targetAdmin: {
    confirmGenerate: '确认生成',
    forceRestartMsg: '强制停止当前分析并重新开始任务"{name}"，以任务创建者"{creator}"的身份执行',
    forceRegenTitle: '强制重新生成报告',
    forceRequeueMsg: '强制重新排队生成任务"{name}"，以任务创建者"{creator}"的身份执行',
    regenOverwriteMsg: '重新生成任务"{name}"的报告，原报告将被覆盖，以任务创建者"{creator}"的身份执行',
    regenTitle: '重新生成报告',
    resumeGenMsg: '恢复生成任务"{name}"的报告，以任务创建者"{creator}"的身份执行',
    resumeGenTitle: '恢复生成报告',
    generateMsg: '生成任务"{name}"的报告，以任务创建者"{creator}"的身份执行',
    resumeGenSimpleMsg: '恢复生成任务"{name}"的报告',
    resumeGenCheckpointPartialMsg: '恢复生成任务"{name}"的报告，将复用已采集调研数据（已完成 {completed}/{total} 个调研模块），以任务创建者"{creator}"的身份执行',
    resumeGenCheckpointPartialSimpleMsg: '恢复生成将复用已采集调研数据（已完成 {completed}/{total} 个调研模块）',
    resumeGenCheckpointSynthesisMsg: '恢复生成任务"{name}"的报告，将跳过已完成的数据采集并继续整理报告，以任务创建者"{creator}"的身份执行',
    resumeGenCheckpointSynthesisSimpleMsg: '恢复生成将跳过已完成的数据采集并继续整理报告',
    regenSimpleMsg: '重新生成任务"{name}"的报告',
    generateSimpleMsg: '生成任务"{name}"的报告',
    forceRestartSuccess: '强制重新生成已启动，原分析任务已停止，将以创建者"{creator}"的身份重新执行',
    forceRequeueSuccess: '强制重新生成已启动，任务已重新排队，将以创建者"{creator}"的身份执行',
    regenOverwriteSuccess: '重新生成已启动，原报告将被覆盖，将以创建者"{creator}"的身份执行',
    resumeGenSuccess: '恢复生成已启动，将从失败点继续，以创建者"{creator}"的身份执行',
    resumeGenSuccessLocalSurvey: '恢复生成已启动，将使用相同参数继续调研，以创建者"{creator}"的身份执行',
    resumeGenSuccessCheckpoint: '恢复生成已启动，将复用已保存的调研进度。',
    resumeGenSuccessCheckpointAdmin: '恢复生成已启动，将复用已保存的调研进度，以创建者"{creator}"的身份执行',
    resumeGenHermesWritingSimpleMsg: '恢复生成任务"{name}"的报告，将继续未完成的报告撰写',
    resumeGenHermesWritingMsg: '恢复生成任务"{name}"的报告，将继续未完成的报告撰写，以任务创建者"{creator}"的身份执行',
    resumeGenSuccessHermesWriting: '恢复生成已启动，将继续未完成的报告撰写任务。',
    resumeGenSuccessHermesWritingAdmin: '恢复生成已启动，将继续未完成的报告撰写任务，以创建者"{creator}"的身份执行',
    adminGenSuccess: '管理员代为生成报告已启动，将以创建者"{creator}"的身份执行',
    preparingDownload: '正在准备下载，请稍候...',
    pdfOpenedInNewWindow: 'PDF已在新窗口中打开，请使用浏览器的保存功能下载文件',
    downloadStarted: '下载已开始',
    downloadFailed: '下载失败: {msg}',
    downloadFailedStatus: '下载失败: {status}',
    audit: '审核',
    auditTask: '审核任务',
    fileTypes: {
      pdf: 'PDF报告',
      image: '图片文件',
      json: 'JSON数据',
      txt: '文本文件',
      docx: 'Word文档',
      xlsx: 'Excel表格'
    },
    reportTypes: {
      pdf: '中文报告',
      en_pdf: '英文报告',
      markdown: 'Markdown文档',
      metadata: '元数据表格'
    },
    resources: {
      processingTime: '处理时间',
      apiCalls: 'API调用次数',
      dataSize: '数据大小',
      memoryUsage: '内存使用',
      cpuUsage: 'CPU使用'
    }
  },
  register: {
    title: '用户注册',
    titleWithInvite: '用户注册 - 邀请码: {code}',
    requestTimeout: '注册请求超时，请检查网络后重试',
    serverError: '服务器错误，请稍后重试',
    inviteVerifyError: '邀请码验证出现异常，请稍后重试'
  },
      auth: {
    login: {
      title: '欢迎登录epiXora',
      username: '用户名或手机号',
      usernamePlaceholder: '请输入手机号或用户名',
      password: '密码',
      passwordPlaceholder: '请输入账户密码',
      captcha: '图形验证码',
      captchaPlaceholder: '请输入验证码',
      captchaClickToLoad: '点击获取',
      captchaRefreshHint: '点击图片可刷新验证码',
      rememberMe: '记住我',
      forgotPassword: '忘记密码？',
      login: '登录',
      loggingIn: '登录中...',
      registerTip: '还没有账号？',
      registerNow: '立即注册',
      dividerOr: '或',
      feishuLogin: '飞书登录',
      success: '登录成功',
      feishuLoginSuccess: '飞书登录成功',
      requestTimeout: '请求超时({timeout}ms)',
      defaultTenant: '默认租户',
      testTenant: '测试租户',
      loginFailedMsg: '登录失败: {msg}',
      feishuLoginProcessing: '飞书登录处理中...',
      feishuLoginFailed: '飞书授权处理失败，请尝试手动登录',
      feishuCallbackFailed: '处理飞书登录回调失败',
      feishuAutoLoginFailed: '飞书自动登录失败，请重试',
      feishuAutoLoginFailedManual: '飞书自动登录失败，请手动登录',
      feishuAccountLoginSuccess: '飞书账号登录成功',
      feishuUnavailable: '飞书登录可能不可用: {msg}',
      feishuMultiTenantTip: '您有多个租户权限，请选择要登录的租户并点击"飞书登录"按钮',
      configError: '检测到配置问题，请联系管理员',
      loginFailedRetry: '登录失败，请重试',
      noTenantPermission: '您没有权限访问租户:{name}',
      networkFailedLogin: '网络连接失败，请检查您的网络或服务器状态',
      setTokenFailed: '设置token失败',
      feishuAuthProcessing: '飞书授权处理中...',
      responseFormatError: '响应数据格式不正确',
      responseTypeError: '响应类型不正确: {type}',
      feishuAuthFailed: '飞书授权处理失败，尝试手动登录',
      feishuLoginFailedMsg: '登录失败: {msg}',
      // 飞书错误码映射
      feishuErrors: {
        missing_code: '缺少授权码',
        missing_state: '缺少状态参数',
        invalid_state: '无效的状态参数',
        expired_state: '授权已过期，请重新登录',
        invalid_tenant: '无效的租户',
        tenant_inactive: '租户已禁用',
        missing_tenant: '缺少租户信息',
        token_failed: '获取飞书令牌失败',
        missing_token: '缺少访问令牌',
        user_info_failed: '获取用户信息失败',
        incomplete_user_info: '用户信息不完整',
        fetch_user_failed: '获取用户信息异常',
        user_creation_failed: '创建用户失败',
        user_inactive: '用户已被停用',
        user_deleted: '用户已被删除',
        tenant_unauthorized: '无权访问所选租户',
        unknown: '未知错误'
      },
      preparingFeishuLogin: '正在准备飞书登录...',
      feishuAuthUrlFailed: '获取飞书授权地址失败：响应无效。',
      redirectingToFeishu: '正在跳转至飞书授权页面...',
      feishuLoginDefaultError: '飞书登录失败，请重试或联系管理员。',
      feishuLoginNetworkError: '飞书登录处理失败，请重试。',
      backendCheckFailed: '后端服务检查失败，请稍后重试或联系管理员。',
      backendCheckFailedBrief: '后端服务检查失败。',
      feishuAuthUrlFailedDetail: '获取飞书授权地址失败，请检查后端配置或联系管理员。',
      feishuAuthUrlFailedBrief: '获取飞书授权地址失败。',
      serviceRequestFailed: '服务请求失败 ({status})',
      loginRequestFailed: '登录请求失败 ({status})',
      networkFailedFeishu: '网络连接失败，请检查您的网络设置。',
      networkFailedBrief: '网络连接失败。',
      unknownLoginError: '登录过程中发生未知错误。',
      internalLoginError: '登录处理时发生内部错误。',
      feishuConfigError: '飞书配置错误: {msg}',
      feishuAccountLogging: '正在通过飞书账号登录...',
      feishuAutoLoginFailedRetry: '飞书自动登录失败，尝试手动登录',
      feishuAutoLoginFailedManualLogin: '飞书自动登录失败，请手动登录',
      feishuEnvDetected: '检测到飞书环境，尝试自动登录...',
      useFeishuLogin: '请使用飞书账号登录',
      loginInfoParseFailed: '登录信息解析失败',
      loginFailed: '登录失败',
      loginTip: '登录提示',
      multiFailMessage: '多次登录失败，请检查以下问题：\n1. 账号或密码是否正确\n2. 网络连接是否正常\n3. 服务器是否在线\n\n如果问题持续，请联系系统管理员。',
      accountRestricted: '账号状态受限',
      accountRestrictedDetail: '您的账号当前无法使用，请联系系统管理员。',
      tenantRestricted: '租户访问受限',
      tenantRestrictedDetail: '请尝试选择其他租户或联系管理员解决权限问题。',
      network: {
        checking: '正在检查服务器连接...',
        cannotConnect: '无法连接到服务器，请检查网络或联系管理员',
        detectConfigIssue: '检测到配置问题，请联系管理员',
        tenantsUseCache: '无法获取最新租户数据，使用缓存数据',
        tenantsFetchFailed: '无法获取租户列表，请联系管理员或稍后再试',
        defaultTenantAdded: '已添加默认租户',
        defaultTenantName: '默认租户',
        testTenantName: '测试租户'
      },
      rules: {
        usernameRequired: '请输入手机号或用户名',
        passwordRequired: '请输入账户密码',
        captchaRequired: '请填写图形验证码后继续登录',
        captchaInvalid: '请输入4位字母或数字验证码',
        passwordMin: '密码不能少于6个字符',
        emailInvalidFormat: '请输入正确的邮箱地址',
        usernameMin: '用户名长度不能少于3个字符',
        phoneInvalid: '请输入正确的手机号码',
        usernameInvalid: '请输入正确的用户名称'
      }
    },
    router: {
      userInfoExpired: '用户信息已过期，请重新登录',
      userInfoAbnormal: '用户信息异常，请重新登录',
      noAdminPermission: '您没有权限访问该页面',
      getUserInfoFailed: '获取用户信息失败，请重新登录'
    },
    register: {
      title: '欢迎注册epiXora',
      invitationCode: '邀请码',
      invitationPlaceholder: '请输入邀请码',
      verify: '验证',
      getInvitationCode: '一键获取',
      applyForRegistration: '申请注册',
      sourceChannel: '来源渠道',
      sourceChannelPlaceholder: '请选择您是如何了解到我们的',
      sourceChannelHint: '如果您有邀请码可不填；否则请告诉我们您是如何了解到我们的',
      sourceChannelOptions: {
        wechat: '微信公众号',
        friend: '朋友推荐',
        live: '直播',
        other: '其他',
        none: '无推荐渠道'
      },
      username: '用户名',
      usernamePlaceholder: '请输入用户名',
      usernameFormatPlaceholder: '4-15个字符，支持大小写字母与数字，不可为纯数字',
      email: '邮箱',
      emailPlaceholder: '请输入邮箱地址',
      emailHint: '请使用企业邮箱或教育邮箱（.edu / .edu.cn）注册',
      password: '密码',
      passwordPlaceholder: '请输入密码',
      confirmPassword: '确认密码',
      confirmPasswordPlaceholder: '请再次输入密码',
      industry: '行业',
      industryPlaceholder: '请选择行业',
      organization: '单位',
      organizationPlaceholder: '请输入单位名称（可选）',
      register: '注册',
      registering: '注册中，请稍候...',
      agreementPrefix: '我已阅读并接受',
      userAgreement: '用户协议',
      and: '和',
      privacy: '隐私条款',
      hasAccount: '已有账号？',
      loginNow: '立即登录',
      messages: {
        verifyFirst: '请先验证邀请码',
        acceptAgreements: '请先阅读并同意用户协议和隐私条款',
        success: '注册成功，请前往注册邮箱完成账号激活!',
        successSimple: '注册成功',
        failed: '注册失败，请稍后重试',
        verifyFailed: '验证邀请码失败，请稍后重试',
        invitationOrSourceRequired: '请填写邀请码或来源渠道',
        verifyInvitationFirst: '请先验证邀请码'
      },
      rules: {
        invitationRequired: '请输入邀请码',
        invitationCodeRequired: '请输入邀请码',
        invitationCodeNotVerified: '邀请码未验证或验证失败，请点击"验证"按钮',
        invitationOrSourceRequired: '邀请码和来源渠道至少填写一项',
        sourceChannelRequired: '未填写邀请码时，来源渠道为必填项',
        sourceChannelLength: '来源渠道长度不能超过200个字符',
        usernameRequired: '请输入用户名',
        usernameLength: '用户名长度在 2 到 20 个字符',
        usernamePattern: "用户名只能包含中文、字母、数字、下划线、中划线、点号和{'@'}符号",
        usernameFormat: '用户名需为4-15个字符，仅支持大小写字母与数字，且不可为纯数字',
        officialName: '用户名包含官方名称，请更换',
        usernameTaken: '该用户名已被注册，请更换',
        emailRequired: '请输入邮箱地址',
        emailInvalid: '请输入正确的邮箱地址',
        emailNotCorporate: '请使用企业邮箱或教育邮箱，不支持个人邮箱（如QQ、163、126、Gmail等）',
        industryRequired: '请选择行业',
        phoneRequired: '请输入手机号',
        phoneInvalid: '请输入正确的手机号',
        captchaRequired: '请输入图形验证码',
        smsCodeRequired: '请输入短信验证码',
        smsCodeInvalid: '验证码格式错误',
        passwordFormat: '密码需6-20位，并同时包含大写字母、小写字母与数字',
        passwordMismatch: '密码输入不一致，请重新输入'
      },
      sms: {
        phone: '手机号',
        phonePlaceholder: '请输入手机号',
        captcha: '图形验证码',
        captchaPlaceholder: '请输入图中字符',
        captchaRefreshHint: '点击图片可刷新验证码',
        captchaClickToGet: '点击获取',
        smsCode: '短信验证码',
        smsCodePlaceholder: '请输入短信验证码',
        getCode: '获取验证码',
        resendCode: '重新获取',
        sending: '发送中',
        resendAfter: '{seconds}s后重发',
        sendSuccess: '验证码已发送，请注意查收',
        sendFailed: '发送失败，请稍后重试',
        getCaptchaFailed: '获取图形验证码失败，请重试',
        refreshCaptcha: '请刷新图形验证码',
        serviceUnavailable: '短信服务暂不可用，请稍后再试',
        phoneRequired: '请先输入手机号',
        phoneInvalid: '请输入正确的手机号',
        captchaRequired: '请输入图形验证码'
      }
    },
    forgot: {
      title: '忘记密码',
      email: '邮箱',
      emailPlaceholder: '请输入您的邮箱地址',
      sendLink: '发送重置链接',
      sending: '发送中...',
      backToLogin: '← 返回登录',
      successTitle: '邮件发送成功',
      successDesc: '重置密码的链接已发送到 {email}，请查收邮件并按照提示操作',
      resend: '重新发送',
      messages: {
        sendSuccess: '重置密码邮件发送成功，请查收邮件'
      },
      rules: {
        emailRequired: '请输入邮箱地址',
        emailInvalid: '请输入正确的邮箱地址'
      }
    },
    forgotSms: {
      title: '重置密码',
      subtitle: '请按步骤完成身份验证并设置新密码',
      backToLogin: '返回登录',
      steps: {
        verifyIdentity: '验证身份',
        smsVerify: '短信验证',
        setPassword: '设置密码'
      },
      form: {
        phone: '手机号码',
        phonePlaceholder: '请输入手机号码',
        phoneNotRegisteredPrefix: '该手机号未注册，请核对您输入的手机号码或',
        phoneNotRegisteredSuffix: '。',
        goRegister: '前往注册',
        captcha: '图形验证码',
        captchaPlaceholder: '请输入验证码',
        captchaRefresh: '点击刷新',
        refresh: '刷新',
        captchaHint: '看不清可点击图片刷新',
        smsCode: '短信验证码',
        smsCodePlaceholder: '请输入6位验证码',
        smsHint: '验证码有效期5分钟，连续错误请重新获取',
        newPassword: '新密码',
        newPasswordPlaceholder: '6-20位，含大小写字母与数字',
        confirmPassword: '确认密码',
        confirmPasswordPlaceholder: '请再次输入密码'
      },
      actions: {
        getSmsCode: '获取短信验证码',
        retryAfter: '{seconds}s后重试',
        nextStep: '下一步',
        resendSms: '重新获取验证码',
        resendAfter: '{seconds}s后可重新获取',
        confirmReset: '确认重置',
        resetting: '正在重置...'
      },
      success: {
        title: '密码重置成功',
        desc: '请使用新密码登录账号 {phone}'
      },
      validation: {
        phoneRequired: '请输入手机号',
        phoneInvalid: '请输入正确的手机号码',
        captchaRequired: '请输入图形验证码',
        smsCodeRequired: '请输入短信验证码',
        newPasswordRequired: '请输入新密码',
        passwordRule: '密码需为6-20位，且必须包含大写字母、小写字母和数字',
        confirmPasswordRequired: '请再次输入新密码',
        passwordMismatch: '两次输入的密码不一致'
      },
      messages: {
        captchaLoadFailed: '图形验证码加载失败，请刷新页面重试',
        smsSent: '短信验证码已发送',
        sendFailed: '发送失败，请稍后重试',
        resetSuccess: '密码重置成功',
        resetFailed: '密码重置失败，请稍后重试'
      }
    },
    reset: {
      title: '重置密码',
      invalidLinkTitle: '链接无效或已过期',
      invalidLinkDesc: '请重新申请密码重置或联系系统管理员',
      backToLogin: '返回登录',
      newPassword: '新密码',
      newPasswordPlaceholder: '请输入新密码',
      confirmPassword: '确认密码',
      confirmPasswordPlaceholder: '请再次输入新密码',
      reset: '重置密码',
      resetting: '重置中...',
      back: '← 返回登录',
      messages: {
        alreadyLoggedIn: '您已经登录，正在跳转到主页...',
        tokenInvalid: '重置令牌无效，请重新申请密码重置',
        tokenExpired: '重置链接已过期，正在跳转到忘记密码页面...',
        successTitle: '成功',
        success: '密码重置成功！请使用新密码登录。',
        unknownFailed: '密码重置失败，请重试',
        invalidOrExpired: '重置令牌无效或已过期'
      }
    }
  },
  profile: {
    title: '个人信息',
    edit: '编辑资料',
    cancelEdit: '取消编辑',
    firstProfileTipPrefix: '首次补充完整个人信息可获得',
    username: '用户名',
    name: '姓名',
    phone: '手机号',
    changePhone: '更改手机号',
    changePhoneTitle: '更改手机号码',
    changePhoneStep1: '第一步：验证当前手机号',
    changePhoneStep2: '第二步：输入新手机号',
    currentPhone: '当前手机号',
    currentPhonePlaceholder: '请输入当前绑定手机号',
    newPhone: '新手机号',
    newPhonePlaceholder: '请输入新手机号',
    graphCaptcha: '图形验证码',
    graphCaptchaPlaceholder: '请输入验证码',
    graphCaptchaRequired: '请输入图形验证码',
    smsCode: '短信验证码',
    smsCodePlaceholder: '请输入短信验证码',
    smsCodeRequired: '请输入短信验证码',
    getSmsCode: '获取验证码',
    resendIn: '{seconds}s 后重发',
    smsSent: '短信验证码已发送',
    smsSendFailed: '短信发送失败，请稍后再试',
    captchaLoadFailed: '图形验证码加载失败',
    verifyOldFailed: '当前手机号验证失败',
    currentPhoneMismatch: '请输入当前账号绑定的手机号',
    samePhoneError: '新手机号不能与当前手机号一致',
    phoneRequired: '请输入手机号',
    phoneInvalid: '请输入正确的手机号码',
    changePhoneSuccess: '手机号修改成功，请使用新手机号重新登录',
    changePhoneFailed: '手机号修改失败，请稍后重试',
    changeSessionExpired: '更换手机号会话已过期，请重新发起',
    changePhoneNoBind: '当前账号尚未绑定手机号，请联系管理员',
    next: '下一步',
    email: '邮箱',
    emailVerified: '已激活',
    emailUnverified: '未激活',
    sendActivationEmail: '发送激活邮件',
    changeEmail: '更改邮箱',
    password: '密码',
    changePassword: '修改密码',
    changePasswordSubtitle: '为了您的账户安全，请设置新的密码',
    passwordStrength: '密码强度',
    passwordStrengthWeak: '弱',
    passwordStrengthMedium: '中',
    passwordStrengthStrong: '强',
    passwordTips: '密码需6-20位，并同时包含大写字母、小写字母与数字',
    passwordMatch: '密码匹配',
    passwordNotMatch: '密码不匹配',
    passwordContains: '包含',
    passwordCharTypes: {
      lowercase: '小写字母',
      uppercase: '大写字母',
      digits: '数字',
      special: '特殊字符'
    },
    industry: '行业',
    selectIndustry: '请选择行业',
    organization: '单位',
    organizationPlaceholder: '请输入单位信息',
    language: '语言',
    selectLanguage: '请选择语言',
    notSet: '未设置',
    lastLogin: '上次登录',
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    currentPasswordPlaceholder: '请输入当前密码',
    newPasswordPlaceholder: '请输入新密码',
    confirmPasswordPlaceholder: '请再次输入新密码',
    industryOptions: {
      invest: '投资',
      preclinical: '生物医药（临床前研发）',
      clinical: '生物医药（临床研究）',
      basic: '基础研究',
      management: '管理',
      bd: 'BD',
      school: '学校/研究所',
      other: '其它'
    },
    validation: {
      currentRequired: '请输入当前密码',
      newRequired: '请输入新密码',
      newMin: '密码长度至少6位',
      confirmRequired: '请确认新密码',
      confirmNotMatch: '两次输入的密码不一致'
    },
    neverLoggedIn: '从未登录',
    functionEntries: '功能入口',
    myPreferenceCenter: '我的偏好画像',
    myUsageStatistics: '我的使用统计',
    messages: {
      loadFailed: '加载用户信息失败',
      updateSuccess: '个人信息更新成功',
      updateFailed: '更新用户信息失败',
      emailCannotBeCleared: '邮箱已绑定，不允许清空后保存',
      passwordChanged: '密码修改成功！',
      passwordChangeFailed: '修改密码失败，请检查当前密码是否正确',
      badRequest: '请求参数有误',
      authFailed: '身份认证失败，请重新登录',
      noPermission: '没有权限修改此信息',
      validationFailed: '数据验证失败，请检查输入信息',
      serverError: '服务器内部错误，请稍后重试',
      updateFailedCode: '更新失败 ({code})',
      networkFailed: '网络连接失败，请检查网络连接',
      unknownError: '发生未知错误：{msg}'
    }
  },
  account: {
    loading: '正在加载账户信息...',
    title: '个人账户',
    subtitle: '查看您的额度使用情况',
    totalAmount: '总额度',
    usedAmount: '已使用额度',
    remainingAmount: '剩余额度',
    usageProgress: '额度使用进度',
    lowBalanceTitle: '余额不足提醒',
    lowBalanceDesc: '您的余额已不足总额度的20%，建议及时充值以确保服务正常使用。当前剩余: ',
    rechargeNow: '立即充值',
    timeDistTitle: '平台整体报告生成平均耗时分布（单位：分钟）',
    timeDistSub: '最近一个月各耗时区间的报告数量分布',
    costDistTitle: '平台整体平均报告生成X-Coin消耗分布',
    costDistSub: '最近一个月各消耗区间的报告数量分布',
    taskOverview: '任务统计概览',
    taskOverviewSub: '查看您的调研分析任务统计信息',
    totalTasks: '总任务数',
    monthlySubmitted: '本月提交',
    completed: '已完成',
    analyzing: '分析中',
    failed: '失败',
    monthlyCompleted: '本月完成',
    monthAvgDuration: '个人本月平均耗时',
    monthAvgCost: '个人本月平均X-Coin消耗',
    recordsTitle: '消费记录详情',
    recordsSub: '查看每个调研任务的详细消费情况',
    columns: {
      usageType: '使用类型',
      model: '使用模型',
      recordCount: '记录数',
      inputTokens: '输入Tokens',
      outputTokens: '输出Tokens',
      cost: 'X-Coin消耗',
      targetName: '任务名称',
      status: '状态',
      createdAt: '创建时间',
      duration: '报告生成耗时',
      modelsUsed: '使用模型'
    },
    noData: '暂无数据',
    charts: {
      reportCount: '报告数量',
      avgTime: '平均耗时',
      avgCost: '平均X-Coin消耗',
      yAxisName: '报告数',
      reportCountUnit: '份',
      avgTimeUnit: '分钟',
      avgCoinConsumption: '平均X-Coin消耗',
      timeTooltip: '报告数: {value} 份',
      coinTooltip: '报告数: {value} 份',
      avgTimeTooltip: '平均耗时: {value} 分钟',
      avgCoinTooltip: '平均: {value} X-Coin'
    },
    usageLevel: {
      nearExhausted: '额度即将用完，请及时充值',
      high: '额度使用较多，建议关注余额',
      normal: '额度使用正常',
      sufficient: '额度充足'
    },
    messages: {
      fetchAccountFailed: '获取账户信息失败',
      fetchStatsFailed: '获取统计数据失败',
      fetchTaskStatsFailed: '获取任务统计信息失败',
      fetchRecordsFailed: '获取消费记录详情失败',
      rechargeTip: '充值功能开发中，请联系管理员'
    }
  },
  sources: {
    noData: '暂无来源数据',
    title: '数据来源 ({count})',
    subtitle: '以下是分析过程中收集的数据来源',
    index: '序号',
    sourceType: '来源类型',
    source: '来源',
    collectTime: '收集时间',
    timeUnknown: '时间未知',
    timeFormatError: '时间格式错误',
    unknownDomain: '未知域名',
    unknownSource: '未知来源',
    sourceIndex: '来源 {index}',
    dataSource: '数据来源',
    types: {
      journal: '学术期刊',
      patent: '专利',
      cnAcademic: '中文学术',
      bioDB: '生物数据库',
      drugDB: '药物数据库',
      other: '其他'
    }
  },
  progress: {
    started: '分析工作已启动，预计耗时约 30～60 分钟...',
    generating: '正在分析中...',
    generatingOutline: '正在生成报告结构',
    outlineCompleted: '报告大纲结构已完成撰写',
    writingReport: '正在撰写报告',
    writingBody: '正在撰写报告正文',
    refiningBody: '正在优化正文内容',
    typesetting: '正在优化报告排版',
    writingDoneEnterOptimize: '报告撰写已完成，开始进入报告优化阶段',
    optimizingAndReview: '正在进行报告优化与最终审核',
    savingReport: '正在保存分析报告',
    reportSavedPreviewBelow: '报告已保存，请在下方进行分析报告预览',
    allDone: '全部分析工作已顺利完成',
    failed: '分析报告生成遇到问题，过程中可能因网络或服务波动导致中断',
    // Writing-mode (llm_agent) progress labels. Writing is its own product
    // surface and has no outline/integration phases — these labels match
    // the step_name vocabulary emitted by
    // backend/app/workflows/writing/llm_agent_executor.py.
    writing: {
      submitted: '撰写任务已提交',
      started: '远端已接受任务，开始撰写',
      inProgress: '撰写进行中',
      draftingBody: '正在撰写正文…',
      generatedChars: '已生成约 {count} 字',
      callingTool: '调用工具: {tool}',
      researching: '正在检索资料',
      reading: '正在阅读材料',
      editing: '正在编辑文档',
      saving: '正在保存文档',
      sectionProgress: '第 {index}/{total} 章',
      draftDone: '撰写已完成，正在保存报告',
      allDone: '报告已生成，可在下方预览',
      hermesStarted: '报告撰写已启动',
      hermesResearching: '正在检索文献与数据，并撰写文档…',
      hermesFinalizing: '正在整合证据并定稿文档…',
      hermesPersisting: '正在保存报告草稿…',
      hermesDone: '报告撰写已完成',
      hermesResuming: '正在恢复报告撰写任务…',
      groundedCitationsOk: '引用溯源校验通过（{count} 条来源）',
      groundedCitationsRemediated: '引用溯源校验通过（已本地修复，{count} 条来源）',
      groundedCitationsDegraded: '引用溯源校验未完全通过（{count} 项），已降级交付'
    },
    v2: {
      dataCollection: '正在从多个数据源检索相关文献',
      knowledgeGraph: '正在构建研究知识图谱',
      outlineGeneration: '正在生成报告结构',
      contentGeneration: '正在撰写报告',
      abstractDone: '报告摘要已完成撰写',
      conclusionDone: '报告结论已完成撰写',
      referencesDone: '参考文献已整理完成',
      contentDone: '报告撰写已完成，开始进入报告整合阶段',
      integration: '正在进行报告整合与最终审核'
    },
    targetSurvey: {
      pipelineAria: '靶点调研生成进度',
      dataCollection: '正在采集靶点调研证据',
      dataStructuring: '正在整理结构化证据',
      contentGeneration: '正在生成靶点调研报告',
      qualityCheck: '正在执行质量校验',
      integration: '正在整合报告',
      workflowStarted: '正在启动靶点调研'
    }
  },
  notifications: {
    title: '通知中心',
    subtitle: '管理所有通知消息',
    markAllAsRead: '全部已读',
    totalCount: '总通知',
    unreadCount: '未读通知',
    criticalCount: '重要通知',
    readStatus: '阅读状态',
    category: '通知分类',
    notificationType: '通知类型',
    severity: '严重程度',
    allNotifications: '全部通知',
    unreadOnly: '仅未读',
    clearFilters: '清空筛选',
    unreadSuffix: ' 未读',
    viewAll: '查看全部',
    notificationList: '通知列表',
    batchRead: '批量已读',
    batchDelete: '批量删除',
    markAsRead: '标记已读',
    viewDetails: '查看详情',
    goToDetail: '跳转查看',
    notificationDetails: '通知详情',
    notificationContent: '通知内容',
    basicInfo: '基本信息',
    detailedInfo: '详细信息',
    createdTime: '创建时间',
    updatedTime: '更新时间',
    readStatus: '阅读状态',
    read: '已读',
    unread: '未读',
    relatedObject: '关联对象',
    target: '任务',
    deleteNotification: '删除通知',
    defaultType: '通知',
    downloadReport: '下载报告',
    downloadOptions: {
      pdf: 'PDF报告',
      markdown: 'Markdown文件',
      metadata: '元数据文件',
      details: '详细数据'
    },
    types: {
      info: '信息',
      warning: '警告',
      error: '错误',
      success: '成功',
      purchase_xcoin_success: 'X-Coin购买成功',
      purchase_xcoin_failed: 'X-Coin购买失败',
      subscribe_membership_failed: '会员订购失败',
      upgrade_membership_failed: '会员升级失败',
      xcoin_granted: 'X-Coin到账',
      xcoin_granted_membership: '会员赠送X-Coin到账',
      xcoin_granted_invitation: '邀请奖励到账',
      xcoin_granted_profile_completion: '资料完善奖励到账',
      xcoin_granted_platform: '平台赠送到账',
      xcoin_expiring: 'X-Coin即将过期',
      xcoin_expired: 'X-Coin已过期',
      monthly_bill: '月度账单',
      overspend: '超支提醒',
      balance_low: '余额不足',
      system: '系统通知',
      security: '安全提醒',
      report_success: '报告生成成功',
      report_failed: '报告生成失败',
      subscribe_membership_success: '会员订购成功',
      upgrade_membership_success: '会员升级成功',
      membership_expired: '会员已过期',
      membership_expiring: '会员即将过期',
      membership_cancelled: '会员已取消',
      feedback_reply: '反馈回复',
      knowledge_map_subscription: '知识地图订阅更新',
      intelligence_subscription: '报告情报订阅更新'
    },
    categories: {
      account_change: '账户变动',
      usage: '使用通知',
      system: '系统通知'
    },
    entities: {
      target: '任务',
      user: '用户',
      system: '系统'
    },
    severities: {
      info: '信息',
      warning: '警告',
      error: '错误',
      critical: '严重'
    },
    messages: {
      markReadSuccess: '标记已读成功',
      markReadFailed: '标记已读失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      loadFailed: '加载通知失败',
      noNotifications: '暂无通知',
      noMatchingNotifications: '没有找到匹配的通知',
      operationFailed: '操作失败',
      allSelectedRead: '所选通知已全部已读',
      batchReadSuccess: '已标记 {count} 条通知为已读',
      batchReadFailed: '批量标记已读失败',
      markAllReadSuccess: '全部通知已标记为已读',
      batchDeleteConfirm: '确定要删除所选的 {count} 条通知吗？',
      batchDeleteSuccess: '成功删除 {count} 条通知',
      batchDeleteFailed: '批量删除失败',
      deleteConfirm: '确定要删除这条通知吗？',
      reportRejected: '报告内容审核未通过，暂时无法下载。如有疑问请联系管理员。',
      reportRejectedBrief: '报告内容审核未通过，暂时无法下载。请联系管理员。'
    },
    time: {
      justNow: '刚刚',
      minutesAgo: '{minutes}分钟前',
      hoursAgo: '{hours}小时前',
      daysAgo: '{days}天前'
    },
    dateFormat: '{year}年{month}月{day}日 {hours}:{minutes}'
  },
  // 快捷命令UI文本
  ui: {
    quickActions: '快捷命令',
    showQuickActions: '显示快捷命令',
    manageCommands: '管理命令',
    collapse: '收起',
    expand: '展开',
    directSend: '直接发送',
    editSend: '编辑发送',
    smartSuggestions: '智能建议',
    outlineTemplates: '大纲模板',
    recentUsed: '最近使用',
    selectOutlineTemplate: '选择大纲模板',
    viewAllTemplates: '查看全部模板',
    templateCount: '{count}个模板',
    noOutlineTemplates: '暂无大纲模板',
    selectTarget: '请先选择一个靶点',
    // 管理界面
    commandManager: '快捷命令管理',
    myCommands: '我的命令',
    publicLibrary: '公开命令库',
    addToMyCommands: '添加到我的命令',
    noPublicCommands: '暂无公开命令',
    currentCommands: '当前命令',
    totalCommands: '总数',
    addCommand: '添加命令',
    editCommand: '编辑命令',
    deleteCommand: '删除命令',
    quickSettings: '快捷设置',
    save: '保存',
    cancel: '取消',
    confirm: '确定',
    edit: '编辑',
    delete: '删除',
    refresh: '刷新',  // 添加刷新翻译
    // 表单标签
    label: '标签',
    description: '描述',
    text: '文本',
    icon: '图标',
    color: '颜色',
    clear: '清除',
    priority: '优先级',
    sortOrder: '排序',
    public: '公开',
    create: '创建',
    behavior: '行为',
    hotkey: '快捷键',
    visible: '显示状态',
    order: '显示顺序',
    publicShare: '公开分享',
    show: '显示',
    hidden: '隐藏',
    hide: '隐藏',
    emptyCommandText: '无内容',
      commandInfo: '命令信息',
      status: '状态',
      actions: '操作',
      
      // 命令类型和模板相关
      commandType: '命令类型',
      availableTemplates: '可用模板',
      usageScenarios: '使用场景',
      templateUsedSuccess: '模板使用成功',
      templateUseFailed: '模板使用失败',
      createCustomCommand: '创建自定义命令',
      commandCreatedSuccess: '命令创建成功',
      commandCreateFailed: '命令创建失败',
      
      // 命令类型场景说明
      actionScenario1: '快速确认或否定AI的建议和问题',
      actionScenario2: '执行常见的操作指令，如继续、重新分析等',
      actionScenario3: '简化重复性的交互操作',
      outlineScenario1: '为任务分析提供结构化的大纲模板',
      outlineScenario2: '确保分析的全面性和一致性',
      outlineScenario3: '快速生成标准化的分析框架',
      analysisScenario1: '应用专业的分析方法和技巧',
      analysisScenario2: '提供深度分析的指导模板',
      analysisScenario3: '标准化复杂的分析流程',
      replyScenario1: '快速回复常见问题和请求',
      replyScenario2: '保持专业和一致的沟通风格',
      replyScenario3: '提高沟通效率',
      terminologyScenario1: '快速输入专业术语和缩写',
      terminologyScenario2: '确保术语使用的准确性',
      terminologyScenario3: '建立统一的术语库',
      
      // 命令创建表单
      commandName: '命令名称',
      commandNamePlaceholder: '请输入命令名称',
      commandNameRequired: '请输入命令名称',
      commandNameLength: '命令名称长度应在2-50个字符之间',
      displayLabel: '显示标签',
      labelRequired: '请输入显示标签',
      labelLength: '显示标签长度应在1-20个字符之间',
      commandContent: '命令内容',
      contentRequired: '请输入命令内容',
      contentLength: '命令内容长度应在1-500个字符之间',
      descriptionPlaceholder: '请输入命令描述（可选）',
      behaviorRequired: '请选择行为类型',
      directSendHelp: '点击后直接发送内容',
      editSendHelp: '点击后将内容填入输入框，可编辑后发送',
      hotkeyHelp: '点击输入框并按下组合键来设置快捷键',
      publicHelp: '公开的命令可以被其他用户看到和使用',
      usageCount: '使用次数',
      
      // 内容占位符
      actionContentPlaceholder: '例如：确认、继续分析、重新评估',
      outlineContentPlaceholder: '例如：请按照以下大纲进行分析：1. 基本信息 2. 市场分析 3. 风险评估',
      analysisContentPlaceholder: '例如：请使用SWOT分析法对该任务进行综合评估',
      replyContentPlaceholder: '例如：好的，我明白了。请稍等，我来详细分析一下',
      terminologyContentPlaceholder: '例如：Small Molecule Drug（小分子药物）',
      
      // 存储模式
      storageMode: '存储模式',
      localStorage: '本地存储',
      serverStorage: '服务器存储',
      hybridStorage: '混合存储',
      syncEnabled: '启用同步',
      lastSyncTime: '最后同步时间',
      syncNow: '立即同步',
      syncSuccess: '同步成功',
      syncFailed: '同步失败',
    // 表单占位符
    labelPlaceholder: '如：确认、取消',
    textPlaceholder: '发送的实际文本',
    iconPlaceholder: '如：✓、✕、+',
    hotkeyPlaceholder: '如：Ctrl+Enter',
    orderPlaceholder: '数字越小越靠前',
    // 提示消息
    commandAdded: '命令添加成功',
    commandUpdated: '命令更新成功',
    commandDeleted: '命令删除成功',
    commandsSaved: '命令配置保存成功',
    fillCommand: '已填入"{label}"，请继续输入具体内容',
    executeCommand: '已执行命令: {label}',
    selectTarget: '请先选择一个任务',
    cannotDeletePreset: '预设命令不能删除',
    confirmDelete: '确定要删除这个命令吗？'
  },
  // 报告评价相关
  rating: {
    // 工具栏基础
    satisfaction: '满意度',
    detailedRating: '详细评价',
    rated: '已评价',
    reportSatisfactionRating: '报告满意度评价',
    
    // 操作
    viewRating: '查看评价',
    editRating: '修改评价',
    deleteRating: '删除评价',
    submitRating: '提交评价',
    updateRating: '更新评价',
    cancel: '取消',
    
    // 评分项目
    overallRating: '总体评分',
    usefulnessScore: '实用性',
    accuracyScore: '准确性',
    completenessScore: '完整性',
    readabilityScore: '可读性',
    
    // 表单
    comment: '评价内容',
    commentPlaceholder: '请输入您的评价意见...',
    tags: '评价标签',
    anonymous: '匿名评价',
    
    // 状态消息
    submitSuccess: '评价提交成功',
    updateSuccess: '评价更新成功',
    deleteSuccess: '评价删除成功',
    submitFailed: '评价提交失败',
    updateFailed: '评价更新失败',
    deleteFailed: '评价删除失败',
    loadFailed: '加载评价失败',
    quickRatingSuccess: '快速评价成功',
    quickRatingFailed: '快速评价失败',
    
    // 确认对话框
    deleteConfirmTitle: '确认删除',
    deleteConfirmMessage: '确定要删除这条评价吗？此操作不可撤销。',
    
    // 现有评价显示
    existingRating: '您的评价',
    createdAt: '评价时间',
    anonymousUser: '匿名用户',
    scoreOutOf5: '{score}/5分',
    
    // 验证消息
    pleaseSelectRating: '请选择评分',
    ratingRequired: '评分是必填项'
  },
  // 个人中心页面
  personalCenter: {
    title: '个人中心',
    nav: {
      accountInfo: '账户信息',
      rechargeCenter: '充值中心',
      notifyCenter: '通知中心',
      feedback: '用户反馈'
    },
    tabs: {
      overview: '账户概览',
      recharge: '充值管理',
      invite: '邀请管理'
    },
    transaction: {
      empty: '暂无交易记录',
      accountChange: '账户变动',
      changeTime: '变动时间',
      changeType: '变动类型',
      xcoinAmount: 'X-Coin数量',
      accountBalance: '账户余额',
      type: {
        expense: '消费',
        income: '充值',
        reward: '奖励',
        refund: '退款'
      }
    },
    recharge: {
      empty: '暂无充值记录',
      rechargeTime: '充值时间',
      rechargeType: '充值类型',
      paymentAmount: '支付金额',
      validity: '有效期',
      status: '充值状态',
      permanent: '永久有效',
      memberSuffix: '会员',
      xcoinRecharge: 'X-Coin充值',
      statusText: {
        completed: '已完成',
        pending: '处理中',
        failed: '失败'
      }
    },
    transactionTypes: {
      expense: '支出',
      income: '收入',
      reward: '奖励',
      refund: '退款'
    },
    invite: {
      myInviteCode: '我的邀请码',
      inviteDescription: '每邀请1位好友成功充值,您和好友都将获得相应的邀请奖励',
      copy: '复制',
      codeNotLoaded: '邀请码未加载，请稍后重试',
      steps: {
        step1: '邀请朋友注册账号',
        step2: '新生成邮件邀请',
        step3: '双方均获得奖励'
      },
      stats: {
        invitedCount: '已经成功邀请人数',
        totalRewards: '累计邀请奖励',
        people: '人'
      },
      noCode: {
        title: '邀请好友，共享奖励',
        description: '生成您的专属邀请链接，好友注册并完成首次调研任务后，您与好友均可获得 X-Coin 奖励',
        generateBtn: '生成我的邀请码'
      },
      rules: {
        title: '邀请规则',
        rule1: '复制专属邀请链接分享给好友；好友通过链接注册 epiXora 并完成首次登录。',
        rule2: '好友完成首次调研任务（快速简报或专家报告均可）后，您与好友各获得 1,000 X-Coin；奖励通常在 24 小时内发放至双方账户。',
        rule3: '若参与者在活动期间涉嫌欺诈或恶意获取活动奖励的行为，官方保留取消其资格并撤销奖励的权利。',
        rule4: '每位用户每月最多可邀请 5 名新用户获得该奖励。',
      },
      dashboard: {
        cumulativeReward: '累计奖励',
        viewDetails: '查看明细',
        successfulInvites: '成功邀请',
        pendingRewards: '待到账奖励',
        peopleSuffix: '人'
      },
      method: {
        title: '邀请方式',
        step1: '步骤 1',
        step2: '步骤 2',
        step3: '步骤 3',
        step1Desc: '复制专属邀请链接，分享给同事或科研伙伴',
        step2Desc: '好友通过链接注册 epiXora 并完成首次登录',
        step3Desc: '好友完成首次调研任务后，双方奖励自动到账',
        copyLink: '复制链接'
      },
      rewardDetails: {
        title: '邀请记录',
        invitedUser: '邀请用户',
        registerTime: '注册时间',
        rewardType: '奖励类型',
        rewardAmount: '奖励数量',
        status: '状态',
        empty: '暂无邀请记录',
        loadFailed: '加载邀请记录失败',
        types: {
          invite: '邀请奖励',
          register: '注册奖励',
          recharge: '充值奖励',
          generateReport: '首次调研奖励'
        },
        statusText: {
          pending: '待到账',
          completed: '已到账',
          failed: '失败',
          cancelled: '已取消'
        }
      }
    },
    notify: {
      listTitle: '通知列表',
      markAllRead: '全部标为已读',
      loading: '通知加载中...',
      empty: '暂无通知',
      defaultTitle: '通知',
      groups: {
        today: '今天',
        yesterday: '昨天',
        earlier: '更早'
      },
      time: {
        justNow: '刚刚',
        hoursAgo: '{hours} 小时前'
      },
      categories: {
        all: '全部通知',
        account: '账户变动',
        system: '系统通知',
        reportFailed: '报告失败',
        reportSuccess: '报告成功',
        xcoinExpiring: 'X-Coin 到期提醒',
        xcoinGrantedInvitation: '邀请奖励到账',
        xcoinGrantedRecharge: '充值到账',
        xcoinConsumed: 'X-Coin 消耗',
        membershipExpiring: '会员到期提醒',
        membershipActivated: '会员开通通知',
        other: '其他通知'
      },
      messages: {
        loadFailed: '加载通知失败，请稍后重试',
        markAllReadSuccess: '已全部标记为已读',
        markAllReadFailed: '标记已读失败，请稍后重试'
      }
    },
    footer: {
      description: 'epiXora 是面向投资机构、高校科研院所与药物研发企业的企业级 AI 智能调研分析平台。依托智能体驱动的多源检索与自动化分析能力，epiXora 将公开文献、预印本、专利、全球临床试验数据库及用户自有文件等进行融合计算和分析，自动生成可自定义大纲、结构化、可追溯的靶点与研发调研报告，旨在为科研决策、投资评估与管线规划提供高质量、可复现的知识产出。',
      helpTitle: '帮助与支持',
      userAgreement: '用户协议',
      privacyPolicy: '隐私政策',
      productManual: '产品手册',
      intellectualProperty: '知识产权',
      contactTitle: '联系我们',
      copyright: '© 2025 XtalPi Technology Co., Ltd. 保留所有权利。',
      icp: '京ICP备12345678号-1'
    },
    messages: {
      loadTransactionFailed: '加载交易记录失败，请稍后重试',
      loadRechargeFailed: '加载充值记录失败，请稍后重试',
      copySuccess: '邀请码已复制到剪贴板',
      copyFailed: '复制失败，请手动复制邀请码',
      generateSuccess: '邀请码生成成功！',
      generateFailed: '生成邀请码失败'
    }
  },
  preference: {
    stats: {
      zeroMin: '0 分钟',
      activities: '活动次数'
    }
  },
  // 账户余额卡片组件
  accountBalance: {
    accountName: '账户名',
    phone: '手机号',
    totalAssets: '总资产',
    freeTier: '免费版',
    membershipBadge: {
      format: '{tier}-{period}',
      tier: {
        plus: 'Plus',
        pro: 'Pro',
        enterprise: 'Enterprise'
      },
      period: {
        monthly: '月度会员',
        yearly: '年费会员',
        default: ''
      }
    },
    membershipValidity: '会员有效期',
    daysRemaining: '{days}天（{date}到期）',
    temporaryXCoin: '限时 X-coin',
    permanentXCoin: '永久 X-coin',
    reportGeneration: '报告生成次数',
    times: '次',
    reportCount: '{count}次',  // 用于格式化报告次数显示
    viewDetails: '查看明细',
    recharge: '充值',
    generateDetails: '生成明细',
    // 升级按钮文本
    upgradeButton: {
      upgradeMembership: '升级会员',
      renewMembership: '续费会员',
      renewOrUpgrade: '续费/升级会员'
    },
    // 对话框
    dialogs: {
      temporaryXCoinDetails: '限时X-Coin明细',
      reportGenerationDetails: '报告生成明细'
    },
    // 表格列
    table: {
      xcoinBalance: 'X-Coin余额',
      initialAmount: '初始金额',
      usedAmount: '已使用',
      source: '来源',
      grantedTime: '获得时间',
      expiryTime: '过期时间',
      status: '状态',
      reportName: '报告名称',
      generationTime: '生成时间',
      xcoinConsumed: '消耗X-Coin'
    },
    // 状态
    status: {
      active: '有效',
      expired: '已过期'
    },
    // 加载和错误消息
    messages: {
      loading: '加载中...',
      noData: '暂无数据',
      loadXCoinFailed: '加载X-Coin余额失败',
      loadMembershipFailed: '加载用户会员状态失败',
      loadDetailsFailed: '加载明细失败',
      loadTaskStatsFailed: '加载任务统计失败',
      loadReportDetailsFailed: '加载报告明细失败'
    }
  },
  // X-Coin业务类型（用于账户页面）
  xcoin: {
    transactionTypeLabels: {
      batchResearch: '批量任务消费',
      quickBrief: '快速简报消费',
      expertReport: '专家报告消费',
      writingReport: '撰写报告消费',
      hallucinationDetection: '幻觉检测消费',
      chat: '聊天消费',
      reportInteractiveEdit: '报告交互编辑消费',
      reportInteractiveEditTool: '交互编辑工具消费',
      rewardGrant: '奖励发放'
    },
    accountChangeLabels: {
      registerRewardGrant: '用户注册奖励发放',
      profileCompletionRewardGrant: '信息补充奖励发放'
    },
    businessTypes: {
      // 收入类型
      recharge: '充值',
      member_grant: '会员赠送',
      member_monthly_grant: '月度发放',
      invite_reward: '邀请奖励',
      behavior_reward: '行为奖励',
      refund: '退款',
      monthly_refresh: '月度刷新',
      system_init: '系统初始化',
      // 支出类型
      expire: '过期',
      target_chat: '聊天消费',
      outline_generation: '报告消费',
      target_report: '报告消费',
      quick_qa: '快速模式问答消费',
      quick_brief_generation: '快速模式简报生成消费',
      expert_qa: '专家模式问答消费',
      expert_report_generation: '专家模式报告生成消费',
      writing_qa: '撰写模式问答消费',
      writing_report_generation: '撰写模式报告生成消费',
      hallucination_detection: '幻觉检测消费',
      report_interactive_edit: '报告交互编辑消费',
      report_interactive_edit_tool: '交互编辑工具消费',
      target_wiki_classify: 'Wiki分类消费',
      target_wiki_compile: 'Wiki整理消费',
      target_wiki_heal: 'Wiki自愈消费',
      target_wiki_query: 'Wiki问答/体检消费',
      target_wiki_extract: '知识地图智能抽取消费',
      knowledge_subscription_extract: '订阅采集抽取消费',
      consume: '消费',
      target: '靶点分析',
      // 特殊类型
      correction: '数据修正',
      data_fix: '数据修复',
      test_deduct: '测试扣费',
      // 旧版本兼容
      test_charge: '测试扣费',  // 兼容旧值，映射到test_deduct
      report_generation: '报告生成',
      knowledge_base_usage: '知识库使用',
      xcoin_expired: 'X-Coin过期'
    },
    messages: {
      loadSummaryFailed: '获取余额汇总失败',
      loadDetailsFailed: '获取余额明细失败',
      loadTransactionsFailed: '获取交易流水失败'
    }
  },
  // 会员中心
  membership: {
    // 基础文本
    title: '会员中心',
    currentMembership: '当前会员',
    membershipStatus: '会员状态',
    expiryTime: '到期时间',
    subscriptionType: '订阅类型',
    autoRenewal: '自动续费',
    enabled: '开启',
    disabled: '关闭',
    daysRemaining: '还剩 {days} 天',
    
    // 会员状态
    status: {
      active: '已激活',
      expired: '已过期',
      cancelled: '已取消'
    },
    
    // 订阅类型
    subscriptionTypes: {
      monthly: '月度订阅',
      yearly: '年度订阅'
    },
    
    // 权益使用情况
    benefitsUsage: {
      title: '权益使用情况',
      concurrentTasks: '并发任务数',
      knowledgeBaseFiles: '知识库文件（总量）',
      monthlyReports: '本月报告生成',
      xcoinBalance: 'X-Coin余额',
      unlimited: '不限',
      priority: '{level} 优先级'
    },
    
    // 会员等级对比
    comparison: {
      title: '会员权益对比',
      recommended: '推荐',
      currentTier: '当前等级',
      currentMember: '当前会员',
      lowerTier: '较低等级',
      upgradeMember: '升级会员',
      purchaseMember: '购买会员',
      
      // 价格相关
      firstPurchaseDiscount: '首充优惠',
      originalPrice: '原价',
      monthlySubscription: '月度订阅',
      yearlySubscription: '年度订阅',
      perMonth: '/月',
      perYear: '/年',
      
      // X-Coin赠送
      monthlyXCoinGrant: '月度订阅：每月送 {amount} X-Coin',
      yearlyXCoinGrant: '年度订阅：每月送 {amount} X-Coin',
      validity: '有效期',
      validityDays: '{days}天',
      permanent: '永久',
      
      // 功能特性
      features: {
        maxConcurrentTasks: '最多同时生成 {count} 个报告',
        maxReportsPerMonth: '每月最多 {count} 份报告',
        unlimitedReports: '不限报告生成数量',
        withWatermark: '报告带水印',
        noWatermark: '报告无水印',
        canDownload: '可下载报告',
        cannotDownload: '不可下载报告',
        knowledgeBase: '知识库总量 {count} 份',
        cannotUseKnowledgeBase: '不可使用知识库',
        filesPerTask: '单任务 {count} 份文件',
        commercialUse: '可商业使用',
        personalUseOnly: '仅个人使用',
        hallucinationOn: '幻觉检测与输出质量优化',
        hallucinationOff: '不含幻觉检测优化',
        intelligenceSubscriptionOn: '靶点情报订阅配置与巡检',
        intelligenceSubscriptionOff: '不含情报订阅',
        intelligenceFeedOn: '靶点情报更新流查看',
        intelligenceFeedOff: '不含情报更新查看',
        reportInteractiveEditOn: '报告在线智能交互编辑',
        reportInteractiveEditOff: '不含在线智能交互编辑',
        selectionQaOn: '报告选中问答与快捷问题',
        selectionQaOff: '不含选中问答',
        selectionRegenerateOn: '报告选中内容智能改写',
        selectionRegenerateOff: '不含选中改写',
        selectionAddToMapOn: '报告选中内容添加至知识地图',
        selectionAddToMapOff: '不含选中添加至地图',
        knowledgeMapLlmWikiOn: '知识地图 LLM Wiki 与知识图谱（整理/研讨/体检/自愈/双链拓扑）',
        knowledgeMapLlmWikiOff: '不含 LLM Wiki 与知识图谱（脑图/大纲不受影响）',
        websearchOn: '商用搜索（Tavily）',
        websearchOff: '不含商用搜索（默认 SearXNG）'
      },
      
      // 优先级
      priority: {
        low: '低优先级',
        normal: '标准优先级',
        high: '高优先级',
        vip: 'VIP优先级'
      }
    },
    
    // 订阅历史
    history: {
      title: '订阅历史',
      viewAll: '查看全部',
      membershipTier: '会员等级',
      subscriptionType: '订阅类型',
      startTime: '开始时间',
      endTime: '到期时间',
      status: '状态',
      actions: '操作',
      cancelSubscription: '取消订阅',
      
      // 状态
      statusActive: '活跃',
      statusExpired: '已过期',
      statusCancelled: '已取消'
    },
    
    // 购买对话框
    purchaseDialog: {
      upgradeTitle: '升级会员',
      purchaseTitle: '购买会员',
      tierSummary: '会员等级',
      subscriptionType: '订阅类型',
      monthlyOption: '月度订阅 - ¥{price}',
      yearlyOption: '年度订阅 - ¥{price}',
      firstPurchaseTip: '（首充优惠，原价¥{originalPrice}）',
      paymentMethod: '支付方式',
      amountDue: '应付金额',
      monthlyGrant: '每月赠送',
      cancel: '取消',
      confirmUpgrade: '确认升级',
      payNow: '立即支付',
      
      // 升级价格明细
      upgradeDetails: {
        title: '会员升级价格明细',
        calculating: '正在计算升级价格...',
        calculatingTip: '正在为您计算最优升级价格，请稍候...',
        originalPrice: '目标套餐原价：',
        remainingValue: '当前会员剩余价值：',
        remainingDays: '（剩余{days}天）',
        actualPayment: '实际需支付：',
        formula: '计算公式',
        
        // 重要提示
        importantNotice: '重要提示',
        upgradeMethod: '升级方式：立即升级（剩余价值抵扣）',
        paymentAmount: '支付 ¥{price}，立即获得 {duration} {tier} 会员',
        remainingWillExpire: '您当前会员剩余 {days}天 的权益将 立即作废',
        valueDeductedTip: '剩余价值已抵扣升级费用，这是获得优惠价格的方式',
        thirtyDays: '30天',
        threeSixtyDays: '360天',
        
        // 错误状态
        loadFailed: '升级价格获取失败',
        loadFailedMessage: '无法获取升级价格信息，请刷新页面重试或联系客服'
      },
      
      // 正常购买价格
      priceSummary: {
        totalAmount: '应付金额：',
        monthlyGrant: '每月赠送：'
      }
    },
    
    // 确认对话框
    confirmations: {
      upgradeTitle: '确认升级',
      upgradeMessage: '您当前会员还剩余 {days} 天，升级后这些剩余天数的权益将立即作废。\n\n升级费用：¥{price}\n获得权益：{duration} {tier} 会员\n\n确认要继续升级吗？',
      confirmUpgrade: '确认升级',
      cancel: '取消',
      
      cancelSubscriptionTitle: '确认取消订阅',
      cancelSubscriptionMessage: '确定要取消订阅吗？'
    },
    
    // 消息提示
    messages: {
      loadTiersFailed: '加载会员等级失败',
      autoRenewEnabled: '已开启自动续费',
      autoRenewDisabled: '已关闭自动续费',
      subscriptionCancelled: '订阅已取消',
      cancelSubscriptionFailed: '取消订阅失败',
      renewalInDevelopment: '续费功能开发中',
      upgradePriceLoadFailed: '升级价格加载失败',
      calculateUpgradePriceFailed: '计算升级价格失败：{error}',
      unknownError: '未知错误',
      getUpgradeOptionsFailed: '获取升级选项失败'
    },
    // 升级相关对话框
    upgrade: {
      // 升级错误对话框
      errorDialog: {
        defaultTitle: '会员升级提示',
        remainingDays: '您当前会员还剩余 {days} 天',
        suggestions: '建议'
      },
      // 跨等级升级确认对话框
      crossTierConfirm: {
        title: '会员升级确认',
        upgradeInfo: '升级详情',
        upgradeFee: '升级费用',
        feeCalculationV74: '（剩余{days}天价值已抵扣）',
        membershipDuration: '会员时长',
        durationFixed: '固定30天',
        durationLoss: '（将损失{days}天）',
        xcoinNote: 'X-Coin说明',
        xcoinDiffOnly: '仅补差额 +{diff}',
        totalXcoin: 'X-Coin总计',
        totalXcoinValue: '升级后保持原有X-Coin余额',
        formulaV74: '升级费用 = 新套餐价格 - 剩余天数折算价值',
        formulaExampleV74: '例如：Pro月度¥399 - 剩余{days}天折算 = 实付价格',
        importantNotice: '重要提示',
        notices: [
          '立即切换到 Pro 权益，使用更强的 AI 能力',
          '保留您当前 Plus 月度套餐中的 X-Coin',
          '仅补发差额 X-Coin，避免重复发放',
          '升级后 X-Coin 总量与直接购买一致',
          '原 Plus 月度剩余 {days} 天将失效，并获得固定 30 天 Pro 月度会员'
        ],
        betterChoice: '更优选择',
        betterChoiceContent: '如果您需要更长时间的会员权益，建议选择<strong>Pro年度订阅（¥{price}）</strong>，可享受更多优惠。',
        betterChoiceReasons: [
          '每月赠送更多 X-Coin',
          '年度订阅更划算，月均价格更低',
          '立即获得更长会员有效期，避免时长损失'
        ],
        actions: {
          cancel: '取消',
          chooseProYearly: '选择 Pro 年度',
          confirmUpgrade: '确认升级到 Pro 月度'
        }
      }
    }
  },
  // 支付页面
  payment: {
    // 页面标题
    rechargeCenter: '充值中心',
    // 标签页
    tabs: {
      membership: '会员订阅',
      monthly: '月度订阅',
      yearly: '年度订阅',
      xcoin: 'X-Coin充值',
      payMonthly: '按月付费',
      payYearly: '按年付费',
      yearlyDiscount: '年付更优惠'
    },
    // 会员订阅
    membership: {
      firstPurchaseBadge: '首充专享折扣',
      monthlyTitle: '{tier}会员月度订阅',
      yearlyTitle: '{tier}会员年度订阅',
      monthlyGrant: '每月赠送{amount}X-Coin',
      defaultDescription: '享受会员专属权益',
      validityDays: '有效期{days}天',
      selectBtn: '立即开通',
      selectedBtn: '已选择',
      recommendedRibbon: '推荐套餐',
      priceUnitMonth: '/ 月',
      priceUnitYear: '/ 年',
      monthlyGrantText: '每月赠送 {amount} X-Coin',
      yearlyGrantText: '每月赠送 {amount} X-Coin',
      grantValidityText: '赠送额度有效期 {days} 天',
      freeGiftText: '注册成功赠送 10,000 X-Coin',
      freeGiftSubText: '有效期 30 天',
      customPriceText: '定制报价',
      customGiftText: '按需配置 X-Coin 额度',
      customGiftSubText: '专属客户成功协助',
      currentPlanBtn: '当前套餐',
      contactUsBtn: '联系我们',
      upgradeNowBtn: '立即升级',
      cardTitles: {
        free: '免费版',
        plus: '进阶版 Plus',
        pro: '专业版 Pro',
        enterprise: '企业版 Enterprise'
      },
      tierDisplayNames: {
        free: 'Free 免费版',
        plus: 'Plus 进阶版',
        pro: 'Pro 专业版',
        enterprise: 'Enterprise 企业版',
        internal: 'Internal 内部用户',
        academic: 'Academic 学术用户'
      },
      featureMatrix: {
        proResearch: '专业调研功能',
        researchAndReport: '调研与报告生成',
        reportWatermark: '报告生成（含水印）',
        reportGeneration: '报告生成',
        reportHallucination: '报告幻觉检测',
        reportRegenerate: '报告重新生成',
        reportEdit: '报告在线编辑',
        reportDownload: '报告下载',
        knowledgeBase: '知识库',
        personalKnowledgeMap: '个性化知识地图',
        priorityQueue: '优先算力队列',
        proAllBenefits: '专业版全部权益',
        teamCollaboration: '团队协作与权限管理',
        enterpriseCustomization: '企业垂域定制开发',
        onPremise: '本地部署',
        priorityService: '专属服务优先体验'
      },
      // 会员等级描述
      tierDescriptions: {
        free: '个人学生/初步体验',
        plus: '个人研究者、硕博研究生',
        pro: '实验室负责人、初创Biotech公司',
        enterprise: '中大型药企、CRO、研究机构',
        internal: 'Xtalpi内部员工专属会员',
        academic: '高校/科研机构学术用户'
      }
    },
    // 支付方式
    paymentMethod: {
      title: '选择支付方式',
      paymentMethodSelected: '支付方式已选择',
      alipay: '支付宝',
      wechat: '微信支付',
      qrCodeAlt: '支付二维码',
      selectPaymentHint: '选择支付方式后生成支付二维码',
      refreshQRCode: '刷新二维码',
      paymentRemaining: '支付剩余时间：{time}',
      scanToPay: '请使用{method}扫码支付'
    },
    // X-Coin充值
    xcoin: {
      selectPackageTitle: '选择套餐',
      hotBadge: '热门',
      recommendedBadge: '推荐',
      baseLabel: '基础',
      bonusLabel: '赠送',
      permanentPeriod: '永久',
      daysUnit: '天',
      enterpriseTitle: '企业定制',
      enterpriseSubtitle: '专属客户经理 · 定制化功能开发 · 7x24技术支持',
      contactService: '联系客服',
      priceLabel: '¥{price}',
      amountLabel: '{amount} X-Coin',
      breakdown: '{base} 基础 + {bonus} 赠送',
      customPlaceholder: '或输入自定义金额',
      customUnit: '元',
      selectAmountHint: '选择充值金额后查看订单详情',
      customRechargeDescription: '自定义充值 - {amount} 元',
      packageNames: {
        xcoin_50: '入门套餐',
        xcoin_99: '实惠套餐',
        xcoin_199: '热门套餐',
        xcoin_399: '超值套餐',
        xcoin_999: '999套餐',
        xcoin_999_1: '999套餐',
        xcoin_2999: '2999套餐',
        xcoin_2999_1: '2999套餐',
        xcoin_custom: '自定义充值'
      },
      orderTypeLabel: '订单类型：',
      amountDueLabel: '应付金额：',
      grantXCoinLabel: '赠送X-Coin：',
      cancelBtn: '取消',
      payNowBtn: '立即支付',
      closeBtn: '关闭',
      businessTypes: {
        // 收入类型
        recharge: '充值',
        member_grant: '会员赠送',
        member_monthly_grant: '月度发放',
        invite_reward: '邀请奖励',
        behavior_reward: '行为奖励',
        refund: '退款',
        monthly_refresh: '月度刷新',
        system_init: '系统初始化',
        // 支出类型
        expire: '过期',
        target_chat: '聊天消费',
        outline_generation: '报告消费',
        target_report: '报告消费',
        quick_qa: '快速模式问答消费',
        quick_brief_generation: '快速模式简报生成消费',
        expert_qa: '专家模式问答消费',
        expert_report_generation: '专家模式报告生成消费',
        writing_qa: '撰写模式问答消费',
        writing_report_generation: '撰写模式报告生成消费',
        consume: '消费',
        target: '靶点分析',
        // 特殊类型
        correction: '数据修正',
        data_fix: '数据修复',
        test_deduct: '测试扣费',
        // 旧版本兼容
        test_charge: '测试扣费',  // 兼容旧值，映射到test_deduct
        report_generation: '报告生成',
        knowledge_base_usage: '知识库使用',
        xcoin_expired: 'X-Coin过期'
      }
    },
    notice: {
      exchangeRule: '¥1 = 100 X-Coin',
      period: '。',
      membership: {
        title: '会员订阅说明：',
        prefix: '用户为功能权益付费，订阅成功后赠送对应额度的 X-Coin；赠送的 X-Coin 有效期为 ',
        validity: '30 天',
        rulePrefix: '。基础兑换规则：'
      },
      xcoin: {
        title: 'X-Coin 充值说明：',
        prefix: '基础兑换规则 ',
        middle: '；充值所得 X-Coin 均为 ',
        permanent: '永久有效',
        suffix: '，可与会员赠送额度叠加使用。档位充值享额外赠送，自定义金额按基础比例兑换、无赠送。'
      },
      // 支付结果通知文案（成功 / 失败）— 替代原硬编码字符串
      paymentResult: {
        period: { monthly: '月付', yearly: '年付' },
        defaultDash: '--',
        success: {
          xcoin: '您已成功购买{packageName}，到账{xcoin}X-Coin（永久有效）。当前账户余额：{balance}。',
          xcoinFallbackPackage: '自定义充值',
          subscribe: '您已成功订阅{period}-{tier}，有效期{startDate}至{endDate}。会员套餐赠送{xcoin}X-Coin（30天有效）已到账。当前账户余额：{balance}。',
          renew: '会员续费成功：{period}-{tier}会员有效期已延长至{endDate}。{xcoin} X-Coin将在下个会员周期发放。当前账户余额：{balance}。',
          upgrade: '您已成功将{fromTier}升级为{toTier}，会员有效期至{endDate}，本次支付{paid}元。',
          deferredGrant: '您已成功订购【{tier}】服务，会员周期 {startDate} - {endDate}，套餐赠送的 {xcoin} X-Coin 将在下个会员周期发放，当前账户余额：{balance} X-Coin。',
          deferredUpgradeGrant: '您已成功升级为【{tier}】服务，会员周期 {startDate} - {endDate}，套餐赠送的 {xcoin} X-Coin 将在下个会员周期发放，当前账户余额：{balance} X-Coin。',
          crossTierUpgradeNoGrant: '您已成功升级为【{tier}】，会员周期 {startDate} - {endDate}，当前账户余额：{balance} X-Coin。'
        },
        failed: {
          template: '抱歉，您购买的{product}支付未成功。若您已被扣款，请先查看账户余额或在个人中心里的反馈页面联系我们。',
          xcoinProduct: '{amount}{packageName}',
          xcoinPackageFallback: '自定义充值套餐',
          upgradeProduct: '{from}升级至{to}',
          subscribeProduct: '{period}{tier}会员'
        }
      }
    },
    deductRules: {
      title: '对话 / 生成扣费逻辑',
      rule1Title: '优先扣减限时 X-Coin',
      rule1Body: '：消费时先使用限时额度，再使用永久额度。',
      rule2Title: '同类型按到期时间',
      rule2Body: '：限时 X-Coin 中，优先扣减剩余有效期最短的批次。',
      rule3Title: '同到期优先扣充值币',
      rule3Body: '：若到期时间相同，优先扣减付费充值获得的 X-Coin，再扣减免费 / 赠送获得的 X-Coin。',
      sourcesTitle: 'X-Coin 来源说明：',
      sourcesText: '① 新用户注册赠送（30 天有效）；② 会员订阅月度 / 年度赠送（30 天有效）；③ 邀请裂变奖励（永久有效）；④ 付费充值（永久有效）。'
    },
    // 会员权益表格
    benefits: {
      title: '会员权益',
      headers: {
        feature: '会员权益',
        free: 'Free用户',
        plus: 'Plus VIP',
        pro: 'Pro VIP',
        enterprise: '企业版VIP'
      },
      features: {
        reportGeneration: '专业报告生成',
        reportGenerationFree: '✓（带水印）',
        reportGenerationPaid: '✓（无水印）',
        reportGenerationEnterprise: '✓',
        concurrentTasks: '同时并发任务',
        concurrentTasksFree: '1个',
        concurrentTasksPlus: '3个',
        concurrentTasksPro: '5个',
        concurrentTasksEnterprise: '根据定制情况而定',
        reportDownload: '生成报告下载',
        priority: '生成优先级',
        priorityFree: '低优先级',
        priorityPlus: '标准优先级',
        priorityPro: '高优先级',
        priorityEnterprise: '企业专属通道',
        modelAccess: '模型访问',
        modelAccessFree: '基础模型',
        modelAccessPlus: 'Plus专属模型',
        modelAccessPro: 'Pro专属模型',
        modelAccessEnterprise: '企业专属模型',
        knowledgeBase: '专属知识库',
        commercialAuth: '商业授权'
      },
      checkMark: '✓',
      crossMark: '✕'
    },
    // 底部
    footer: {
      copyright: 'Copyright © 2025 XtalPi Inc. 粤ICP备17120953号-4'
    },
    // 充值管理页面
    rechargeManagement: {
      title: '充值管理',
      pageDescription: '充值X-Coin，享受更多服务，首次充值还可获得邀请奖励',
      backButton: '返回',
      balanceCard: {
        title: '账户余额',
        rechargeNow: '立即充值',
        currentBalance: '当前余额',
        totalRecharge: '累计充值',
        rechargeCount: '充值次数',
        firstRecharge: '首次充值',
        yuan: '元',
        times: '次'
      },
      recordsCard: {
        title: '充值记录',
        orderNo: '订单编号',
        filterStatus: '筛选状态',
        allRecords: '全部记录',
        paymentSuccess: '支付成功',
        pending: '待支付',
        paymentFailed: '支付失败',
        cancelled: '已取消',
        searchBtn: '查询',
        emptyText: '暂无充值记录',
        rechargeAmount: '充值金额',
        xcoinAmount: '获得X-Coin',
        paymentMethod: '支付方式',
        paymentStatus: '支付状态',
        isFirstRecharge: '首次充值',
        firstRechargeTag: '首充',
        transactionId: '交易号',
        createdAt: '创建时间',
        paymentTime: '支付时间',
        actions: '操作',
        cancelAction: '取消',
        payAction: '支付',
        viewDetails: '详情'
      },
      paymentMethods: {
        alipay: '支付宝',
        wechat: '微信支付',
        manual: '手动充值'
      },
      paymentDialog: {
        title: '支付订单',
        orderInfo: '订单信息',
        orderNo: '订单号',
        rechargeAmount: '充值金额',
        xcoinAmount: 'X-Coin数量',
        paymentMethod: '支付方式',
        qrCodeTitle: '扫码支付',
        scanToPay: '请使用{method}扫码支付',
        countdown: '支付剩余时间',
        cancelPayment: '取消支付',
        refreshStatus: '刷新状态'
      }
    },
    // 提示消息
    messages: {
      paymentSuccess: '支付成功，快去体验吧！',
      paymentSuccessRedirect: '支付成功！正在跳转到知识库...',
      paymentFailed: '支付失败',
      createOrderFailed: '创建订单失败',
      createOrderFailedWithError: '创建订单失败: {error}',
      loadTiersFailed: '加载会员等级失败',
      loadPackagesFailed: '加载充值套餐失败',
      // 套餐相关
      packageDataInvalid: '套餐数据格式错误',
      packagePriceInvalid: '套餐价格信息错误，请刷新后重试',
      // 支付相关
      selectPaymentMethodFirst: '请先选择支付方式',
      scanToPay: '请扫码支付',
      paymentInfoLoadFailed: '未能获取支付信息，请重试',
      loadRechargeRecordsFailed: '获取充值记录失败',
      paymentSuccessMessage: '支付成功！',
      paymentFailed: '支付失败',
      checkPaymentStatusFailed: '检查支付状态失败',
      paymentCancelled: '支付已取消',
      cancelPaymentFailed: '取消支付失败',
      cancelRechargeConfirm: '确定要取消这笔充值订单吗？',
      cancelRechargeTitle: '确认取消',
      rechargeCancelled: '充值订单已取消',
      cancelRechargeFailed: '取消充值失败',
      // 表单验证警告
      selectSubscriptionPeriod: '请选择订阅周期',
      selectRechargePackage: '请选择充值套餐',
      minRechargeAmount: '充值金额不能小于1元',
      selectPaymentMethodWarning: '请选择支付方式',
      // 会员选择警告
      duplicatePurchaseTitle: '不支持重复购买',
      duplicatePurchaseMessage: '您当前是{tier}{type}会员{remaining}{expiry}。\n\n建议您会员到期后再选购同等级会员服务。',
      upgradeProYearlyTitle: '建议升级Pro年度会员',
      upgradeProYearlyMessage: '您当前是Plus年度会员{remaining}{expiry}。\n\n建议升级Pro年度以获取更多权益！',
      upgradeProYearlyBtn: '立即升级Pro年度',
      downgradeTitle: '不支持会员降级',
      downgradeMessage: '您当前是Pro{type}会员{remaining}{expiry}。\n\n为保障您的权益，暂不支持降级购买Plus会员。建议等待Pro会员到期后再选购其他类型会员。',
      yearlyToMonthlyDowngradeTitle: '不支持年度降为月度',
      yearlyToMonthlyDowngradeMessage: '您当前是{tier}年度会员{remaining}{expiry}。\n\n为保障您的权益，暂不支持将年度会员降级为月度会员。建议等待会员到期后再选购月度会员服务。',
      confirmBtn: '我知道了',
      continueBtn: '继续选择',
      cancelBtn: '我再想想',
      remainingDays: '（还剩{days}天）',
      expiryDate: '，到期时间：{date}',
      monthlyType: '月度',
      yearlyType: '年度',
      monthlySubscription: '月度订阅',
      yearlySubscription: '年度订阅',
      // X-Coin发放提示
      xcoinGrantNoticeTitle: 'X-Coin发放说明',
      xcoinGrantNoticeMessage: '升级/续费后会员套餐中赠送的X-Coin将在下个会员周期开始时发放，如您希望快速获取X-Coin可前往选购X-Coin套餐。',
      xcoinGrantNoticeConfirm: '确定购买',
      xcoinGrantNoticeBuyXCoin: '先购买X-Coin'
    },
    // 升级确认对话框
    upgradeDialog: {
      title: '会员升级',
      currentTier: '当前会员等级',
      remainingDays: '会员剩余天数',
      daysCount: '{days} 天',
      upgradeTarget: '升级目标',
      priceDetails: '价格明细',
      originalPrice: '套餐原价',
      remainingValueDiscount: '剩余价值抵扣',
      remainingValueFormula: '剩余价值 = (剩余天数 ÷ 365) × 原价',
      durationExtension: '会员时长延长',
      daysExtension: '+365 天',
      actualPayment: '实际支付金额',
      actualPaymentFormula: '实际支付 = 套餐原价 - 剩余价值抵扣',
      upgradeReward: '升级奖励',
      congratulations: '恭喜您升级至 {tier}！',
      cancel: '取消',
      confirmPayment: '确认支付 ¥{amount}',
      // Plus月度升级Pro月度特别提示
      plusMonthlyToProMonthly: {
        noExtraXCoin: '本次升级不额外赠送X-Coin',
        suggestion: '建议：如需完整Pro权益，可选择Pro年度'
      }
    },
    upgradeLimitDialog: {
      title: '暂不支持再次升级',
      currentPrefix: '您当前为 ',
      currentSuffix: '。',
      rule: '根据会员规则，每个订阅周期内仅支持升级 1 次。您本周期已完成升级，暂无法再次升级会员等级。',
      nextAvailableTime: '下次可升级时间：',
      xcoinPrefix: '若当前 X-Coin 余额不足，您可先 ',
      xcoinRecharge: '单独充值 X-Coin',
      xcoinMiddle: ' 继续使用相关功能。单独充值的 X-Coin ',
      xcoinPermanent: '永久有效，不过期',
      xcoinSuffix: '，可与账户内其他额度叠加使用。',
      confirm: '确定',
      unknownPlan: '当前会员',
      monthlyPlan: '月费会员',
      yearlyPlan: '年费会员'
    }
  },
  
  // 余额警告组件
  balanceWarning: {
    insufficientTitle: '余额不足',
    lowBalanceTitle: '余额预警',
    balanceConfirmTitle: '余额确认',
    currentBalanceLabel: '当前余额:',
    estimatedCostLabel: '预估费用:',
    afterBalanceLabel: '操作后余额:',
    buttons: {
      rechargeNow: '立即充值',
      recharge: '充值',
      viewAccount: '查看账户',
      viewDetails: '查看详情',
      cancel: '取消',
      confirmExecute: '确认执行',
      insufficient: '余额不足'
    },
    messages: {
      rechargePending: '正在前往充值中心',
      lowBalanceWarning: '您的余额使用率已达{percentage}%，建议及时充值。当前剩余: {balance} X-Coin'
    }
  },
  
  // PDF预览组件
  pdfPreview: {
    loading: '正在加载PDF...',
    loadingWithProgress: '正在加载PDF... {progress}%',
    downloadSpeed: '下载速度: {speed}',
    loadFailed: 'PDF加载失败: {error}',
    buttons: {
      retry: '重试',
      clearCache: '清除缓存',
      fullscreen: '全屏'
    },
    title: 'PDF预览',
    messages: {
      cacheCleared: '缓存已清除',
      loadTimeout: 'PDF下载超时，请检查网络连接',
      fileNotFound: 'PDF文件不存在',
      noPermission: '没有权限访问此PDF文件',
      serverError: '服务器内部错误，请稍后重试',
      networkError: '网络连接错误',
      maxRetryReached: '已达到最大重试次数 ({count})',
      invalidFormat: 'PDF文件格式无效或已损坏',
      viewerLoadFailed: 'PDF查看器加载失败',
      fetchFailed: '获取PDF预览失败',
      fetchingPdf: '正在获取PDF文件...',
      validatingPdf: '正在验证PDF文件...',
      initializingViewer: '正在初始化PDF查看器...',
      emptyOrTooSmall: '文件内容为空或过小',
      invalidPdfFormat: '文件不是有效的PDF格式'
    }
  },
  
  // 通知中心组件（补充）
  notificationCenter: {
    downloadReport: '下载报告',
    markAsRead: '标记已读',
    viewDetails: '查看详情',
    viewSubscriptionFeed: '查看订阅更新',
    subscriptionFeedMissingTopic: '未找到关联主题',
    subscriptionFeedMissingTarget: '未找到关联任务',
    upgradeToDownload: '升级会员即可下载报告',
    noDownloadPermission: '当前会员等级暂无下载权限',
    preparing: '正在准备下载{type}...',
    downloadStarted: '{type}下载已开始',
    pdfOpened: 'PDF已在新窗口中打开，请在新窗口中保存文件',
    reportTypes: {
      pdf: 'PDF报告',
      markdown: 'Markdown文件',
      metadata: '元数据文件',
      details: '详细数据'
    },
    messages: {
      markReadSuccess: '已标记为已读',
      markReadFailed: '标记已读失败',
      markAllReadFailed: '标记失败',
      downloadFailed: '下载失败，请稍后重试',
      serverError: '服务器错误，请稍后重试',
      networkError: '网络连接失败，请检查网络后重试',
      permissionError: '没有下载权限，请重新登录'
    }
  },
  
  aiDeliveryBlocked: {
    header: '系统安全审核',
    title: '内容未通过安全审核',
    aiOutputBody: '大模型返回的内容包含不符合平台内容安全规范的表述，该条回复已被拦截，不会展示给您。您可以点击重新生成按钮获取新的回复，或调整提问后再次尝试；',
    userInputBody: '您输入的内容包含不符合平台内容安全规范的表述，消息未被发送至大模型。请修改后重新输入，避免涉及违法违规、人身攻击或其他受限内容；',
    misjudgePrefix: '如认为误判，可通过',
    feedbackLink: '用户反馈',
    misjudgeMiddle: '或通过邮箱',
    misjudgeSuffix: '联系我们；',
    noImpact: '审核仅拦截本次发送，不影响历史对话记录。',
    adminNote: '管理员可在后台查看原始内容与审核记录。',
    regenerate: '重新生成',
    reportAuditTitle: '报告未通过安全审核',
    reportAuditBody: '大模型为您生成的报告包含不符合平台内容安全规范的表述，已自动转交人工审核，预计{deadline}前返回审核结果；',
  },

  // 敏感词检测
  sensitiveWord: {
      auditUnavailable: '审核服务繁忙，请稍后重试',
    blockTitle: '内容审核提示',
    blockMessage: '您好，您提交的内容因涉及不符合平台生成规范的信息，当前无法进行报告生成。请您检查并修改输入内容，避免涉及违法违规、编造虚假信息或过度敏感主题。您可以重新提交任务或联系官方支持（{email}）',
    detectedWordsLabel: '检测到的敏感词',
    supportEmail: "epixora{'@'}xtalpi.com",
    intercepted: '已拦截',
    interceptedMessage: '该消息因包含敏感词已被拦截，仅管理员可见原始内容'
  },

  // 意图澄清卡（快速模式确认简报生成）
  intentClarify: {
    tip: '请确认你的研究意图，以便我为你生成简报：',
    yes: '是',
    no: '否'
  },
  // 快捷命令预设标签（由 utils/quickCommands.js 使用）
  commands: {
    confirm: '确认',
    cancel: '取消',
    add: '增加',
    delete: '删除',
    modify: '修改',
    continue: '继续',
    useOutlineTemplate: '大纲模板'
  },
  // 快捷命令预设发送文本（由 utils/quickCommands.js 使用）
  commandTexts: {
    confirm: '确认',
    cancel: '取消',
    add: '增加',
    delete: '删除',
    modify: '修改',
    continue: '继续'
  }
}
